<template>
  <div class="main-container">
    <div class="PDCcontainer">
      <header
        class="library-page-header library-page-header--conto"
        aria-labelledby="library-page-title-conto"
      >
        <img
          class="library-page-header__icon"
          src="/Titoli pagine/Icona Libreria Codici conto.png"
          alt=""
          aria-hidden="true"
        />
        <div class="library-page-header__copy">
          <div class="library-page-header__title-row">
            <h1
              id="library-page-title-conto"
              class="library-page-header__title"
            >
              Libreria Codici Conto
            </h1>
            <span class="library-scope-badge is-personal">
              <i class="fa-solid fa-user" aria-hidden="true"></i>
              Personale
            </span>
          </div>
          <p class="library-page-header__subtitle">
            Gestisci la tua libreria personale e riutilizza i codici conto nelle
            elaborazioni successive.
          </p>
        </div>
        <img
          class="library-page-header__visual library-page-header__visual--conto"
          src="/Titoli pagine/Immagine Libreria codici conto.png"
          alt=""
          aria-hidden="true"
        />
      </header>
      <section
        class="library-workspace"
        :class="{
          'library-workspace--empty':
            isDataLoaded &&
            !jsonData.length &&
            !hasAnyPdcLibraryFiles &&
            !showAddBilancino &&
            !showAddPiano &&
            !isPdcArchiveView,
        }"
        aria-label="Strumenti e dati della libreria codici conto"
      >
        <div class="dashboarddiv" v-if="isDataLoaded">
          <div class="dashboard" ref="dashboardRef">
            <div class="buttons">
              <button
                class="btninput addRowButton"
                :class="{ 'active-button': currentEditModeActive }"
                :disabled="!currentFileHasVisibleDataRows"
                @click="toggleCurrentEditMode"
              >
                <i class="fa-solid fa-pen-to-square toolicon"></i> Modifica
              </button>
              <button
                class="btninput addRowButton"
                :class="{ 'active-button': showAddRow }"
                @click="openAddRowModal"
                :disabled="!currentAddRowHeaders.length"
              >
                <!-- :disabled="!jsonData.length" -->
                <i class="fa-solid fa-plus toolicon"></i> Aggiungi Riga
              </button>
              <button
                class="btninput addBilancinoButton leggibilancino"
                :class="{ 'active-button': showAddBilancino }"
                :disabled="currentPdcIsClient"
                :title="
                  currentPdcIsClient
                    ? 'La lettura da prospetto aggiorna il Piano dei Conti principale'
                    : 'Leggi Prospetto Paghe'
                "
                @click="
                  showAddBilancino = !showAddBilancino;
                  showAddRow = false;
                  showAddPiano = false;
                "
              >
                <i class="fa-solid fa-file-import toolicon"></i> Leggi Prospetto
                Paghe
                <!-- Menu a tendina per scegliere il software di output -->
              </button>
              <button
                class="btninput addRowButton"
                @click="deleteCurrentLibraryFile($event)"
                :title="currentDeleteButtonTitle"
                :disabled="
                  !currentPdcDeleteHasDataRows || currentDeleteDisabled
                "
              >
                <i class="fa-solid fa-trash cursor toolicon"></i>
                {{ currentDeleteButtonLabel }}
              </button>
              <div class="download-menu">
                <button
                  class="btninput btn-scarica download-menu-trigger"
                  type="button"
                >
                  <i
                    title="Scarica il Piano dei conti"
                    class="fas fa-download download-icon cursor icon"
                  ></i>
                  Scarica
                  <i class="fa-solid fa-chevron-down download-menu-chevron"></i>
                </button>
                <div class="download-menu-dropdown">
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="downloadCurrentLibraryFile"
                    :disabled="!currentFileHasDataRows"
                  >
                    <i class="fas fa-file-excel"></i> File attuale
                  </button>
                  <button
                    class="download-menu-item"
                    type="button"
                    @click="
                      scaricaModello(
                        currentTemplateKey,
                        currentTemplateFilename
                      )
                    "
                  >
                    <i class="fas fa-file-excel"></i> Modello vuoto
                  </button>
                </div>
              </div>
              <button
                class="btninput addBilancinoButton btn-carica"
                :class="{ 'active-button': showAddPiano }"
                @click="openCurrentUploadModal"
                :disabled="!ha(user, 'funzione_carica_piano')"
                :title="
                  !ha(user, 'funzione_carica_piano')
                    ? 'Carica un nuovo Piano dei Conti manualmente - Disponibile da piano Plus'
                    : 'Carica o sostituisci il Piano dei Conti selezionato'
                "
              >
                <i class="fas fa-upload toolicon"></i> Carica Piano
              </button>
              <input
                type="file"
                ref="fileInputMadre"
                class="hidden-file-input"
                accept=".xlsx,.xls,.csv"
                @change="replaceFileMadre"
              />
              <CondivisionePiano
                class="library-share-control"
                ref="condivisionePiano"
                tipoPiano="Piano dei Conti"
                :inviti-ricevuti="invitiRicevuti"
                :inviti-inviati="invitiInviati"
                :shareable-files="pdcShareableFiles"
                :on-refresh-files="fetchFileFromBackend"
                @mostra-excel="apriExcelViewer"
                @refresh-inviti="fetchInviti"
                @success="mostraSuccesso"
                @error="mostraErrore"
                :jsonLength="jsonData.length"
                :auto-open="shouldOpenShareModal"
                :highlighted-invito-id="highlightedShareInvitoId"
                :feature-locked="!ha(user, 'condivisione_pdc_studio')"
                :title="
                  !ha(user, 'condivisione_pdc_studio')
                    ? 'Condividi il tuo Piano dei Conti - Disponibile da piano Plus'
                    : 'Condividi il tuo Piano dei Conti'
                "
              />
              <div
                v-if="false"
                class="archive-menu"
                ref="archiveMenuRef"
                :class="{
                  'archive-menu--open': archiveMenuOpen,
                  disabled: !ha(user, 'archivio_completo_nomi_conto'),
                }"
              >
                <button
                  class="btninput addRowButton archive-menu-trigger"
                  type="button"
                  @click.stop="toggleArchiveMenu"
                  :disabled="!ha(user, 'archivio_completo_nomi_conto')"
                  :title="
                    !ha(user, 'archivio_completo_nomi_conto')
                      ? 'Consulta i tuoi Archivi - Disponibile da piano Plus'
                      : 'Consulta i tuoi Archivi'
                  "
                >
                  <i class="fa-solid fa-folder-open toolicon"></i>
                  Archivi
                  <i class="fa-solid fa-chevron-down archive-chevron"></i>
                </button>
                <div class="archive-menu-dropdown">
                  <button
                    class="archive-menu-item"
                    type="button"
                    @click.stop="openArchiveMadre"
                  >
                    <i class="fa-solid fa-book-open"></i>
                    Archivio Descrizioni Cod. Conto
                  </button>
                </div>
              </div>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: currentFileHasUnsavedChanges }"
                title="Salva modifiche"
                @click="saveCurrentLibraryFile($event)"
                :disabled="!currentFileCanSaveOrCancel"
              >
                <i
                  class="fa-solid fa-floppy-disk savebutton"
                  :class="{ unsaved: currentFileHasUnsavedChanges }"
                >
                </i>
                <span>Salva</span>
              </button>
              <button
                class="btninput addRowButton savebuttondiv"
                :class="{ unsaved: currentFileHasUnsavedChanges }"
                title="Annulla modifiche"
                @click="cancelCurrentLibraryChanges"
                :disabled="!currentFileCanSaveOrCancel"
              >
                <i
                  class="fa-solid fa-xmark cancelbutton"
                  :class="{ unsaved: currentFileHasUnsavedChanges }"
                >
                </i>
                <span>Annulla</span>
              </button>
              <ExcelViewer
                :rows="PianoRows"
                :visible="showPianoModal"
                @close="showPianoModal = false"
              />
            </div>
          </div>
          <div
            v-if="noChangesMessage && jsonData.length > 0"
            class="dashboard-feedback"
          >
            <span class="nochanges-message">Nessuna modifica presente</span>
          </div>
        </div>
        <div
          class="PDC_header empty-plan-card"
          v-if="
            isDataLoaded &&
            !jsonData.length &&
            !hasAnyPdcLibraryFiles &&
            !showAddBilancino &&
            !showAddPiano &&
            !isPdcArchiveView
          "
        >
          <div class="empty-plan-icon" aria-hidden="true">
            <i class="fa-solid fa-table-list"></i>
          </div>
          <div class="empty-plan-body">
            <p class="nessun-piano-header">Crea il tuo Piano dei Conti</p>
            <p class="empty-plan-line">
              Questo file non esiste ancora. Verrà creato e aggiornato
              automaticamente usando il Convertitore Prospetti Paghe.
              <br />
              In alternativa, puoi usare gli strumenti dedicati della libreria,
              caricare un file già compilato o scaricare il modello vuoto.
            </p>
            <div class="empty-plan-actions">
              <router-link
                class="empty-plan-action empty-plan-action--primary convertitore linkstrumentiPDC"
                title="Vai al convertitore"
                to="/home/prospetti-paghe"
              >
                <i class="fa-solid fa-wand-magic-sparkles"></i>
                Usa convertitore
              </router-link>
              <button
                class="empty-plan-action empty-plan-action--secondary"
                type="button"
                @click="
                  scaricaModello(
                    'pdc_prospetti',
                    'MODELLO - Prospetti Paghe - Piano dei Conti.xlsx'
                  )
                "
              >
                <i class="fa-solid fa-file-arrow-down"></i>
                Scarica modello
              </button>
            </div>
          </div>
        </div>
        <div class="skeleton-loader" v-if="!isDataLoaded">
          <div class="skeleton skeleton-title"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-button"></div>
        </div>
        <div
          v-if="showAddBilancino"
          class="container-wrapper-add-bilancino library-reader-workspace library-reader-workspace--prospetti"
        >
          <div class="calcolatrice-add-bilancino">
            <div
              class="div-add-prospetti"
              :class="['div-add-bilancino', isShifted ? 'shift-left' : '']"
            >
              <!-- Titolo principale -->
              <div class="header-add-bilancino">
                <span class="library-reader-title-icon" aria-hidden="true">
                  <img src="/Pagina Home/Prospetti Paghe.png" alt="" />
                </span>
                <h3 class="title-add-bilancino">
                  Leggi <span>PROSPETTO PAGHE</span>
                </h3>
                <p class="library-reader-subtitle">
                  Individua e aggiungi nuovi codici al Piano dei Conti.
                </p>
              </div>
              <button
                type="button"
                class="headerButtons-add-bilancino headerbtn-add-prospetti"
                @click="refreshConversione"
                aria-label="Resetta la lettura del prospetto paghe"
              >
                <i
                  title="Reset del convertitore"
                  class="fa-solid fa-arrows-rotate refresh"
                >
                </i>
              </button>
              <!-- Contenitore degli input -->
              <div
                v-show="expanded"
                class="input-container library-reader-form"
              >
                <label
                  for="bilancinoInput"
                  class="input-label input-label--file"
                >
                  Seleziona file da leggere:
                </label>
                <input
                  id="bilancinoInput"
                  class="file-input-add-bilancino library-reader-file-input"
                  type="file"
                  ref="bilancinoInput"
                  accept=".pdf,.csv,.xls,.xlsx"
                  :disabled="calculating || calculating2 || showResult"
                  @change="handleBilancinoInput"
                />
                <small class="library-reader-formats">
                  Formati supportati: PDF, CSV, XLS, XLSX
                </small>
                <button
                  v-if="filePDF_URL"
                  @click="openPDFPreview"
                  class="btn anteprimapdf"
                >
                  <i class="fa-solid fa-file-pdf" aria-hidden="true"></i>
                  Visualizza PDF
                </button>
                <button
                  v-if="ExcelRows.length && fileType === 'excel'"
                  @click="showExcelModal = true"
                  class="anteprimaexcel anteprimaexcel--excel"
                >
                  <i class="fa-solid fa-file-excel" aria-hidden="true"></i>
                  Visualizza Excel
                </button>

                <button
                  v-if="ExcelRows.length && fileType === 'csv'"
                  @click="showExcelModal = true"
                  class="anteprimaexcel anteprimaexcel--csv"
                >
                  <i class="fa-solid fa-file-csv" aria-hidden="true"></i>
                  Visualizza CSV
                </button>
                <span class="softwaredetected" v-show="input_PC">
                  <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
                  <span class="softwaredetected-label"
                    >Software contabile rilevato</span
                  >
                  <strong class="input_PC">{{ input_PC }}</strong>
                </span>
                <label
                  for="outputSystem"
                  class="input-label input-label--software"
                >
                  Software contabile di conversione:
                </label>
                <select
                  :disabled="calculating || calculating2 || showResult"
                  v-model="output_PC"
                  id="outputSystem"
                  class="select-input-add-bilancino library-reader-select"
                >
                  <option disabled selected value="">Seleziona software</option>
                  <option value="TEAMSYSTEM">TEAMSYSTEM</option>
                  <option value="DATEV">DATEV</option>
                  <option value="ZUCCHETTI">ZUCCHETTI</option>
                  <option value="SEAC">SEAC</option>
                  <option value="SISTEMI">SISTEMI</option>
                  <!-- <option value="SISTEMI">SISTEMI</option> -->
                </select>
                <button
                  :disabled="calculating || calculating2 || showResult"
                  class="action-button"
                  @click="sendBilancino"
                >
                  <span v-if="calculating">
                    <div class="spinner"></div>
                    Elaborazione...
                  </span>
                  <span v-else>
                    <i class="fa-solid fa-play" aria-hidden="true"></i>
                    Avvia scansione
                  </span>
                </button>
              </div>
              <!-- Messaggio di errore PDF incompatibile con sistema di Input contabile -->
              <div v-if="errorMessage" class="error-message-leggi-bilancino">
                <p>{{ errorMessage }}</p>
              </div>
              <div v-if="showDelayedMessage" class="waiting-message">
                <span v-if="!delayedMessageUpdated">
                  MyStudio sta elaborando un file abbastanza lungo. Attendere,
                  per favore 🙂⏳
                </span>
                <span v-else>
                  Sei ancora lì? Non ti preoccupare, manca poco! 🙌⏳
                </span>
                <span class="dot-anim"></span>
              </div>
            </div>
          </div>
          <section
            v-if="!showResult"
            class="library-reader-placeholder"
            aria-label="Area risultato lettura prospetto paghe"
          >
            <div class="library-reader-placeholder__visual" aria-hidden="true">
              <i class="fa-solid fa-file-arrow-up"></i>
              <span><i class="fa-solid fa-table-list"></i></span>
            </div>
            <div class="library-reader-placeholder__copy">
              <h3>Nuovi codici conto</h3>
              <p>
                Carica un prospetto paghe: i codici individuati compariranno qui
                pronti per la verifica e il salvataggio.
              </p>
            </div>
          </section>
          <div
            v-show="showResult"
            :class="[
              'result-container-add-bilancino library-reader-results',
              showResult ? 'show' : '',
            ]"
          >
            <!-- FASE 1 per SEAC -->
            <div v-if="fase1_SEAC" class="fase1-seac">
              <h3 class="clienti-individuati">Clienti individuati</h3>
              <div class="response-message">
                <div
                  class="divclient-table"
                  :class="{ expanded: isTableExpanded }"
                >
                  <table class="client-table">
                    <thead>
                      <i
                        @click="toggleTableExpansion"
                        :class="
                          isTableExpanded
                            ? 'fa-solid fa-compress expand-button-clienti'
                            : 'fa-solid fa-expand expand-button-clienti'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th>Cliente</th>
                        <th>
                          Contabilità Ordinaria
                          <button
                            title="Seleziona l'intera colonna"
                            class="btn-select"
                            @click="selezionaColonna(1)"
                          >
                            ✔
                          </button>
                        </th>
                        <th>
                          Contabilità Semplificata
                          <button
                            disabled
                            title="Seleziona l'intera colonna"
                            class="btn-select"
                            @click="selezionaColonna(2)"
                          >
                            ✔
                          </button>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(cliente, index) in vettoreClienti_SEAC"
                        :key="index"
                      >
                        <td>{{ cliente[1] }}</td>
                        <td>
                          <input
                            type="radio"
                            :name="'scelta-seac-' + index"
                            :value="1"
                            v-model="vettoreClienti_SEAC[index][2]"
                          />
                        </td>
                        <td>
                          <input
                            disabled
                            type="radio"
                            :name="'scelta-seac-' + index"
                            :value="2"
                            v-model="vettoreClienti_SEAC[index][2]"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <button
                  class="btnfase2 btnfase2seac"
                  @click="proseguiFase2_SEAC"
                  :disabled="calculating2"
                >
                  <span v-if="calculating2">
                    <div class="spinner"></div>
                    Elaborazione...
                  </span>
                  <span v-else>Prosegui conversione</span>
                </button>
              </div>
            </div>

            <!-- FASE 2 (esistente) -->
            <div
              v-if="editPDCresponse && !fase1_SEAC"
              class="response-message-add-bilancino conversion-table-surface"
            >
              <h3 class="cod-conto-individuati title-conv">
                CODICI CONTO INDIVIDUATI
              </h3>
              <!-- →→→ Aggiunta: toggle e tabella codici già salvati ←←← -->
              <button
                v-show="vettoreCodContoPDC?.length > 0"
                class="btnPDCvisible"
                :class="{ active: vettorePDCVisible }"
                @click.stop="togglePdcCodeViewDropdown"
              >
                <i :class="currentPdcCodeViewIcon" class="iconbtnPDC"></i>
                <span class="pdc-code-view-label">{{
                  currentPdcCodeViewLabel
                }}</span>
                <span class="pdc-hidden-legacy-label">
                  Codici Conto già salvati
                </span>
                <i
                  :class="
                    pdcCodeViewDropdownOpen
                      ? 'fa-solid fa-chevron-down'
                      : 'fa-solid fa-chevron-right'
                  "
                  class="toggle-icon"
                ></i>
              </button>
              <div
                v-if="pdcCodeViewDropdownOpen && vettoreCodContoPDC?.length > 0"
                class="pdc-code-view-menu"
              >
                <button
                  type="button"
                  :class="{ active: !vettorePDCVisible }"
                  @click="selectPdcCodeView(false)"
                >
                  <i class="fa-solid fa-list"></i>
                  Nuovi codici
                </button>
                <button
                  type="button"
                  :class="{ active: vettorePDCVisible }"
                  @click="selectPdcCodeView(true)"
                >
                  <i class="fa-solid fa-book"></i>
                  Codici salvati
                </button>
              </div>
              <div v-if="hasPdcClientGroups" class="pdc-client-view-controls">
                <button
                  type="button"
                  class="pdc-client-view-trigger"
                  :class="{ active: pdcClientDropdownOpen }"
                  @click.stop="togglePdcClientViewDropdown"
                >
                  <i class="fa-solid fa-users"></i>
                  <span>{{ currentPdcClientSelectionLabel }}</span>
                  <i
                    :class="
                      pdcClientDropdownOpen
                        ? 'fa-solid fa-chevron-up'
                        : 'fa-solid fa-chevron-down'
                    "
                  ></i>
                </button>
                <div v-if="pdcClientDropdownOpen" class="pdc-client-view-menu">
                  <button
                    type="button"
                    :class="{ active: pdcClientTableMode === 'all' }"
                    @click="selectAllPdcClientRows"
                  >
                    Tutti
                  </button>
                  <button
                    v-for="client in pdcClientTableOptions"
                    :key="client.key"
                    type="button"
                    :class="{
                      active:
                        pdcClientTableMode === 'client' &&
                        selectedPdcClientKey === client.key,
                    }"
                    @click="selectPdcClientRows(client.key)"
                  >
                    {{ client.label }}
                  </button>
                </div>
              </div>

              <div
                class="divPCTtable"
                :class="{ 'table-hidden': !vettorePDCVisible }"
              >
                <div
                  v-show="
                    currentCodContoPdcRows?.length > 0 && vettorePDCVisible
                  "
                  class="cod_conto_table_divPCT"
                  :class="{ expanded: isTablePDCExpanded }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotablePCT-datev'
                        : 'codcontotablePCT'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTablePDCExpansion"
                        :class="
                          isTablePDCExpanded
                            ? 'fa-solid fa-compress expand-buttoncodconto'
                            : 'fa-solid fa-expand expand-buttoncodconto'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          <div class="headerscodconto">{{ header }}</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in currentCodContoPdcRows"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumnsPDC"
                          :key="colIndex"
                          :class="{
                            'datev-column':
                              filteredHeaders[colIndex] ===
                                'Cod. Conto - Datev Aziende' ||
                              filteredHeaders[colIndex] ===
                                'Cod. Conto - Datev Lib. Prof.',
                            'italic-text':
                              hasNessunaCorrelazione(
                                currentCodContoPdcRows[rowIndex][col]
                              ) ||
                              isNessuno(currentCodContoPdcRows[rowIndex][col]),
                            'pdc-client-custom-cell':
                              isPdcClientPdcCellDifferentFromGlobal(
                                rowIndex,
                                col
                              ),
                          }"
                        >
                          <template v-if="isEditableColumnPDC(col)">
                            <input
                              v-model="currentCodContoPdcRows[rowIndex][col]"
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    currentCodContoPdcRows[rowIndex][col]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    currentCodContoPdcRows[rowIndex][col]
                                  ),
                                'prospetti-cell-input--pdc-custom':
                                  isPdcClientPdcCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  ),
                              }"
                              :placeholder="
                                isDescrizioneCodContoColumn(
                                  filteredHeaders[colIndex]
                                )
                                  ? 'Inserisci Descrizione Codice Conto'
                                  : ''
                              "
                              @input="
                                handlePdcCellInput(rowIndex, colIndex, true)
                              "
                              @keydown="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  col,
                                  colIndex,
                                  currentCodContoPdcRows
                                )
                              "
                              @paste="blockPaste($event)"
                              @focus="$event.target.select()"
                            />
                          </template>
                          <template v-else>
                            {{
                              currentCodContoPdcRows[rowIndex][col] === "None"
                                ? ""
                                : currentCodContoPdcRows[rowIndex][col]
                            }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Bottone modifica solo per i codici già salvati -->
                <button
                  v-if="currentCodContoPdcRows?.length > 0 && vettorePDCVisible"
                  class="edit-buttonPDC"
                  :class="{ 'active-editbuttonPDC': isEditModePDC }"
                  @click="toggleEditModePDC"
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Modifica Codici Conto già salvati - Disponibile da piano Plus'
                      : 'Modifica Codici Conto già salvati'
                  "
                >
                  <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                  <span class="edit-button-text">Modifica</span>
                </button>
              </div>
              <div v-if="!vettorePDCVisible">
                <div
                  v-if="currentCodContoRows.length > 0"
                  class="cod_conto_table_div"
                  :class="{ expanded: isTableExpanded }"
                >
                  <table
                    :class="
                      output_PC === 'DATEV'
                        ? 'codcontotable-add-bilancino-datev'
                        : 'codcontotable-add-bilancino'
                    "
                  >
                    <thead>
                      <i
                        @click="toggleTableExpansion"
                        :class="
                          isTableExpanded
                            ? 'fa-solid fa-compress expand-buttoncodconto'
                            : 'fa-solid fa-expand expand-buttoncodconto'
                        "
                        title="Espandi / Comprimi Tabella"
                      ></i>
                      <tr>
                        <th class="headerIndici"></th>
                        <th
                          v-for="(header, index) in filteredHeaders"
                          :key="index"
                          :class="{
                            'datev-column':
                              header === 'Aziende' ||
                              header === 'Liberi Professionisti',
                          }"
                        >
                          {{ header }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(row, rowIndex) in currentCodContoRows"
                        :key="rowIndex"
                      >
                        <td class="row-number-cell">{{ rowIndex + 1 }}</td>
                        <td
                          v-for="(col, colIndex) in validColumns"
                          :key="colIndex"
                          :class="{
                            'datev-column':
                              filteredHeaders[colIndex] ===
                                'Cod. Conto - Datev Aziende' ||
                              filteredHeaders[colIndex] ===
                                'Cod. Conto - Datev Lib. Prof.',
                            'italic-text': hasNessunaCorrelazione(
                              currentCodContoRows[rowIndex][col]
                            ),
                            'pdc-client-custom-cell':
                              isPdcClientCellDifferentFromGlobal(rowIndex, col),
                          }"
                        >
                          <template v-if="isEditableColumn(col)">
                            <input
                              v-model="currentCodContoRows[rowIndex][col]"
                              type="text"
                              class="editable-input"
                              :class="{
                                'italic-text':
                                  isNessuno(
                                    currentCodContoRows[rowIndex][col]
                                  ) ||
                                  hasNessunaCorrelazione(
                                    currentCodContoRows[rowIndex][col]
                                  ),
                                'prospetti-cell-input--pdc-custom':
                                  isPdcClientCellDifferentFromGlobal(
                                    rowIndex,
                                    col
                                  ),
                              }"
                              @input="
                                handlePdcCellInput(rowIndex, colIndex, false)
                              "
                              @keydown="
                                blockLetters(
                                  $event,
                                  rowIndex,
                                  col,
                                  colIndex,
                                  currentCodContoRows
                                )
                              "
                              @paste="blockPaste($event, colIndex)"
                            />
                          </template>
                          <template v-else>
                            {{
                              currentCodContoRows[rowIndex][col] === "None"
                                ? ""
                                : currentCodContoRows[rowIndex][col]
                            }}
                          </template>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-else class="success-container">
                  <svg
                    class="checkcodicicontoIcon"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <p class="checkcodiciconto">
                    Tutti i codici conto individuati nel Prospetto Paghe sono
                    già presenti nel tuo
                    <span class="scrittapiano">Piano dei Conti</span>
                  </p>
                </div>
                <button
                  v-if="currentCodContoRows.length > 0"
                  key="edit-btn"
                  class="edit-button"
                  :class="{ 'active-editbutton': isEditMode }"
                  @click="toggleEditMode"
                  :disabled="!ha(user, 'modifica_descrizione_nomi_conto')"
                  :title="
                    !ha(user, 'modifica_descrizione_nomi_conto')
                      ? 'Personalizza Descrizioni contabili - Disponibile da piano Plus'
                      : 'Personalizza Descrizioni contabili'
                  "
                >
                  <i class="fa-regular fa-pen-to-square edit-button-icon"></i>
                  <span class="edit-button-text">Modifica</span>
                </button>
                <div v-if="showResult" class="addrowbuttons-add-bilancino">
                  <button
                    v-if="vettoreCodConto.length > 0"
                    :disabled="calculating2"
                    class="addcodconto action-button"
                    @click="addRowsInPDC"
                  >
                    <span v-if="calculating2">
                      <div class="spinner"></div>
                      Elaborazione...
                    </span>
                    <span v-else>Aggiungi righe e salva</span>
                  </button>
                  <button
                    v-if="vettoreCodConto.length > 0"
                    class="annullaAddRow"
                    @click="refreshAddBilancino"
                  >
                    Annulla
                  </button>
                  <button v-else @click="refreshAddBilancino" class="finebtn">
                    Fine
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddRowModal
          :visible="showAddRow"
          :title="currentAddRowTitle"
          :row="newRow"
          :base-fields="currentAddRowBaseFields"
          :software-options="currentAddRowSoftwareOptions"
          :software-fields="currentAddRowSoftwareFields"
          :selected-softwares="selectedAddRowSoftwares"
          @update:selected-softwares="updateSelectedAddRowSoftwares"
          @field-input="handleAddRowFieldInput"
          @submit="addRow"
          @close="refreshAddRow"
        />
        <div v-if="false && showAddRow" class="add-row-form">
          <table id="addRowTable">
            <tr>
              <th
                class="addrowheaders"
                v-for="(header, index) in jsonData[0]"
                :key="index"
                :title="getTooltip(header)"
              >
                {{ getHeaderText(header) }}
                <span class="info-icon" v-if="showTooltipIcon(header)">
                  <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
                  <span class="tooltip">{{ getTooltip(header) }}</span>
                </span>
              </th>
            </tr>
            <tr>
              <td v-for="(header, index) in jsonData[0]" :key="index">
                <!-- Campo "Descrizione Codice Conto" (nessun controllo specifico, ma obbligatorio) -->
                <input
                  v-if="index === 0 || index === 1"
                  v-model="newRow[index]"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                />

                <!-- Input unificato per Codici Conto da index 1 a 6 (TeamSystem, Datev, Datev Lib. Prof., Zucchetti, SEAC, Sistemi) -->
                <input
                  v-if="index >= 2 && index <= 7"
                  v-model="newRow[index]"
                  @input="formatCodiceConto($event, index)"
                  :placeholder="getPlaceholder(index)"
                  :title="getErrorMessage(index)"
                />
              </td>
            </tr>
          </table>
          <div class="addrowbuttons">
            <button class="addcodconto" @click="addRow">Aggiungi Riga</button>
            <button class="annullaAddRow" @click="refreshAddRow()">
              Annulla
            </button>
          </div>
        </div>
        <UploadFileModal
          :visible="showAddPiano"
          :title="currentPdcUploadTitle"
          icon-class="fa-solid fa-table-list"
          :input-id="currentPdcUploadInputId"
          file-label="Seleziona file Excel"
          accept=".xlsx,.xls,.csv"
          :warning-text="currentPdcUploadWarningText"
          submit-label="Carica e salva"
          :uploading="uploading"
          :error-message="errorMessage"
          :show-preview="rows.length > 0"
          @file-selected="handleFileUpload"
          @preview="showExcelPiano = true"
          @submit="uploadFile"
          @close="closeUploadPianoModal"
        >
          <template #extra-fields>
            <div class="upload-scope-panel">
              <label class="upload-scope-title"
                >Dove vuoi caricare il file?</label
              >
              <div class="upload-scope-options">
                <label class="upload-scope-option">
                  <input v-model="uploadPdcScope" type="radio" value="main" />
                  <span>File principale</span>
                </label>
                <label class="upload-scope-option">
                  <input
                    v-model="uploadPdcScope"
                    type="radio"
                    value="existing_client"
                  />
                  <span>Cliente esistente</span>
                </label>
                <label class="upload-scope-option">
                  <input
                    v-model="uploadPdcScope"
                    type="radio"
                    value="new_client"
                  />
                  <span>Nuovo cliente</span>
                </label>
              </div>

              <div
                v-if="uploadPdcScope === 'existing_client'"
                class="form-group"
              >
                <label>Cliente</label>
                <select
                  v-model="selectedUploadClientKey"
                  class="upload-client-select"
                  :disabled="loadingUploadClients"
                >
                  <option value="">Seleziona cliente</option>
                  <option
                    v-for="cliente in uploadClientOptions"
                    :key="cliente.key"
                    :value="cliente.key"
                  >
                    {{ cliente.label }}
                  </option>
                </select>
                <small v-if="uploadPdcErrors.client" class="field-error">
                  {{ uploadPdcErrors.client }}
                </small>
              </div>

              <div
                v-if="uploadPdcScope === 'new_client'"
                class="upload-new-client-grid"
              >
                <div class="form-group">
                  <label>Denominazione Cliente</label>
                  <input
                    v-model.trim="uploadNewClient.titolo_cliente"
                    type="text"
                    class="upload-client-input"
                    placeholder="Mario Rossi SRL"
                  />
                  <small
                    v-if="uploadPdcErrors.titolo_cliente"
                    class="field-error"
                  >
                    {{ uploadPdcErrors.titolo_cliente }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Codice Fiscale</label>
                  <input
                    v-model.trim="uploadNewClient.codice_fiscale"
                    type="text"
                    class="upload-client-input"
                    maxlength="16"
                    placeholder="RSSMRA..."
                    @input="formatUploadClientFiscalCode"
                  />
                  <small
                    v-if="uploadPdcErrors.codice_fiscale"
                    class="field-error"
                  >
                    {{ uploadPdcErrors.codice_fiscale }}
                  </small>
                </div>
                <div class="form-group">
                  <label>Codice Ditta</label>
                  <input
                    v-model.trim="uploadNewClient.codice_ditta"
                    type="text"
                    class="upload-client-input"
                    maxlength="20"
                    placeholder="Opzionale"
                  />
                </div>
              </div>
            </div>
          </template>
        </UploadFileModal>
        <!-- Menu per caricare il piano -->
        <div
          v-if="false && showAddPiano"
          class="menu-invia-piano menu-invia-PDC"
        >
          <label for="fileInput" class="input-label titleaddpiano">
            Carica PIANO DEI CONTI
          </label>
          <div class="label-container">
            <!-- Input file -->
            <input
              id="fileInput"
              class="file-input-add-piano"
              type="file"
              ref="fileInput"
              @change="handleFileUpload"
              accept=".xlsx, .xls"
            />
            <button
              v-if="rows.length"
              @click="showExcelPiano = true"
              class="anteprimaexcel piano"
            >
              Visualizza Excel
            </button>
            <span class="info-piano">
              <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
              <span class="tooltip-piano">
                Assicurati di inserire un Piano dei Conti del formato corretto.
                <br />
                Il Piano attuale verrà sostituito con il Piano dei Conti
                caricato.
              </span>
            </span>
          </div>
          <!-- Pulsante di invio -->
          <button
            @click="uploadFile"
            title="Carica il file selezionato"
            class="btn-invia"
            :disabled="!selectedPiano || uploading"
          >
            <span v-if="uploading">
              <div class="spinner"></div>
              Caricamento...
            </span>
            <span v-else>Carica e salva</span>
          </button>
          <div v-if="errorMessage" class="error-message-leggi-piano">
            <p>{{ errorMessage }}</p>
          </div>
        </div>
        <div class="table-wrapper">
          <div v-if="showPdcLibraryControls" class="table-meta-row">
            <div v-if="isDataLoaded" class="library-control-row">
              <div v-if="false" class="library-active-summary">
                <span class="library-active-eyebrow">File attivo</span>
                <strong>{{ activePdcFileLabel }}</strong>
                <span class="library-active-details">
                  {{ activePdcScopeLabel }}
                  <template v-if="!isPdcArchiveView">
                    <span class="library-active-dot">·</span>
                    {{ activePdcSoftwareLabel }}
                  </template>
                </span>
              </div>
              <div
                class="library-active-controls"
                :class="{
                  'has-datev-causale':
                    hasActivePdcLibrarySelection &&
                    !isPdcArchiveView &&
                    selectedSoftware === 'DATEV',
                }"
              >
                <div class="library-file-menu" ref="pdcLibraryMenuRef">
                  <button
                    type="button"
                    class="library-file-trigger"
                    :class="{
                      active: pdcLibraryMenuOpen,
                      'is-client-file': currentPdcIsClient,
                    }"
                    :title="`${activePdcFileLabel} - ${activePdcScopeLabel}`"
                    @click.stop="togglePdcLibraryMenu"
                  >
                    <span class="library-file-trigger-label">
                      <i
                        :class="[
                          activePdcFileIcon,
                          'library-file-trigger-book',
                        ]"
                        aria-hidden="true"
                      ></i>
                      <span>{{ activePdcFileLabel }}</span>
                    </span>
                    <i
                      :class="
                        pdcLibraryMenuOpen
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                    ></i>
                  </button>
                  <span
                    v-if="currentPdcIsClient"
                    class="library-file-trigger-scope"
                    :title="`Cliente: ${activePdcScopeLabel}`"
                  >
                    <span class="library-file-trigger-scope-prefix"
                      >Cliente:</span
                    >
                    <span>{{ activePdcScopeLabel }}</span>
                  </span>
                  <div v-if="pdcLibraryMenuOpen" class="library-file-dropdown">
                    <span class="library-file-section-title">Principale</span>
                    <button
                      v-for="option in pdcLibraryBaseOptions"
                      :key="option.key"
                      type="button"
                      class="library-file-option"
                      :class="{
                        active: isPdcLibraryEntryActive(option),
                        'is-empty':
                          option.status && option.status.kind === 'empty',
                        'is-missing':
                          option.status && option.status.kind === 'missing',
                      }"
                      @click="selectPdcLibraryEntry(option)"
                      :disabled="option.disabled"
                    >
                      <span class="library-file-option-body">
                        <i
                          :class="option.icon"
                          class="library-file-option-file-icon"
                          aria-hidden="true"
                        ></i>
                        <span class="library-file-option-text">
                          <strong>{{ option.label }}</strong>
                          <small>
                            {{ option.meta }}
                            <em
                              v-if="option.status"
                              class="library-file-status"
                              :class="`library-file-status--${option.status.kind}`"
                            >
                              {{ option.status.label }}
                            </em>
                          </small>
                        </span>
                      </span>
                      <i
                        v-if="isPdcLibraryEntryActive(option)"
                        class="fa-solid fa-check library-file-option-check"
                      ></i>
                    </button>
                    <template v-if="pdcLibraryClientGroups.length">
                      <span class="library-file-section-title">
                        Personalizzati
                      </span>
                      <div
                        v-for="client in pdcLibraryClientGroups"
                        :key="client.key"
                        class="library-file-client-group"
                      >
                        <div class="library-file-client-heading">
                          <i class="fa-solid fa-star" aria-hidden="true"></i>
                          <span>{{ client.label }}</span>
                        </div>
                        <div class="library-file-client-actions">
                          <button
                            v-for="option in client.options"
                            :key="option.key"
                            type="button"
                            class="library-file-client-action"
                            :class="{
                              active: isPdcLibraryEntryActive(option),
                              'is-empty':
                                option.status && option.status.kind === 'empty',
                              'is-missing':
                                option.status &&
                                option.status.kind === 'missing',
                            }"
                            :disabled="option.disabled"
                            @click="selectPdcLibraryEntry(option)"
                          >
                            <i :class="option.icon" aria-hidden="true"></i>
                            <span>{{ option.shortLabel }}</span>
                            <em
                              v-if="option.status"
                              class="library-file-status library-file-status--compact"
                              :class="`library-file-status--${option.status.kind}`"
                            >
                              {{ option.status.label }}
                            </em>
                          </button>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div v-if="false" class="library-view-path">
                  <div class="pdc-view-selector pdc-file-view-selector">
                    <select
                      v-model="selectedPdcFileKey"
                      @change="handlePdcFileChange"
                      aria-label="Sezione del piano visualizzata"
                    >
                      <option
                        v-for="option in pdcFileOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                  <span class="library-view-path-separator">›</span>
                  <div
                    class="pdc-view-selector pdc-view-selector--owner"
                    ref="pdcViewSelectorRef"
                  >
                    <select
                      v-model="selectedPdcViewKey"
                      @change="handlePdcViewChange"
                      :disabled="loadingClientPdcPlans"
                    >
                      <option
                        v-for="option in pdcViewOptions"
                        :key="option.value"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  v-if="hasActivePdcLibrarySelection"
                  class="software-context-group"
                >
                  <select
                    v-model="selectedSoftware"
                    id="softwareSelectPdc"
                    ref="softwareSelectPdc"
                  >
                    <option
                      v-for="option in softwareOptions"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                <div
                  v-if="hasActivePdcLibrarySelection"
                  class="search-input-wrap"
                >
                  <i class="fa-brands fa-sistrix search-icon"></i>
                  <input
                    v-model.trim="tableSearchTerm"
                    type="text"
                    class="search-input-pdc"
                    :placeholder="
                      isPdcArchiveView
                        ? 'Cerca nell Archivio'
                        : 'Cerca nel Piano'
                    "
                  />
                </div>
                <div
                  v-if="!isPdcArchiveView && selectedSoftware === 'DATEV'"
                  class="causale-library-cluster"
                >
                  <button
                    type="button"
                    class="causale-library-trigger"
                    :class="{
                      active: editingCausaleProspetti,
                    }"
                    @click="
                      editingCausaleProspetti
                        ? cancelEditCausaleProspetti()
                        : startEditCausaleProspetti()
                    "
                  >
                    <span class="causale-library-trigger-label">
                      <span class="causale-library-trigger-label-text">
                        Causale prospetti paghe
                      </span>
                      <span class="info-icon">
                        <i
                          class="fa-solid fa-circle-info"
                          aria-hidden="true"
                        ></i>
                        <span class="tooltip">
                          Valore usato nel CSV DATEV per importazione diretta
                          dei Prospetti Paghe.
                        </span>
                      </span>
                    </span>
                    <strong class="causale-library-trigger-value">
                      {{ causaleProspettiPaghe || "Da impostare" }}
                    </strong>
                    <i
                      :class="
                        editingCausaleProspetti
                          ? 'fa-solid fa-chevron-up'
                          : 'fa-solid fa-chevron-down'
                      "
                      aria-hidden="true"
                    ></i>
                  </button>
                  <div
                    v-if="editingCausaleProspetti"
                    class="causale-library-panel"
                  >
                    <label class="causale-library-panel-label">
                      Valore causale
                    </label>
                    <div class="causale-library-panel-row">
                      <input
                        v-model.trim="causaleProspettiDraft"
                        class="causale-library-input"
                        type="text"
                        maxlength="4"
                        placeholder="C05"
                        @input="handleCausaleProspettiInput"
                      />
                      <button
                        class="causale-library-button"
                        type="button"
                        :disabled="savingCausaleProspetti"
                        @click="saveCausaleProspetti"
                      >
                        <i class="fa-solid fa-floppy-disk"></i>
                        Salva
                      </button>
                      <button
                        class="causale-library-button causale-library-button--ghost"
                        type="button"
                        @click="cancelEditCausaleProspetti"
                      >
                        Annulla
                      </button>
                    </div>
                    <span class="causale-library-panel-hint">
                      Massimo 4 caratteri alfanumerici.
                    </span>
                    <span
                      v-if="causaleProspettiError"
                      class="causale-library-error"
                    >
                      {{ causaleProspettiError }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="currentFileHasRows" class="ultimamodifica">
              <span class="ultimamodificatext">
                Ultima modifica: {{ lastModified }}
              </span>
            </div>
          </div>
          <div
            v-if="needsPdcLibrarySelection"
            class="library-selection-empty-state"
          >
            <i class="fa-solid fa-folder-open" aria-hidden="true"></i>
            <p>Seleziona un file per visualizzarlo</p>
          </div>
          <table
            v-if="!isPdcArchiveView && hasActivePdcLibrarySelection"
            id="excelTable"
            :key="tableKey"
            ref="exceltableRef"
            :class="{
              editing: isEditing,
              'focused-software-table': isFocusedSoftwareView,
              'focused-software-table--double':
                isFocusedSoftwareView && visibleColumns.length > 1,
              'has-empty-body':
                jsonData.length === 1 ||
                (tableSearchTerm && filteredDisplayRows.length === 1),
            }"
          >
            <tr
              class="riga"
              :class="[
                'riga',
                {
                  'row-deleting': deletedRows[displayRow.originalIndex],
                  'highlight-row':
                    !deletedRows[displayRow.originalIndex] &&
                    (hoveredRow === displayRow.originalIndex ||
                      hoveredRow === 'all') &&
                    displayRow.originalIndex !== 0,
                  'provisional-row':
                    !deletedRows[displayRow.originalIndex] &&
                    provisionalRows.includes(displayRow.originalIndex),
                },
              ]"
              v-for="displayRow in filteredDisplayRows"
              :key="displayRow.originalIndex"
            >
              <th v-if="displayRow.originalIndex === 0" class="row-index"></th>
              <td v-else class="row-index">{{ displayRow.originalIndex }}</td>
              <template v-for="(cell, colIndex) in displayRow.row">
                <th
                  v-if="
                    displayRow.originalIndex === 0 &&
                    isMainTableColumnVisible(colIndex)
                  "
                  :key="colIndex"
                  :data-row-index="displayRow.originalIndex"
                  :data-col-index="colIndex"
                  @dblclick="toggleEditing"
                >
                  {{ cell }}
                </th>
                <td
                  v-else-if="
                    displayRow.originalIndex !== 0 &&
                    isMainTableColumnVisible(colIndex)
                  "
                  :contenteditable="
                    isEditing && isEditableColumntable(colIndex)
                  "
                  @dblclick="toggleEditing"
                  @input="
                    updateCell(
                      displayRow.originalIndex,
                      colIndex,
                      $event.target.textContent
                    )
                  "
                  :key="colIndex"
                  :data-row-index="displayRow.originalIndex"
                  :data-col-index="colIndex"
                  :class="{
                    'highlight-cell': isCellModified(
                      displayRow.originalIndex,
                      colIndex
                    ),
                    'modified-cell':
                      modifiedCells[
                        `${displayRow.originalIndex}-${colIndex}`
                      ] && !errors[`${displayRow.originalIndex}-${colIndex}`],
                    'error-cell':
                      errors[`${displayRow.originalIndex}-${colIndex}`],
                    'has-hidden-description':
                      colIndex === 1 && displayRow.row[1] !== displayRow.row[0],
                    'italic-none': cell === 'N.A.',
                  }"
                >
                  {{ cell }}
                  <span
                    v-if="
                      colIndex === 1 && displayRow.row[1] !== displayRow.row[0]
                    "
                    class="custom-description-action"
                    contenteditable="false"
                    @mouseenter="
                      showTooltip(
                        displayRow.originalIndex,
                        colIndex,
                        displayRow.row
                      )
                    "
                    @mouseleave="hideTooltip"
                  >
                    <span class="info-icon-hidden">
                      <i class="fa-solid fa-user-pen"></i>
                    </span>
                    <div
                      v-if="
                        tooltip.visible &&
                        tooltip.rowIndex === displayRow.originalIndex &&
                        colIndex === 1
                      "
                      class="description-original-tooltip"
                    >
                      <span class="description-original-tooltip-label">
                        Descrizione associata a
                      </span>
                      <span class="desc-originale">{{ tooltip.content }}</span>
                      <button
                        type="button"
                        class="restore-original-description-button"
                        @mousedown.prevent.stop
                        @click.prevent.stop="
                          restoreOriginalDescription(displayRow.originalIndex)
                        "
                      >
                        <i
                          class="fa-solid fa-rotate-left"
                          aria-hidden="true"
                        ></i>
                        Ripristina originale
                      </button>
                    </div>
                  </span>
                </td>
              </template>
              <td
                v-if="
                  isEditing && hasDataRows && displayRow.originalIndex === 0
                "
                class="delete-column"
              ></td>
              <td
                v-if="
                  isEditing && hasDataRows && displayRow.originalIndex !== 0
                "
                class="delete-column"
              >
                <button
                  v-if="isEditing"
                  title="Elimina riga"
                  class="delete-button"
                  :class="{ active: activeDelete[displayRow.originalIndex] }"
                  @click="deleteRow(displayRow.originalIndex, $event)"
                  @mouseenter="hoveredRow = displayRow.originalIndex"
                  @mouseleave="hoveredRow = null"
                >
                  <i class="fa-solid fa-trash" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </table>
          <div
            v-if="!isPdcArchiveView && pdcMainTableIsEmpty"
            class="table-empty-message"
          >
            <p>Nessun codice conto presente</p>
          </div>
          <div
            v-else-if="
              !isPdcArchiveView &&
              tableSearchTerm &&
              filteredDisplayRows.length === 1
            "
            class="table-empty-message"
          >
            <p>Nessun risultato per il filtro inserito</p>
          </div>
          <div
            v-if="isPdcArchiveView && hasActivePdcLibrarySelection"
            class="inline-archive-wrapper"
          >
            <div v-if="archiveMadreMissing" class="archive-missing-notice">
              <p>
                Questo archivio non esiste ancora. Si popolera automaticamente
                con le conversioni. In alternativa, puoi caricare un file gia
                compilato oppure
                <button
                  class="archive-missing-inline-action"
                  type="button"
                  @click="
                    scaricaModello(
                      'archivio_codconto',
                      'MODELLO - Prospetti Paghe - Archivio Descrizioni Conti.xlsx'
                    )
                  "
                >
                  scaricare il modello vuoto
                </button>
                .
              </p>
            </div>
            <table
              v-else
              id="madrePDCTable"
              ref="madreTableRef"
              :class="{
                editing: isEditingMadre,
                'hide-software-column': allSoftwareSame,
              }"
              :key="madreTableKey"
            >
              <tr
                class="riga"
                v-for="row in filteredMadreDisplayRows"
                :key="row.originalIndex"
                :class="[
                  {
                    'header-rowmadre': row.originalIndex === 0,
                    'row-deletingmadre': deletedMadreRows[row.originalIndex],
                    'highlight-rowmadre':
                      !deletedMadreRows[row.originalIndex] &&
                      hoveredMadreRow === row.originalIndex &&
                      row.originalIndex !== 0,
                  },
                ]"
              >
                <th v-if="row.originalIndex === 0" class="row-index"></th>
                <td v-else class="row-index">{{ row.originalIndex }}</td>
                <template v-for="(cell, colIndex) in row.row">
                  <th
                    v-if="row.originalIndex === 0"
                    :key="'inline-header-' + colIndex"
                    @dblclick="toggleEditingMadre"
                  >
                    {{ cell }}
                  </th>
                  <td
                    v-if="row.originalIndex !== 0"
                    :key="'inline-cell-' + colIndex"
                    :contenteditable="isEditingMadre && colIndex !== 0"
                    @dblclick="toggleEditingMadre"
                    @input="
                      updateCellMadre(
                        row.originalIndex,
                        colIndex,
                        $event.target.textContent
                      )
                    "
                    :class="{
                      'modified-cell':
                        isEditingMadre &&
                        isCellModifiedMadre(row.originalIndex, colIndex),
                      'madre-descrizione': colIndex === 1,
                    }"
                  >
                    {{ cell ?? "" }}
                  </td>
                </template>
                <td
                  v-if="isEditingMadre && row.originalIndex === 0"
                  class="delete-column"
                ></td>
                <td
                  v-if="isEditingMadre && row.originalIndex !== 0"
                  class="delete-column"
                >
                  <button
                    title="Elimina riga"
                    class="delete-button"
                    :class="{ active: activeDeleteMadre[row.originalIndex] }"
                    @click="deleteMadreRow(row.originalIndex, $event)"
                    @mouseenter="hoveredMadreRow = row.originalIndex"
                    @mouseleave="hoveredMadreRow = null"
                  >
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </td>
              </tr>
            </table>
            <div
              v-if="
                !archiveMadreMissing &&
                !tableSearchTerm &&
                filteredMadreDisplayRows.length === 1
              "
              class="table-empty-message"
            >
              <p>Nessuna descrizione codice conto presente</p>
            </div>
            <div
              v-else-if="
                !archiveMadreMissing &&
                tableSearchTerm &&
                filteredMadreDisplayRows.length === 1
              "
              class="table-empty-message"
            >
              <p>Nessun risultato per il filtro inserito</p>
            </div>
          </div>
          <!-- Modal di conferma per l'eliminazione -->
          <LibraryDeleteModal
            v-if="confirmModalConfirmClass === 'btn-danger'"
            :visible="confirmModalVisibile"
            title="Elimina file dalla libreria"
            :message="confirmModalMessaggio"
            :options="confirmModalDeleteOptions"
            :selected-options="deleteLibraryTargets"
            :confirm-label="confirmModalConfirmLabel"
            :cancel-label="confirmModalCancelLabel"
            :confirm-disabled="
              confirmModalDeleteOptions.length > 0 &&
              !confirmModalDeleteHasSelection
            "
            @toggle-option="
              $set(deleteLibraryTargets, $event.key, $event.checked)
            "
            @cancel="confirmModalCallback && confirmModalCallback(false)"
            @confirm="confirmModalCallback && confirmModalCallback(true)"
          />
          <div v-else-if="confirmModalVisibile" class="modal">
            <div class="modal-content">
              <h2>{{ confirmModalTitle }}</h2>
              <p class="deletemessage">{{ confirmModalMessaggio }}</p>
              <div
                v-if="confirmModalDeleteOptions.length"
                class="delete-archive-options"
              >
                <label
                  v-for="option in confirmModalDeleteOptions"
                  :key="option.key"
                  class="delete-archive-checkbox"
                >
                  <input
                    v-model="deleteLibraryTargets[option.key]"
                    type="checkbox"
                  />
                  {{ option.label }}
                </label>
              </div>
              <button
                @click="confirmModalCallback(false)"
                class="btn-modal btn-secondary"
              >
                {{ confirmModalCancelLabel }}
              </button>
              <button
                @click="confirmModalCallback(true)"
                class="btn-modal"
                :class="confirmModalConfirmClass"
                :disabled="
                  confirmModalDeleteOptions.length > 0 &&
                  !confirmModalDeleteHasSelection
                "
              >
                <i
                  v-if="confirmModalConfirmIcon"
                  :class="confirmModalConfirmIcon"
                  aria-hidden="true"
                ></i>
                {{ confirmModalConfirmLabel }}
              </button>
            </div>
          </div>
          <!-- Modal for Madre PDC -->
          <div v-if="madreModalVisible" class="modal-madre">
            <div class="modal-content-madre">
              <i
                class="fa-solid fa-xmark chiudiPDCmadre"
                @click="attemptCloseMadreModal"
              ></i>
              <h2 class="titlePDCmadre">Archivio Descrizioni Cod. Conto</h2>

              <div class="table-container">
                <!-- Dashboard -->
                <div class="dashboardmadre">
                  <div class="buttons" ref="dashboardRefMadre">
                    <!-- MODIFICA -->
                    <button
                      class="btninput"
                      :class="{ 'active-button': isEditingMadre }"
                      :disabled="madreJsonData.length <= 1"
                      @click="toggleEditingMadre"
                    >
                      <i class="fa-solid fa-pen-to-square toolicon"></i>
                      Modifica
                    </button>

                    <button
                      class="btninput addRowButton"
                      :class="{ 'active-button': showAddRow }"
                      :disabled="!currentAddRowHeaders.length"
                      @click="openAddRowModal"
                    >
                      <i class="fa-solid fa-plus toolicon"></i>
                      Aggiungi Riga
                    </button>

                    <!-- SCARICA -->
                    <div class="download-menu">
                      <button
                        class="btninput download-menu-trigger"
                        type="button"
                      >
                        <i class="fas fa-download toolicon"></i> Scarica
                        <i
                          class="fa-solid fa-chevron-down download-menu-chevron"
                        ></i>
                      </button>
                      <div class="download-menu-dropdown">
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="downloadPDCMadre"
                          :disabled="madreJsonData.length <= 1"
                        >
                          <i class="fas fa-file-excel"></i> File attuale
                        </button>
                        <button
                          class="download-menu-item"
                          type="button"
                          @click="
                            scaricaModello(
                              'archivio_codconto',
                              'MODELLO - Prospetti Paghe - Archivio Descrizioni Conti.xlsx'
                            )
                          "
                        >
                          <i class="fas fa-file-excel"></i> Modello vuoto
                        </button>
                      </div>
                    </div>

                    <!-- SOSTITUISCI -->
                    <button
                      class="btninput"
                      :class="{ uploadingPDCMadre: uploadingMadre }"
                      @click="openUploadPianoModal"
                      :disabled="uploadingMadre"
                    >
                      <i class="fas fa-upload toolicon"></i>
                      {{ uploadingMadre ? "Elaborazione..." : "Carica File" }}
                    </button>

                    <!-- ELIMINA -->
                    <button
                      class="btninput danger"
                      @click="deleteFile"
                      :disabled="madreJsonData.length <= 1 || uploadingMadre"
                    >
                      <i class="fas fa-trash toolicon"></i> Elimina
                    </button>

                    <!-- SALVA -->
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChangesMadre }"
                      @click="saveChangesMadre"
                      :disabled="
                        !hasUnsavedChangesMadre ||
                        uploadingMadre ||
                        !madreJsonData.length
                      "
                    >
                      <i
                        class="fa-solid fa-floppy-disk savebutton"
                        :class="{ unsaved: hasUnsavedChangesMadre }"
                      ></i>
                      <span>Salva</span>
                    </button>

                    <!-- ANNULLA -->
                    <button
                      class="btninput addRowButton savebuttondiv"
                      :class="{ unsaved: hasUnsavedChangesMadre }"
                      @click="cancelChangesMadre"
                      :disabled="
                        !hasUnsavedChangesMadre || !madreJsonData.length
                      "
                    >
                      <i
                        class="fa-solid fa-xmark cancelbutton"
                        :class="{ unsaved: hasUnsavedChangesMadre }"
                      ></i>
                      <span>Annulla</span>
                    </button>

                    <!-- Input nascosto -->
                    <input
                      type="file"
                      ref="fileInputMadre"
                      class="hidden-file-input"
                      accept=".xlsx,.xls,.csv"
                      @change="replaceFileMadre"
                    />
                  </div>
                </div>

                <div v-if="archiveMadreMissing" class="archive-missing-notice">
                  <p>
                    Questo archivio non esiste ancora. Si popolerà
                    automaticamente con le conversioni. In alternativa, puoi
                    caricare un file già compilato oppure
                    <button
                      class="archive-missing-inline-action"
                      type="button"
                      @click="
                        scaricaModello(
                          'archivio_codconto',
                          'MODELLO - Prospetti Paghe - Archivio Descrizioni Conti.xlsx'
                        )
                      "
                    >
                      scaricare il modello vuoto
                    </button>
                    .
                  </p>
                </div>

                <!-- Tabella Archivio Descrizioni Cod. Conto -->
                <table
                  v-if="!archiveMadreMissing"
                  id="madrePDCTable"
                  ref="madreTableRef"
                  :class="{
                    editing: isEditingMadre,
                    'hide-software-column': allSoftwareSame,
                  }"
                  :key="madreTableKey"
                >
                  <tr
                    class="riga"
                    v-for="(row, rowIndex) in madreJsonData"
                    :key="rowIndex"
                    :class="[
                      {
                        'header-rowmadre': rowIndex === 0, // opzionale
                        'row-deletingmadre': deletedMadreRows[rowIndex],
                        'highlight-rowmadre':
                          !deletedMadreRows[rowIndex] &&
                          hoveredMadreRow === rowIndex &&
                          rowIndex !== 0,
                      },
                    ]"
                  >
                    <!-- Numero riga -->
                    <th v-if="rowIndex === 0" class="row-index"></th>
                    <td v-else class="row-index">{{ rowIndex }}</td>

                    <!-- Celle -->
                    <template v-for="(cell, colIndex) in row">
                      <!-- Intestazione (prima riga) -->
                      <th
                        v-if="rowIndex === 0"
                        :key="'header-' + colIndex"
                        @dblclick="toggleEditingMadre"
                      >
                        {{ cell }}
                      </th>

                      <!-- Celle dati (righe successive) -->
                      <td
                        v-if="rowIndex !== 0"
                        :key="'cell-' + colIndex"
                        :contenteditable="isEditingMadre && colIndex !== 0"
                        @dblclick="toggleEditingMadre"
                        @input="
                          updateCellMadre(
                            rowIndex,
                            colIndex,
                            $event.target.textContent
                          )
                        "
                        :class="{
                          'modified-cell':
                            isEditingMadre &&
                            isCellModifiedMadre(rowIndex, colIndex),
                          'madre-descrizione': colIndex === 1,
                        }"
                      >
                        {{ cell ?? "" }}
                      </td>
                    </template>

                    <!-- Colonna cestino (solo in editing, come nel tuo esempio) -->
                    <td
                      v-if="isEditingMadre && rowIndex === 0"
                      class="delete-column"
                    ></td>
                    <td
                      v-if="isEditingMadre && rowIndex !== 0"
                      class="delete-column"
                    >
                      <button
                        title="Elimina riga"
                        class="delete-button"
                        :class="{ active: activeDeleteMadre?.[rowIndex] }"
                        @click="deleteMadreRow(rowIndex, $event)"
                        @mouseenter="hoveredMadreRow = rowIndex"
                        @mouseleave="hoveredMadreRow = null"
                      >
                        <i class="fa-solid fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </table>

                <div
                  v-if="!archiveMadreMissing && madreJsonData.length <= 1"
                  class="noRowsArchivio"
                >
                  <p>Nessuna Descrizione Codice Conto presente nell'archivio</p>
                </div>

                <!-- <div v-if="madreJsonData.length == 1" class="noRowsArchivio">
                <p>Nessun codice conto presente</p>
              </div> -->
              </div>

              <div class="modal-footer">
                <button
                  @click="attemptCloseMadreModal"
                  class="btn-modal-madre btn-secondary-madre"
                >
                  Chiudi
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <PDFViewer
      v-if="showPDF"
      :visible="showPDF"
      :src="filePDF_URL"
      :title="fileTitle"
      @close="showPDF = false"
    />
    <ExcelViewer
      v-if="showExcelModal"
      :rows="ExcelRows"
      :visible="showExcelModal"
      :title="fileTitle"
      @close="showExcelModal = false"
    />
    <ExcelViewer
      :rows="rows"
      :visible="showExcelPiano"
      @close="showExcelPiano = false"
    />
    <SuccessMessage
      :message="successModalMessaggio"
      :isVisible="successModalVisibile"
      @close="onSuccessModalClosed"
    />
    <SimpleErrorModal
      :message="erroreModalMessaggio"
      :isVisible="erroreModalVisibile"
      @close="erroreModalVisibile = false"
    />
    <ConfirmActionModal
      :visible="showScanResetConfirmModal"
      title="Azzerare la scansione?"
      eyebrow="Reset lettore prospetti"
      message="L'operazione in corso verrà abbandonata e l'area di lettura sarà azzerata. Eventuali risultati arrivati dopo il reset saranno ignorati."
      confirm-label="Azzera lettura"
      cancel-label="Annulla"
      icon-class="fa-solid fa-triangle-exclamation"
      confirm-icon-class="fa-solid fa-arrows-rotate"
      @close="showScanResetConfirmModal = false"
      @confirm="confirmScanReset"
    />
    <PageLoadingOverlay
      :visible="isResettingScan"
      title="Reset lettore prospetti"
      message="Pulizia dell'area di lavoro in corso..."
    />
    <ErrorMessageDisplay
      :errors="errorsData"
      :isVisible="showErrorModal"
      @close="showErrorModal = false"
      @fill-na="fillEmptyWithNA"
      @fill-no-corr="fillEmptyWithNoCorr"
      @proceed-warnings="proceedWithWarnings"
    />
    <SalvaModifiche
      :isVisible="showSaveModal"
      :message="'Hai modifiche non salvate. Vuoi salvarle prima di uscire?'"
      @save="handleSaveBeforeLeave"
      @close="cancelLeave"
      @discard="discardChangesAndLeave"
    />
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import axios from "axios";
import { API_BASE_URL } from "@/config.js";
import { downloadBlob, downloadModello } from "@/utils/downloads.js";
import { getUserSettings } from "@/utils/settings.js";
import {
  hasValidSeacClientChoice,
  selectSeacAccountingType,
} from "@/utils/seacClientVector.js";
import { haFunzionalita as ha } from "@/utils/plans.js";
import { isGuestMode } from "@/utils/guestMode";
import SuccessMessage from "../components/SuccessMessage.vue";
import SimpleErrorModal from "../components/SimpleErrorModal.vue";
import ErrorMessageDisplay from "../components/ErrorMessageDisplay.vue";
import SalvaModifiche from "../components/SalvaModifiche.vue";
import CondivisionePiano from "../components/CondivisionePiano.vue";
import PDFViewer from "@/components/PDFViewer.vue";
import ExcelViewer from "@/components/ExcelViewer.vue";
import UploadFileModal from "@/components/UploadFileModal.vue";
import AddRowModal from "@/components/AddRowModal.vue";
import ConfirmActionModal from "@/components/ConfirmActionModal.vue";
import LibraryDeleteModal from "@/components/LibraryDeleteModal.vue";
import PageLoadingOverlay from "@/components/PageLoadingOverlay.vue";

export default {
  name: "LibreriaCodiciConto",
  components: {
    SuccessMessage,
    SimpleErrorModal,
    ErrorMessageDisplay,
    SalvaModifiche,
    CondivisionePiano,
    PDFViewer,
    ExcelViewer,
    UploadFileModal,
    AddRowModal,
    ConfirmActionModal,
    LibraryDeleteModal,
    PageLoadingOverlay,
  },
  data() {
    return {
      utenteSelezionato: "",
      invitiRicevuti: [],
      invitiInviati: [],
      showCondividiModal: false,
      showInvitiDropdown: false,
      messaggio: "",
      jsonData: [],
      tableSearchTerm: "",
      isDataLoaded: false,
      selectedPdcViewKey: "main",
      lastSelectedPdcViewKey: "main",
      selectedPdcFileKey: "pdc",
      lastSelectedPdcFileKey: "pdc",
      clientPdcPlans: [],
      mainPdcLibraryState: {
        has_pdc: false,
        has_archive: false,
        pdc_empty: false,
        archive_empty: false,
      },
      loadingClientPdcPlans: false,
      causaleProspettiPaghe: "",
      causaleProspettiDraft: "",
      causaleProspettiError: "",
      codContoDefault: "11/11/111",
      editingCausaleProspetti: false,
      savingCausaleProspetti: false,
      lastSavedData: [],
      modifiedCells: {},
      lastModified: "",
      tableKey: 0,
      selectedFile: null,
      filePDF_URL: null,
      fileTitle: null,
      showPDF: false,
      bilancinoFile: null,
      rows: [],
      selectedPiano: null,
      uploadPdcScope: "main",
      uploadClienti: [],
      loadingUploadClients: false,
      selectedUploadClientKey: "",
      uploadNewClient: {
        titolo_cliente: "",
        codice_fiscale: "",
        codice_ditta: "",
      },
      uploadPdcErrors: {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      },
      showExcelModal: false,
      showExcelPiano: false,
      PianoRows: [],
      ExcelRows: [],
      fileType: "",
      showPianoModal: false,
      isEditing: false,
      calculating: false,
      calculating2: false,
      uploading: false,
      errorMessage: "",
      isShifted: false,
      isTransitionDone: false, // Diventa true dopo la transizione
      expanded: true,
      showAddRow: false, // Gestisce la visualizzazione del form per aggiungere una riga
      newRow: [], // inizializza con un array vuoto
      provisionalRows: [],
      deletedRows: {}, // Oggetto per tenere traccia delle righe eliminate
      pendingDeletedRowCount: 0,
      activeDelete: {}, // Inizializza un oggetto vuoto per tracciare i pulsanti attivi
      hoveredRow: null, // Salva l'indice della riga in cui si trova il mouse
      vettoreCodConto: [],
      editPDCresponse: false,
      headers: [
        "Descrizione nel Prospetto Paghe Originale", // Index 0
        "Descrizione nel Prospetto Paghe", // Index 1
        "Cod. Conto - TeamSystem", // Index 2
        "Cod. Conto - Datev Aziende", // Index 3
        "Cod. Conto - Datev Lib. Prof.", // Index 4
        "Cod. Conto - Zucchetti", // Index 5
        "Cod. Conto - SEAC", // Index 6
        "Cod. Conto - Sistemi", // Index 7
        "Descrizione Cod. Conto", // Index 8
        "Descrizione Cod. Conto 2", // Index 9
        "DARE", // Index 10
        "AVERE", // Index 11
      ],
      output_PC: "",
      input_PC: "",
      showAddBilancino: false,
      showAddPiano: false,
      selectedSoftware: "ALL",
      softwareOptions: [
        { label: "Tutti", value: "ALL" },
        { label: "TEAMSYSTEM", value: "TEAMSYSTEM" },
        { label: "DATEV", value: "DATEV" },
        { label: "ZUCCHETTI", value: "ZUCCHETTI" },
        { label: "SEAC", value: "SEAC" },
        { label: "SISTEMI", value: "SISTEMI" },
      ],
      selectedSoftwareAddRow: "TEAMSYSTEM",
      selectedAddRowSoftwares: ["TEAMSYSTEM"],
      addRowSoftwareOptions: [
        { label: "TEAMSYSTEM", value: "TEAMSYSTEM" },
        { label: "DATEV", value: "DATEV" },
        { label: "ZUCCHETTI", value: "ZUCCHETTI" },
        { label: "SEAC", value: "SEAC" },
        { label: "SISTEMI", value: "SISTEMI" },
      ],
      showResult: false,
      showDelayedMessage: false,
      delayedMessageUpdated: false,
      delayTimer: null,
      updateTimer: null,
      hasUnsavedChanges: false,
      noChangesMessage: false,
      errors: {},
      successModalVisibile: false,
      successModalMessaggio: "",
      erroreModalVisibile: false,
      erroreModalMessaggio: "",
      showScanResetConfirmModal: false,
      isResettingScan: false,
      pendingScanResetMode: "full",
      activeScanRequestId: 0,
      showErrorModal: false,
      errorsData: [],
      showSaveModal: false,
      nextRoute: null,
      pendingNavigationAfterSuccess: false,
      NumeroClienti: null,
      fase1_SEAC: false,
      vettoreClienti_SEAC: [],
      input_file_path: null,
      isTableExpanded: false,
      confirmModalVisibile: false,
      confirmModalTitle: "Elimina Piano dei Conti",
      confirmModalMessaggio: "",
      confirmModalShowArchiveOption: false,
      confirmModalConfirmLabel: "Elimina",
      confirmModalCancelLabel: "Annulla",
      confirmModalConfirmClass: "btn-danger",
      confirmModalConfirmIcon: "",
      deleteArchiveAlongWithPdc: false,
      confirmModalDeleteOptions: [],
      deleteLibraryTargets: {},
      confirmModalCallback: null,
      restoringFile: false,
      tooltip: {
        visible: false,
        content: "",
        rowIndex: null,
      },
      isEditMode: false,

      // ── Per PDC Madre ────────────────────────────────────────
      madreJsonData: [],
      madreLastSavedData: [], // snapshot semplice per annullare/salvare
      archiveMadreMissing: false,
      isEditingMadre: false,
      hasUnsavedChangesMadre: false, // ← BOOLEANO semplice, NON computed!
      showSaveModalMadre: false,
      modifiedCellsMadre: {}, // opzionale per highlight
      madreModalVisible: false,
      uploadingMadre: false,
      madreTableKey: 0,
      hoveredMadreRow: null, // per hover cestino
      activeDeleteMadre: {}, // per classe active sul cestino
      deletedMadreRows: {},
      pendingDeletedMadreRowCount: 0,
      errorsMadre: {},
      isLeavingDueToMadreChanges: false,
      archiveMenuOpen: false,
      pdcLibraryMenuOpen: false,

      vettoreCodContoPDC: [],
      vettorePDCVisible: false,
      isEditModePDC: false,
      isTablePDCExpanded: false,
      pdcClientGroups: {
        global: [],
        global_pdc: [],
        custom: [],
        custom_pdc: [],
        non_custom: [],
        non_custom_pdc: [],
      },
      clientCustomPdcEntries: {},
      pdcClientTableMode: "all",
      selectedPdcClientKey: "",
      pdcClientDropdownOpen: false,
      pdcCodeViewDropdownOpen: false,
      pdcClientGroupRowIndexesToPersist: {},
      pdcClientCustomRowKeysToRemove: {},
      pdcClientPdcGroupRowIndexesToPersist: {},
      pdcClientPdcCustomRowKeysToRemove: {},
      shareInvitoIdFromEvent: null,
    };
  },
  mounted() {
    this.fetchAccountingDefaults();
    this.fetchClientPdcPlans().finally(() => {
      this.fetchCurrentLibraryFile();
    });
    this.fetchUserCausali();
    if (!this.isGuestMode) {
      this.fetchInviti();
    }
    this.loadUserPreferredSoftware();
    this.$root.$on("open-share-modal", this.handleOpenShareModalEvent);
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    this.$root.$off("open-share-modal", this.handleOpenShareModalEvent);
    document.removeEventListener("click", this.handleClickOutside);
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges) {
      this.isLeavingDueToMadreChanges = false;
      this.showSaveModal = true;
      this.nextRoute = next;
      return;
    }

    if (this.hasUnsavedChangesMadre) {
      this.isLeavingDueToMadreChanges = true;
      this.showSaveModal = true;
      this.nextRoute = next;
      return;
    }

    next();
  },
  watch: {
    showAddBilancino(val) {
      if (val && this.bilancinoFile) {
        this.$nextTick(() => {
          const dt = new DataTransfer();
          dt.items.add(this.bilancinoFile);
          this.$refs.bilancinoInput.files = dt.files;
        });
      }
    },
  },
  computed: {
    isGuestMode() {
      return isGuestMode();
    },
    user() {
      const data = localStorage.getItem("user");
      return data ? JSON.parse(data) : null;
    },
    // Opzionale: evidenzia celle modificate (simile a modifiedCells)
    isCellModifiedMadre() {
      return (row, col) => !!this.modifiedCellsMadre[`${row}-${col}`];
    },

    // Opzionale: se vuoi disabilitare Salva quando ci sono errori (per ora vuoto)
    hasErrorsMadre() {
      return Object.keys(this.errorsMadre).length > 0;
    },
    pdcFileOptions() {
      return [
        {
          label: "Piano dei Conti",
          value: "pdc",
          icon: "fa-solid fa-table-list",
        },
        {
          label: "Archivio Descrizioni",
          value: "archive",
          icon: "fa-solid fa-book",
        },
      ];
    },
    pdcLibraryBaseOptions() {
      return [
        {
          key: "pdc:main",
          fileKey: "pdc",
          viewKey: "main",
          label: "Piano dei Conti",
          meta: "Principale",
          icon: "fa-solid fa-table-list",
          status: this.getPdcLibraryFileStatus("pdc"),
          disabled: !this.mainPdcLibraryState.has_pdc,
        },
        {
          key: "archive:main",
          fileKey: "archive",
          viewKey: "main",
          label: "Archivio Descrizioni",
          meta: "Principale",
          icon: "fa-solid fa-book",
          status: this.getPdcLibraryFileStatus("archive"),
          disabled: !this.mainPdcLibraryState.has_archive,
        },
      ];
    },
    pdcLibraryClientOptions() {
      return this.clientPdcPlans
        .flatMap((client) => {
          const options = [];
          if (client?.has_pdc) {
            options.push({
              key: `pdc:client:${client.key}`,
              fileKey: "pdc",
              viewKey: `client:${client.key}`,
              label: client.label,
              meta: "Piano dei Conti personalizzato",
              status: this.getPdcLibraryFileStatus("pdc", client),
            });
          }
          if (client?.has_archive) {
            options.push({
              key: `archive:client:${client.key}`,
              fileKey: "archive",
              viewKey: `client:${client.key}`,
              label: client.label,
              meta: "Archivio Descrizioni personalizzato",
              status: this.getPdcLibraryFileStatus("archive", client),
            });
          }
          return options;
        })
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    pdcLibraryClientGroups() {
      return this.clientPdcPlans
        .map((client) => {
          const options = [
            {
              key: `pdc:client:${client.key}`,
              fileKey: "pdc",
              viewKey: `client:${client.key}`,
              label: client.label,
              meta: "Piano dei Conti personalizzato",
              shortLabel: "Piano dei Conti",
              icon: "fa-solid fa-table-list",
              status: this.getPdcLibraryFileStatus("pdc", client),
              disabled: !client?.has_pdc,
            },
            {
              key: `archive:client:${client.key}`,
              fileKey: "archive",
              viewKey: `client:${client.key}`,
              label: client.label,
              meta: "Archivio Descrizioni personalizzato",
              shortLabel: "Archivio Descrizioni",
              icon: "fa-solid fa-book",
              status: this.getPdcLibraryFileStatus("archive", client),
              disabled: !client?.has_archive,
            },
          ];
          return {
            key: client?.key || client?.label,
            label: client?.label || "Cliente",
            options,
          };
        })
        .filter((client) => client.options.length > 0)
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    pdcShareableFiles() {
      const files = [];

      if (this.mainPdcLibraryState.has_pdc) {
        files.push({
          key: "main",
          label: "Piano dei Conti",
          shortLabel: "Piano dei Conti",
          meta: "Principale",
          icon: "fa-solid fa-table-list",
          section: "principali",
          status: this.getPdcLibraryFileStatus("pdc"),
        });
      }

      if (this.mainPdcLibraryState.has_archive) {
        files.push({
          key: "archivio_madre",
          label: "Archivio Descrizioni Cod. Conto",
          shortLabel: "Archivio Descrizioni",
          meta: "Principale",
          icon: "fa-solid fa-book",
          section: "principali",
          status: this.getPdcLibraryFileStatus("archive"),
        });
      }

      this.clientPdcPlans.forEach((client) => {
        if (client?.has_pdc) {
          files.push({
            key: `client_pdc:${client.key}`,
            label: `Piano dei Conti - ${client.label}`,
            shortLabel: "Piano dei Conti",
            meta: "Personalizzato",
            icon: "fa-solid fa-table-list",
            section: "personalizzati",
            clientKey: client.key,
            clientLabel: client.label,
            status: this.getPdcLibraryFileStatus("pdc", client),
          });
        }
        if (client?.has_archive) {
          files.push({
            key: `client_archive:${client.key}`,
            label: `Archivio Descrizioni - ${client.label}`,
            shortLabel: "Archivio Descrizioni",
            meta: "Personalizzato",
            icon: "fa-solid fa-book",
            section: "personalizzati",
            clientKey: client.key,
            clientLabel: client.label,
            status: this.getPdcLibraryFileStatus("archive", client),
          });
        }
      });

      return files;
    },
    activePdcFileLabel() {
      if (!this.hasActivePdcLibrarySelection && this.hasAnyPdcLibraryFiles) {
        return "Seleziona file";
      }
      return (
        this.pdcFileOptions.find(
          (option) => option.value === this.selectedPdcFileKey
        )?.label || "File della libreria"
      );
    },
    activePdcFileIcon() {
      if (!this.hasActivePdcLibrarySelection && this.hasAnyPdcLibraryFiles) {
        return "fa-solid fa-folder-open";
      }
      return (
        this.pdcFileOptions.find(
          (option) => option.value === this.selectedPdcFileKey
        )?.icon || "fa-solid fa-table-list"
      );
    },
    activePdcScopeLabel() {
      if (!this.hasActivePdcLibrarySelection && this.hasAnyPdcLibraryFiles) {
        return "Da visualizzare";
      }
      return (
        this.pdcViewOptions.find(
          (option) => option.value === this.selectedPdcViewKey
        )?.label || "Principale"
      );
    },
    activePdcSoftwareLabel() {
      return (
        this.softwareOptions.find(
          (option) => option.value === this.selectedSoftware
        )?.label || this.selectedSoftware
      );
    },
    isPdcArchiveView() {
      return this.selectedPdcFileKey === "archive";
    },
    pdcMainTableIsEmpty() {
      return (
        Array.isArray(this.jsonData) &&
        this.jsonData.length > 0 &&
        !this.hasMeaningfulLibraryRows(this.jsonData)
      );
    },
    madreArchiveTableIsEmpty() {
      return (
        !this.archiveMadreMissing &&
        Array.isArray(this.madreJsonData) &&
        this.madreJsonData.length > 0 &&
        !this.hasMeaningfulMadreArchiveRows(this.madreJsonData)
      );
    },
    currentFileHasRows() {
      if (!this.hasActivePdcLibrarySelection) return false;
      return this.isPdcArchiveView
        ? Array.isArray(this.madreJsonData) && this.madreJsonData.length > 0
        : Array.isArray(this.jsonData) && this.jsonData.length > 0;
    },
    currentFileHasDataRows() {
      return this.isPdcArchiveView
        ? Array.isArray(this.madreJsonData) &&
            this.madreJsonData.length > 1 &&
            !this.archiveMadreMissing
        : this.hasDataRows;
    },
    currentFileHasVisibleDataRows() {
      return this.isPdcArchiveView
        ? !this.archiveMadreMissing && this.filteredMadreDisplayRows.length > 1
        : this.filteredDisplayRows.length > 1;
    },
    currentPdcDeleteHasDataRows() {
      if (!this.hasActivePdcLibrarySelection) {
        return false;
      }
      if (this.currentPdcIsClient) {
        const client = this.clientPdcPlans.find(
          (item) => item?.key === this.selectedClientPdcKey
        );
        return Boolean(client?.has_pdc || client?.has_archive);
      }
      return (
        this.hasDataRows ||
        (Array.isArray(this.madreJsonData) &&
          this.madreJsonData.length > 1 &&
          !this.archiveMadreMissing)
      );
    },
    currentFileHasUnsavedChanges() {
      return this.isPdcArchiveView
        ? this.hasUnsavedChangesMadre
        : this.hasUnsavedChanges;
    },
    currentFileCanSaveOrCancel() {
      return this.isPdcArchiveView
        ? !this.archiveMadreMissing &&
            (this.currentFileHasDataRows ||
              this.hasUnsavedChangesMadre ||
              this.pendingDeletedMadreRowCount > 0)
        : this.currentFileHasRows &&
            (this.currentFileHasDataRows ||
              this.hasUnsavedChanges ||
              this.pendingDeletedRowCount > 0);
    },
    currentEditModeActive() {
      return this.isPdcArchiveView ? this.isEditingMadre : this.isEditing;
    },
    currentDeleteButtonLabel() {
      return this.currentPdcIsClient ? "Elimina file cliente" : "Elimina file";
    },
    currentDeleteButtonTitle() {
      return this.currentPdcIsClient
        ? "Scegli quali file del cliente eliminare"
        : "Scegli quali file principali eliminare";
    },
    currentDeleteDisabled() {
      return false;
    },
    hasAnyPdcLibraryFiles() {
      return (
        this.mainPdcLibraryState.has_pdc ||
        this.mainPdcLibraryState.has_archive ||
        this.clientPdcPlans.some(
          (client) => client?.has_pdc || client?.has_archive
        )
      );
    },
    hasActivePdcLibrarySelection() {
      return this.isPdcLibraryEntryAvailable(
        this.selectedPdcFileKey,
        this.selectedPdcViewKey
      );
    },
    showPdcLibraryControls() {
      return (
        this.isDataLoaded &&
        !this.showAddBilancino &&
        !this.showAddPiano &&
        (this.currentFileHasRows ||
          this.hasAnyPdcLibraryFiles ||
          this.hasActivePdcLibrarySelection)
      );
    },
    needsPdcLibrarySelection() {
      return (
        this.isDataLoaded &&
        !this.showAddBilancino &&
        !this.showAddPiano &&
        this.hasAnyPdcLibraryFiles &&
        !this.hasActivePdcLibrarySelection
      );
    },
    confirmModalDeleteHasSelection() {
      return this.confirmModalDeleteOptions.some(
        (option) => this.deleteLibraryTargets?.[option.key]
      );
    },
    currentTemplateKey() {
      return this.isPdcArchiveView ? "archivio_codconto" : "pdc_prospetti";
    },
    currentTemplateFilename() {
      return this.isPdcArchiveView
        ? "MODELLO - Prospetti Paghe - Archivio Descrizioni Conti.xlsx"
        : "MODELLO - Prospetti Paghe - Piano dei Conti.xlsx";
    },
    currentPdcUploadTitle() {
      if (this.currentPdcIsClient) {
        return this.isPdcArchiveView
          ? "Carica Archivio Descrizioni cliente"
          : "Carica Piano dei Conti cliente";
      }
      return this.isPdcArchiveView
        ? "Carica Archivio Descrizioni Cod. Conto"
        : "Carica Piano dei Conti";
    },
    currentPdcUploadInputId() {
      return this.isPdcArchiveView
        ? "pdcArchiveUploadFileInput"
        : "pdcFileInput";
    },
    currentPdcUploadWarningText() {
      if (this.currentPdcIsClient) {
        return this.isPdcArchiveView
          ? "Assicurati di inserire un Archivio Descrizioni del formato corretto. L'archivio personalizzato del cliente selezionato verra sostituito con il file caricato."
          : "Assicurati di inserire un Piano dei Conti del formato corretto. Il piano personalizzato del cliente selezionato verra sostituito con il file caricato.";
      }
      return this.isPdcArchiveView
        ? "Assicurati di inserire un Archivio Descrizioni Cod. Conto del formato corretto. Il file selezionato verra sostituito con l'archivio caricato."
        : "Assicurati di inserire un Piano dei Conti del formato corretto. Il file selezionato verra sostituito con il Piano dei Conti caricato.";
    },
    currentAddRowTitle() {
      return this.isPdcArchiveView
        ? "Aggiungi riga nell'Archivio Descrizioni Cod. Conto"
        : "Aggiungi riga nel Piano dei Conti";
    },
    currentAddRowHeaders() {
      return this.isPdcArchiveView
        ? this.madreJsonData?.[0] || []
        : this.jsonData?.[0] || [];
    },
    currentAddRowBaseFields() {
      if (!this.isPdcArchiveView) {
        return this.addRowBaseFields;
      }

      const headers = this.currentAddRowHeaders;
      return headers.map((header, index) => ({
        index,
        label: header || `Colonna ${index + 1}`,
        type: index === 0 ? "select" : "text",
        options: index === 0 ? this.addRowSoftwareOptions : undefined,
        placeholder:
          index === 0
            ? "Seleziona software"
            : index === 1
            ? "Descrizione codice conto"
            : "Codice conto",
        title:
          index === 0
            ? "Inserisci il software contabile."
            : index === 1
            ? "Inserisci la descrizione del codice conto."
            : "Inserisci il codice conto.",
        required: index <= 2,
        format: index === 2,
      }));
    },
    currentAddRowSoftwareOptions() {
      return this.isPdcArchiveView ? [] : this.addRowSoftwareOptions;
    },
    currentAddRowSoftwareFields() {
      return this.isPdcArchiveView ? {} : this.addRowSoftwareFields;
    },
    uploadClientOptions() {
      return (this.uploadClienti || [])
        .map((cliente) => ({
          key: cliente.titolo_cliente,
          label: cliente.titolo_cliente,
          codice_fiscale: cliente.codice_fiscale || "",
          codice_ditta: cliente.codice_ditta || "",
        }))
        .filter((cliente) => cliente.key)
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    addRowBaseFields() {
      return [
        {
          index: 0,
          label:
            this.jsonData[0]?.[0] || "Descrizione Cod. Conto da individuare",
          placeholder: this.getPlaceholder(0),
          title: this.getErrorMessage(0),
          required: true,
        },
        {
          index: 1,
          label: this.jsonData[0]?.[1] || "Descrizione Cod. Conto",
          placeholder: this.getPlaceholder(1),
          title: this.getErrorMessage(1),
          required: true,
        },
      ];
    },
    addRowSoftwareFields() {
      const makeField = (index) => ({
        index,
        label: this.jsonData[0]?.[index] || `Colonna ${index + 1}`,
        placeholder: this.getPlaceholder(index),
        title: this.getErrorMessage(index),
        format: true,
      });

      return {
        TEAMSYSTEM: [makeField(2)],
        DATEV: [makeField(3), makeField(4)],
        ZUCCHETTI: [makeField(5)],
        SEAC: [makeField(6)],
        SISTEMI: [makeField(7)],
      };
    },
    allSoftwareSame() {
      // Se non ci sono dati o solo header → consideriamo "uniforme" (nascosta)
      const rows = this.madreDataRowsForSelectedSoftware;
      if (rows.length === 0) return true;

      // Prendiamo il valore della prima riga dati (escludiamo header rowIndex=0)
      const firstValue = (rows[0]?.row?.[0] || "").trim().toUpperCase();

      // Controlla che TUTTE le righe dati abbiano lo stesso valore in colonna 0
      return rows.every(
        ({ row }) => (row[0] || "").trim().toUpperCase() === firstValue
      );
    },
    madreDataRowsForSelectedSoftware() {
      if (
        !Array.isArray(this.madreJsonData) ||
        this.madreJsonData.length <= 1
      ) {
        return [];
      }

      const rows = this.madreJsonData.slice(1).map((row, index) => ({
        row,
        originalIndex: index + 1,
      }));

      if (this.selectedSoftware === "ALL") {
        return rows;
      }

      const selectedSoftware = String(this.selectedSoftware || "")
        .trim()
        .toUpperCase();

      return rows.filter(
        ({ row }) =>
          String(row?.[0] || "")
            .trim()
            .toUpperCase() === selectedSoftware
      );
    },
    filteredMadreDisplayRows() {
      if (
        !Array.isArray(this.madreJsonData) ||
        this.madreJsonData.length === 0
      ) {
        return [];
      }

      const headerRow = {
        row: this.madreJsonData[0],
        originalIndex: 0,
      };

      const term = this.tableSearchTerm.trim().toLowerCase();
      const dataRows = this.madreDataRowsForSelectedSoftware;
      if (!term) {
        return [headerRow, ...dataRows];
      }

      return [
        headerRow,
        ...dataRows.filter(({ row }) =>
          row.some((cell) =>
            String(cell ?? "")
              .toLowerCase()
              .includes(term)
          )
        ),
      ];
    },
    validColumns() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };

      const excluded = this.output_PC
        ? excludedColumnsMap[this.output_PC] || []
        : [];

      const n = this.headers.length;
      const lastTwoIndices = n >= 2 ? [n - 2, n - 1] : [];

      let hideLastTwo = false;

      if (lastTwoIndices.length === 2 && this.vettoreCodConto?.length > 0) {
        hideLastTwo = lastTwoIndices.every((idx) =>
          this.vettoreCodConto.every((row) => {
            const val = row[idx]; // ← accesso diretto per indice (array di array)
            return val == null || val === "" || val === undefined;
          })
        );
      }

      return this.headers
        .map((_, index) => index)
        .filter(
          (index) =>
            !excluded.includes(index) &&
            !(lastTwoIndices.includes(index) && hideLastTwo)
        );
    },
    validColumnsPDC() {
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };

      const excluded = this.output_PC
        ? excludedColumnsMap[this.output_PC] || []
        : [];

      const n = this.headers.length;
      const lastTwoIndices = n >= 2 ? [n - 2, n - 1] : [];

      let hideLastTwo = false;

      if (lastTwoIndices.length === 2 && this.vettoreCodContoPDC?.length > 0) {
        hideLastTwo = lastTwoIndices.every((idx) =>
          this.vettoreCodContoPDC.every((row) => {
            const val = row[idx]; // ← accesso diretto per indice (array di array)
            return val == null || val === "" || val === undefined;
          })
        );
      }

      return this.headers
        .map((_, index) => index)
        .filter(
          (index) =>
            !excluded.includes(index) &&
            !(lastTwoIndices.includes(index) && hideLastTwo)
        );
    },
    filteredHeaders() {
      return this.validColumns.map((index) => {
        const header = this.headers[index];

        // Personalizza solo per DATEV
        if (this.output_PC === "DATEV") {
          if (header === "Cod. Conto - Datev Lib. Prof.")
            return "Cod. Conto - Lib. Prof.";
          if (header === "Descrizione Cod. Conto")
            return "Descrizione Cod. Conto - Datev Aziende";
          if (header === "Descrizione Cod. Conto 2")
            return "Descrizione Cod. Conto - Lib. Prof.";
        }

        return header;
      });
    },
    allPdcClientGroups() {
      return [
        ...(this.pdcClientGroups.non_custom || []),
        ...(this.pdcClientGroups.custom || []),
      ];
    },
    allPdcClientPdcGroups() {
      return [
        ...(this.pdcClientGroups.non_custom_pdc || []),
        ...(this.pdcClientGroups.custom_pdc || []),
      ];
    },
    pdcClientTableOptions() {
      const seen = new Set();
      return [...this.allPdcClientGroups, ...this.allPdcClientPdcGroups]
        .filter((group) => {
          const key = group?.client_key || "";
          if (!key || seen.has(key)) return false;
          seen.add(key);
          return true;
        })
        .map((group) => ({
          key: group.client_key,
          label: this.formatPdcClientLabel(group.client_key),
        }))
        .sort((a, b) => a.label.localeCompare(b.label, "it"));
    },
    hasPdcClientGroups() {
      return this.pdcClientTableOptions.length > 0;
    },
    currentPdcClientSelectionLabel() {
      if (!this.hasPdcClientGroups || this.pdcClientTableMode === "all") {
        return "Tutti";
      }
      return (
        this.pdcClientTableOptions.find(
          (client) => client.key === this.selectedPdcClientKey
        )?.label || "Cliente"
      );
    },
    currentPdcCodeViewLabel() {
      return this.vettorePDCVisible ? "Codici salvati" : "Nuovi codici";
    },
    currentPdcCodeViewIcon() {
      return this.vettorePDCVisible ? "fa-solid fa-book" : "fa-solid fa-list";
    },
    isPdcClientTableView() {
      return (
        this.pdcClientTableMode === "client" &&
        Boolean(this.selectedPdcClientKey)
      );
    },
    selectedPdcClientGroup() {
      if (!this.isPdcClientTableView) return null;
      return (
        this.allPdcClientGroups.find(
          (group) => group.client_key === this.selectedPdcClientKey
        ) || null
      );
    },
    selectedPdcClientPdcGroup() {
      if (!this.isPdcClientTableView) return null;
      return (
        this.allPdcClientPdcGroups.find(
          (group) => group.client_key === this.selectedPdcClientKey
        ) || null
      );
    },
    currentCodContoRows() {
      if (this.isPdcClientTableView) {
        return this.selectedPdcClientGroup?.rows || [];
      }
      return this.vettoreCodConto;
    },
    currentCodContoPdcRows() {
      if (this.isPdcClientTableView) {
        return this.selectedPdcClientPdcGroup?.rows || [];
      }
      return this.vettoreCodContoPDC;
    },
    visibleColumns() {
      const mapping = {
        TEAMSYSTEM: [2],
        DATEV: [3, 4],
        ZUCCHETTI: [5],
        SEAC: [6],
        SISTEMI: [7],
        ALL: [2, 3, 4, 5, 6, 7],
      };

      return mapping[this.selectedSoftware] || mapping.ALL;
    },
    hasDataRows() {
      return Array.isArray(this.jsonData) && this.jsonData.length > 1;
    },
    pdcViewOptions() {
      const requiredFlag = this.isPdcArchiveView ? "has_archive" : "has_pdc";
      return [
        { label: "Principale", value: "main" },
        ...this.clientPdcPlans
          .filter((client) => client?.[requiredFlag])
          .map((client) => ({
            label: client.label,
            value: `client:${client.key}`,
          })),
      ];
    },
    currentPdcIsClient() {
      return String(this.selectedPdcViewKey || "").startsWith("client:");
    },
    selectedClientPdcKey() {
      return this.currentPdcIsClient
        ? String(this.selectedPdcViewKey).slice("client:".length)
        : "";
    },
    selectedClientPdcLabel() {
      const client = this.clientPdcPlans.find(
        (item) => item.key === this.selectedClientPdcKey
      );
      return client?.label || this.selectedClientPdcKey || "";
    },
    isFocusedSoftwareView() {
      return this.selectedSoftware !== "ALL";
    },
    filteredDisplayRows() {
      if (!Array.isArray(this.jsonData) || this.jsonData.length === 0) {
        return [];
      }

      const headerRow = {
        row: this.jsonData[0],
        originalIndex: 0,
      };

      const term = this.tableSearchTerm.trim().toLowerCase();
      if (!term) {
        return [
          headerRow,
          ...this.jsonData.slice(1).map((row, index) => ({
            row,
            originalIndex: index + 1,
          })),
        ];
      }

      const searchableColumns = [0, 1, ...(this.visibleColumns || [])];
      const filteredRows = this.jsonData
        .slice(1)
        .map((row, index) => ({
          row,
          originalIndex: index + 1,
        }))
        .filter(({ row }) =>
          searchableColumns.some((colIndex) =>
            String(row[colIndex] ?? "")
              .toLowerCase()
              .includes(term)
          )
        );

      return [headerRow, ...filteredRows];
    },
    invitiInAttesaCount() {
      return this.invitiRicevuti.filter(
        (i) => i.stato === "in attesa" && i.tipo_piano === "Piano dei conti"
      ).length;
    },
    shouldOpenShareModal() {
      return this.$route.query.openShare === "1";
    },
    highlightedShareInvitoId() {
      return this.shareInvitoIdFromEvent || this.$route.query.invito || null;
    },
  },
  methods: {
    ha,
    normalizeCodContoValue(value) {
      return String(value ?? "")
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "");
    },
    isCodContoDefault(value) {
      return (
        this.codContoDefault &&
        this.normalizeCodContoValue(value) ===
          this.normalizeCodContoValue(this.codContoDefault)
      );
    },
    isCodContoValueColumnName(columnName) {
      const normalized = String(columnName || "").trim();
      return (
        normalized === "Cod. Conto" || normalized.startsWith("Cod. Conto ")
      );
    },
    applyCodContoDefaultFromResponse(data = {}) {
      if (data.codContoDefault) {
        this.codContoDefault = String(data.codContoDefault);
      }
    },
    fetchAccountingDefaults() {
      axios
        .get(`${API_BASE_URL}/accounting_defaults`)
        .then((response) => {
          this.applyCodContoDefaultFromResponse(response.data || {});
        })
        .catch((error) => {
          console.warn("Default contabili non caricati:", error);
        });
    },
    getCodContoDefaultErrorMessage() {
      return `Il codice conto ${this.codContoDefault} e riservato e non puo essere salvato nel Piano dei Conti.`;
    },
    normalizePdcClientRows(rows = []) {
      return (Array.isArray(rows) ? rows : []).map((row) =>
        Array.isArray(row?.row)
          ? row.row.map((cell, index) => {
              if (
                [1, 2, 3, 4, 5, 6].includes(index) &&
                (cell === "None" ||
                  this.isCodContoDefault(cell) ||
                  cell == null)
              ) {
                return null;
              }
              return cell;
            })
          : Array.isArray(row)
          ? row.map((cell, index) => {
              if (
                [1, 2, 3, 4, 5, 6].includes(index) &&
                (cell === "None" ||
                  this.isCodContoDefault(cell) ||
                  cell == null)
              ) {
                return null;
              }
              return cell;
            })
          : row
      );
    },
    normalizePdcClientGroups(groups = []) {
      return (Array.isArray(groups) ? groups : []).map((group) => {
        const rows = this.normalizePdcClientRows(group.rows || []);
        return {
          client_key: String(group.client_key || ""),
          rows,
          row_meta: rows.reduce((acc, row) => {
            const key = this.buildPdcRowKey(row);
            if (key) {
              acc[key] = { key, is_cliente_custom: false };
            }
            return acc;
          }, {}),
        };
      });
    },
    setPdcClientGroups(groupsPayload = {}) {
      this.pdcClientGroups = {
        global: this.normalizePdcClientGroups(groupsPayload.global || []),
        global_pdc: this.normalizePdcClientGroups(
          groupsPayload.global_pdc || []
        ),
        custom: this.normalizePdcClientGroups(groupsPayload.custom || []),
        custom_pdc: this.normalizePdcClientGroups(
          groupsPayload.custom_pdc || []
        ),
        non_custom: this.normalizePdcClientGroups(
          groupsPayload.non_custom || []
        ),
        non_custom_pdc: this.normalizePdcClientGroups(
          groupsPayload.non_custom_pdc || []
        ),
      };
      this.pdcClientGroupRowIndexesToPersist = {};
      this.pdcClientCustomRowKeysToRemove = {};
      this.pdcClientPdcGroupRowIndexesToPersist = {};
      this.pdcClientPdcCustomRowKeysToRemove = {};
      this.ensureSelectedPdcClient();
      if (!this.hasPdcClientGroups) {
        this.pdcClientTableMode = "all";
        this.selectedPdcClientKey = "";
      }
    },
    resetPdcClientState() {
      this.setPdcClientGroups({});
      this.clientCustomPdcEntries = {};
      this.pdcClientTableMode = "all";
      this.selectedPdcClientKey = "";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
    },
    ensureSelectedPdcClient() {
      if (!this.pdcClientTableOptions.length) {
        this.selectedPdcClientKey = "";
        return;
      }
      const exists = this.pdcClientTableOptions.some(
        (client) => client.key === this.selectedPdcClientKey
      );
      if (!exists) {
        this.selectedPdcClientKey = this.pdcClientTableOptions[0].key;
      }
    },
    formatPdcClientLabel(clientKey) {
      return String(clientKey || "").trim() || "Cliente";
    },
    selectAllPdcClientRows() {
      this.pdcClientTableMode = "all";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
    },
    selectPdcClientRows(clientKey) {
      this.selectedPdcClientKey = clientKey;
      this.pdcClientTableMode = "client";
      this.pdcClientDropdownOpen = false;
      this.pdcCodeViewDropdownOpen = false;
    },
    togglePdcCodeViewDropdown() {
      this.pdcCodeViewDropdownOpen = !this.pdcCodeViewDropdownOpen;
      if (this.pdcCodeViewDropdownOpen) {
        this.pdcClientDropdownOpen = false;
      }
    },
    togglePdcClientViewDropdown() {
      this.pdcClientDropdownOpen = !this.pdcClientDropdownOpen;
      if (this.pdcClientDropdownOpen) {
        this.pdcCodeViewDropdownOpen = false;
      }
    },
    selectPdcCodeView(showSaved) {
      this.vettorePDCVisible = showSaved;
      this.pdcCodeViewDropdownOpen = false;
      this.pdcClientDropdownOpen = false;
    },
    closePdcFilterDropdownsOnOutsideClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (
        target.closest(".btnPDCvisible") ||
        target.closest(".pdc-code-view-menu") ||
        target.closest(".pdc-client-view-controls")
      ) {
        return;
      }
      this.pdcCodeViewDropdownOpen = false;
      this.pdcClientDropdownOpen = false;
    },
    isPdcClientPersonalizableColumn(colIndex) {
      return [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(colIndex));
    },
    normalizePdcCellValue(value) {
      if (value === null || value === undefined || value === "None") return "";
      return String(value).trim();
    },
    pdcCellsHaveSameValue(first, second) {
      return (
        this.normalizePdcCellValue(first) === this.normalizePdcCellValue(second)
      );
    },
    buildPdcRowKey(row) {
      if (!Array.isArray(row)) return "";
      return this.normalizePdcCellValue(row[0] || row[1]).toLowerCase();
    },
    findPdcRowIndexByKey(rows = [], rowKey = "") {
      if (!rowKey) return -1;
      return rows.findIndex((row) => this.buildPdcRowKey(row) === rowKey);
    },
    findGlobalPdcClientGroup(clientKey) {
      return (
        (this.pdcClientGroups.global || []).find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    findGlobalPdcClientPdcGroup(clientKey) {
      return (
        (this.pdcClientGroups.global_pdc || []).find(
          (group) => group.client_key === clientKey
        ) || null
      );
    },
    getGlobalPdcClientRow(group, rowIndex) {
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const globalGroup = this.findGlobalPdcClientGroup(group?.client_key);
      const globalIndex = this.findPdcRowIndexByKey(
        globalGroup?.rows || [],
        rowKey
      );
      return globalGroup?.rows?.[globalIndex] || null;
    },
    getGlobalPdcClientPdcRow(group, rowIndex) {
      const row = group?.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const globalGroup = this.findGlobalPdcClientPdcGroup(group?.client_key);
      const globalIndex = this.findPdcRowIndexByKey(
        globalGroup?.rows || [],
        rowKey
      );
      return globalGroup?.rows?.[globalIndex] || null;
    },
    isPdcClientRowDifferentFromGlobal(group, rowIndex) {
      const clientRow = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientRow(group, rowIndex);
      if (!clientRow || !globalRow) return false;
      return [1, 2, 3, 4, 5, 6, 7, 8, 9].some(
        (col) => !this.pdcCellsHaveSameValue(clientRow[col], globalRow[col])
      );
    },
    isPdcClientPdcRowDifferentFromGlobal(group, rowIndex) {
      const clientRow = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientPdcRow(group, rowIndex);
      if (!clientRow || !globalRow) return false;
      return [1, 2, 3, 4, 5, 6, 7, 8, 9].some(
        (col) => !this.pdcCellsHaveSameValue(clientRow[col], globalRow[col])
      );
    },
    isPdcClientCellDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;
      const group = this.selectedPdcClientGroup;
      const row = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientRow(group, rowIndex);
      if (!row || !globalRow) return false;
      return !this.pdcCellsHaveSameValue(row[colIndex], globalRow[colIndex]);
    },
    isPdcClientPdcCellDifferentFromGlobal(rowIndex, colIndex) {
      if (!this.isPdcClientTableView) return false;
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return false;
      const group = this.selectedPdcClientPdcGroup;
      const row = group?.rows?.[rowIndex];
      const globalRow = this.getGlobalPdcClientPdcRow(group, rowIndex);
      if (!row || !globalRow) return false;
      return !this.pdcCellsHaveSameValue(row[colIndex], globalRow[colIndex]);
    },
    setPersistIndex(mapName, clientKey, rowIndex, shouldPersist) {
      const current = this[mapName]?.[clientKey] || [];
      const next = shouldPersist
        ? [...new Set([...current, rowIndex])]
        : current.filter((index) => index !== rowIndex);
      if (next.length) {
        this.$set(this[mapName], clientKey, next);
      } else {
        this.$delete(this[mapName], clientKey);
      }
    },
    setRemovalKey(mapName, clientKey, rowKey, shouldRemove) {
      if (!rowKey) return;
      const current = this[mapName]?.[clientKey] || [];
      const next = shouldRemove
        ? [...new Set([...current, rowKey])]
        : current.filter((key) => key !== rowKey);
      if (next.length) {
        this.$set(this[mapName], clientKey, next);
      } else {
        this.$delete(this[mapName], clientKey);
      }
    },
    syncClientRowCustomState(group, rowIndex, isSaved) {
      if (!group) return;
      const clientKey = group.client_key;
      const row = group.rows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(row);
      const isDifferent = isSaved
        ? this.isPdcClientPdcRowDifferentFromGlobal(group, rowIndex)
        : this.isPdcClientRowDifferentFromGlobal(group, rowIndex);
      this.setPersistIndex(
        isSaved
          ? "pdcClientPdcGroupRowIndexesToPersist"
          : "pdcClientGroupRowIndexesToPersist",
        clientKey,
        rowIndex,
        isDifferent
      );
      this.setRemovalKey(
        isSaved
          ? "pdcClientPdcCustomRowKeysToRemove"
          : "pdcClientCustomRowKeysToRemove",
        clientKey,
        rowKey,
        !isDifferent
      );
    },
    propagatePdcCellToClientGroups(rowIndex, colIndex, isSaved) {
      if (!this.isPdcClientPersonalizableColumn(colIndex)) return;
      const sourceRows = isSaved
        ? this.vettoreCodContoPDC
        : this.vettoreCodConto;
      const sourceRow = sourceRows?.[rowIndex];
      const rowKey = this.buildPdcRowKey(sourceRow);
      if (!rowKey) return;
      const groups = isSaved
        ? this.allPdcClientPdcGroups
        : this.allPdcClientGroups;
      const customCheck = isSaved
        ? this.isPdcClientPdcRowDifferentFromGlobal
        : this.isPdcClientRowDifferentFromGlobal;

      groups.forEach((group) => {
        const clientRowIndex = this.findPdcRowIndexByKey(
          group.rows || [],
          rowKey
        );
        if (clientRowIndex < 0) return;
        if (customCheck.call(this, group, clientRowIndex)) return;
        this.$set(group.rows[clientRowIndex], colIndex, sourceRow[colIndex]);
      });
    },
    handlePdcCellInput(rowIndex, colIndex, isSaved) {
      const col = (isSaved ? this.validColumnsPDC : this.validColumns)[
        colIndex
      ];
      const rows = isSaved
        ? this.currentCodContoPdcRows
        : this.currentCodContoRows;
      this.validateInput(rowIndex, colIndex, rows);
      if (this.isPdcClientTableView) {
        this.syncClientRowCustomState(
          isSaved
            ? this.selectedPdcClientPdcGroup
            : this.selectedPdcClientGroup,
          rowIndex,
          isSaved
        );
        return;
      }
      this.propagatePdcCellToClientGroups(rowIndex, col, isSaved);
    },
    buildPdcClientGroupsPayloadForLibrary() {
      const mapGroups = (groups, indexMap, diffFn) =>
        groups
          .map((group) => ({
            client_key: group.client_key,
            rows: [...new Set(indexMap[group.client_key] || [])]
              .filter((rowIndex) => diffFn.call(this, group, rowIndex))
              .map((rowIndex) => group.rows[rowIndex])
              .filter((row) => Array.isArray(row)),
          }))
          .filter((group) => group.rows.length);

      const custom = mapGroups(
        this.allPdcClientGroups,
        this.pdcClientGroupRowIndexesToPersist,
        this.isPdcClientRowDifferentFromGlobal
      );
      const customPdc = mapGroups(
        this.allPdcClientPdcGroups,
        this.pdcClientPdcGroupRowIndexesToPersist,
        this.isPdcClientPdcRowDifferentFromGlobal
      );
      const removals = [
        ...Object.entries(this.pdcClientCustomRowKeysToRemove || {}),
        ...Object.entries(this.pdcClientPdcCustomRowKeysToRemove || {}),
      ]
        .map(([clientKey, rowKeys]) => ({
          client_key: clientKey,
          row_keys: [...new Set(rowKeys || [])],
        }))
        .filter((group) => group.row_keys.length);

      if (!custom.length && !customPdc.length && !removals.length) {
        return null;
      }
      return {
        custom,
        custom_pdc: customPdc,
        custom_removals: removals,
        non_custom: [],
        non_custom_pdc: [],
      };
    },
    async scaricaModello(tipo, fallbackFileName) {
      try {
        await downloadModello(tipo, fallbackFileName);
        this.successModalMessaggio = "Modello scaricato con successo!";
        this.successModalVisibile = true;
      } catch (err) {
        console.error("Errore download modello:", err);
        this.erroreModalMessaggio =
          err.response?.data?.error ||
          "Errore durante il download del modello.";
        this.erroreModalVisibile = true;
      }
    },
    fetchInviti() {
      if (this.isGuestMode) {
        this.invitiRicevuti = [];
        this.invitiInviati = [];
        return;
      }

      axios
        .get(`${API_BASE_URL}/piano_condiviso/inviti`)
        .then((res) => {
          this.invitiRicevuti = res.data.ricevuti;
          this.invitiInviati = res.data.inviati;
        })
        .catch((err) => {
          console.error("Errore fetch inviti:", err);
          this.invitiRicevuti = [];
          this.invitiInviati = [];
        });
    },
    handleOpenShareModalEvent(payload = {}) {
      if (this.isGuestMode) {
        return;
      }

      if (payload.link && payload.link !== this.$route.path) {
        return;
      }

      this.shareInvitoIdFromEvent = payload.invitoId || null;
      this.$nextTick(() => {
        if (this.$refs.condivisionePiano) {
          this.$refs.condivisionePiano.openModal();
        }
      });
    },
    apriExcelViewer(rows) {
      this.PianoRows = rows;
      this.showPianoModal = true;
    },
    hasMeaningfulLibraryRows(rows) {
      if (!Array.isArray(rows) || rows.length <= 1) {
        return false;
      }

      return rows.slice(1).some((row) => {
        if (Array.isArray(row)) {
          return row.some((cell) => String(cell ?? "").trim() !== "");
        }
        return String(row ?? "").trim() !== "";
      });
    },
    hasMeaningfulMadreArchiveRows(rows) {
      if (!Array.isArray(rows) || rows.length <= 1) {
        return false;
      }

      return rows.slice(1).some((row) => {
        if (!Array.isArray(row)) return false;
        return (
          String(row[1] ?? "").trim() !== "" ||
          String(row[2] ?? "").trim() !== ""
        );
      });
    },
    getPdcLibraryFileStatus(fileKey, client = null) {
      if (client) {
        const exists =
          fileKey === "archive" ? client.has_archive : client.has_pdc;
        if (!exists) {
          return { kind: "missing", label: "Mancante" };
        }

        const empty =
          fileKey === "archive" ? client.archive_empty : client.pdc_empty;
        return empty ? { kind: "empty", label: "Vuoto" } : null;
      }

      if (fileKey === "archive") {
        if (!this.mainPdcLibraryState.has_archive) {
          return { kind: "missing", label: "Mancante" };
        }
        if (this.archiveMadreMissing) {
          return { kind: "missing", label: "Mancante" };
        }
        if (!Array.isArray(this.madreJsonData) || !this.madreJsonData.length) {
          return null;
        }
        return this.hasMeaningfulMadreArchiveRows(this.madreJsonData)
          ? null
          : { kind: "empty", label: "Vuoto" };
      }

      if (!this.mainPdcLibraryState.has_pdc) {
        return { kind: "missing", label: "Mancante" };
      }
      if (!Array.isArray(this.jsonData) || !this.jsonData.length) {
        return null;
      }
      return this.hasMeaningfulLibraryRows(this.jsonData)
        ? null
        : { kind: "empty", label: "Vuoto" };
    },
    normalizeMainPdcLibraryState(raw = {}) {
      return {
        has_pdc: Boolean(raw?.has_pdc),
        has_archive: Boolean(raw?.has_archive),
        pdc_empty: Boolean(raw?.pdc_empty),
        archive_empty: Boolean(raw?.archive_empty),
      };
    },
    findClientPdcPlan(clientKey) {
      return this.clientPdcPlans.find((client) => client?.key === clientKey);
    },
    isPdcLibraryEntryAvailable(fileKey, viewKey) {
      if (viewKey === "main") {
        return fileKey === "archive"
          ? this.mainPdcLibraryState.has_archive
          : this.mainPdcLibraryState.has_pdc;
      }

      if (!String(viewKey || "").startsWith("client:")) {
        return false;
      }

      const clientKey = String(viewKey).slice("client:".length);
      const client = this.findClientPdcPlan(clientKey);
      return fileKey === "archive"
        ? Boolean(client?.has_archive)
        : Boolean(client?.has_pdc);
    },
    buildAvailablePdcLibraryEntries() {
      const entries = [];

      if (this.mainPdcLibraryState.has_pdc) {
        entries.push({ fileKey: "pdc", viewKey: "main" });
      }
      if (this.mainPdcLibraryState.has_archive) {
        entries.push({ fileKey: "archive", viewKey: "main" });
      }

      this.clientPdcPlans.forEach((client) => {
        if (client?.has_pdc) {
          entries.push({ fileKey: "pdc", viewKey: `client:${client.key}` });
        }
        if (client?.has_archive) {
          entries.push({
            fileKey: "archive",
            viewKey: `client:${client.key}`,
          });
        }
      });

      return entries;
    },
    pickAvailablePdcLibraryEntry(preferredEntries = []) {
      const preferredEntry = preferredEntries.find((entry) =>
        this.isPdcLibraryEntryAvailable(entry.fileKey, entry.viewKey)
      );
      if (preferredEntry) {
        return preferredEntry;
      }

      return this.buildAvailablePdcLibraryEntries().find(
        (entry) =>
          entry.viewKey === "main" &&
          this.isPdcLibraryEntryAvailable(entry.fileKey, entry.viewKey)
      );
    },
    applyPdcLibrarySelection(entry) {
      this.selectedPdcFileKey = entry.fileKey;
      this.selectedPdcViewKey = entry.viewKey;
      this.lastSelectedPdcFileKey = entry.fileKey;
      this.lastSelectedPdcViewKey = entry.viewKey;
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditingMadre = false;
      this.pdcLibraryMenuOpen = false;
    },
    clearPdcLibrarySelection() {
      this.selectedPdcFileKey = "";
      this.selectedPdcViewKey = "";
      this.lastSelectedPdcFileKey = "";
      this.lastSelectedPdcViewKey = "";
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditingMadre = false;
      this.pdcLibraryMenuOpen = false;
      this.lastModified = "";
    },
    fetchClientPdcPlans(preferredEntries = []) {
      if (this.isGuestMode) {
        this.clientPdcPlans = [];
        this.mainPdcLibraryState = this.normalizeMainPdcLibraryState();
        return Promise.resolve();
      }

      this.loadingClientPdcPlans = true;
      return axios
        .get(`${API_BASE_URL}/client_pdc/list`)
        .then((res) => {
          this.clientPdcPlans = Array.isArray(res.data?.clients)
            ? res.data.clients
            : [];
          this.mainPdcLibraryState = this.normalizeMainPdcLibraryState(
            res.data?.main
          );

          const selectedStillExists = this.isPdcLibraryEntryAvailable(
            this.selectedPdcFileKey,
            this.selectedPdcViewKey
          );
          if (!selectedStillExists) {
            const nextEntry =
              this.pickAvailablePdcLibraryEntry(preferredEntries);
            if (nextEntry) {
              this.applyPdcLibrarySelection(nextEntry);
            } else if (this.hasAnyPdcLibraryFiles) {
              this.clearPdcLibrarySelection();
            }
          }
        })
        .catch((error) => {
          console.error("Errore nel caricamento dei piani cliente:", error);
          this.clientPdcPlans = [];
        })
        .finally(() => {
          this.loadingClientPdcPlans = false;
        });
    },
    fetchUserCausali() {
      if (this.isGuestMode) {
        this.causaleProspettiPaghe = "";
        return Promise.resolve();
      }

      return axios
        .get(`${API_BASE_URL}/user_causali`)
        .then((res) => {
          this.causaleProspettiPaghe = res.data?.causale_prospetti_paghe || "";
          this.causaleProspettiDraft = this.causaleProspettiPaghe;
        })
        .catch((error) => {
          console.error("Errore nel caricamento della causale:", error);
        });
    },
    normalizeCausale(value) {
      return String(value || "")
        .trim()
        .toUpperCase();
    },
    handleCausaleProspettiInput() {
      this.causaleProspettiDraft = this.normalizeCausale(
        this.causaleProspettiDraft
      ).slice(0, 4);
      this.causaleProspettiError = "";
    },
    startEditCausaleProspetti() {
      this.causaleProspettiDraft = this.causaleProspettiPaghe;
      this.causaleProspettiError = "";
      this.editingCausaleProspetti = true;
    },
    cancelEditCausaleProspetti() {
      this.causaleProspettiDraft = this.causaleProspettiPaghe;
      this.causaleProspettiError = "";
      this.editingCausaleProspetti = false;
    },
    saveCausaleProspetti() {
      const causale = this.normalizeCausale(this.causaleProspettiDraft);
      if (causale && !/^[A-Z0-9]{1,4}$/.test(causale)) {
        this.causaleProspettiError =
          "La causale deve contenere da 1 a 4 caratteri alfanumerici.";
        return Promise.resolve();
      }

      this.savingCausaleProspetti = true;
      return axios
        .post(`${API_BASE_URL}/user_causali`, {
          causale_prospetti_paghe: causale,
        })
        .then((res) => {
          this.causaleProspettiPaghe = res.data?.causale_prospetti_paghe || "";
          this.causaleProspettiDraft = this.causaleProspettiPaghe;
          this.editingCausaleProspetti = false;
          this.causaleProspettiError = "";
        })
        .catch((error) => {
          this.causaleProspettiError =
            error.response?.data?.error ||
            "Errore durante il salvataggio della causale.";
        })
        .finally(() => {
          this.savingCausaleProspetti = false;
        });
    },
    toggleCurrentEditMode() {
      if (this.isPdcArchiveView) {
        this.toggleEditingMadre();
        return;
      }
      this.isEditing = !this.isEditing;
    },
    saveCurrentLibraryFile(event) {
      if (this.isPdcArchiveView) {
        this.saveChangesMadre(event);
        return;
      }
      this.saveChanges(event);
    },
    cancelCurrentLibraryChanges() {
      if (this.isPdcArchiveView) {
        this.cancelChangesMadre();
        return;
      }
      this.cancelChanges();
    },
    downloadCurrentLibraryFile() {
      if (this.isPdcArchiveView) {
        this.downloadPDCMadre();
        return;
      }
      this.downloadPDC();
    },
    deleteCurrentLibraryFile(event) {
      this.openPdcDeleteModal(event);
    },
    openCurrentUploadModal() {
      this.openUploadPianoModal();
    },
    fetchCurrentLibraryFile() {
      if (!this.hasActivePdcLibrarySelection) {
        this.jsonData = [];
        this.lastSavedData = [];
        this.modifiedCells = {};
        this.errors = {};
        this.hasUnsavedChanges = false;
        this.provisionalRows = [];
        this.deletedRows = {};
        this.pendingDeletedRowCount = 0;
        this.lastModified = "";
        this.isDataLoaded = true;
        return Promise.resolve();
      }
      if (this.isPdcArchiveView) {
        return this.fetchMadrePDC(false);
      }
      return this.fetchFileFromBackend();
    },
    togglePdcLibraryMenu() {
      this.pdcLibraryMenuOpen = !this.pdcLibraryMenuOpen;
      if (this.pdcLibraryMenuOpen) {
        this.archiveMenuOpen = false;
      }
    },
    isPdcLibraryEntryActive(option) {
      return (
        option?.fileKey === this.selectedPdcFileKey &&
        option?.viewKey === this.selectedPdcViewKey
      );
    },
    selectPdcLibraryEntry(option) {
      if (option?.disabled) return;

      if (!option || this.isPdcLibraryEntryActive(option)) {
        this.pdcLibraryMenuOpen = false;
        return;
      }

      if (this.currentFileHasUnsavedChanges) {
        this.erroreModalMessaggio =
          "Salva o annulla le modifiche prima di cambiare file visualizzato.";
        this.erroreModalVisibile = true;
        this.pdcLibraryMenuOpen = false;
        return;
      }

      this.selectedPdcFileKey = option.fileKey;
      this.selectedPdcViewKey = option.viewKey;
      this.lastSelectedPdcFileKey = option.fileKey;
      this.lastSelectedPdcViewKey = option.viewKey;
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditingMadre = false;
      this.pdcLibraryMenuOpen = false;
      this.fetchCurrentLibraryFile();
    },
    handlePdcFileChange() {
      if (this.currentFileHasUnsavedChanges) {
        this.erroreModalMessaggio =
          "Salva o annulla le modifiche prima di cambiare file visualizzato.";
        this.erroreModalVisibile = true;
        this.selectedPdcFileKey = this.lastSelectedPdcFileKey;
        return;
      }

      this.lastSelectedPdcFileKey = this.selectedPdcFileKey;
      this.tableSearchTerm = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditingMadre = false;
      if (
        !this.pdcViewOptions.some(
          (option) => option.value === this.selectedPdcViewKey
        )
      ) {
        this.selectedPdcViewKey = "main";
        this.lastSelectedPdcViewKey = "main";
      }
      this.fetchCurrentLibraryFile();
    },
    handlePdcViewChange() {
      if (this.currentFileHasUnsavedChanges) {
        this.erroreModalMessaggio =
          "Salva o annulla le modifiche prima di cambiare Piano dei Conti visualizzato.";
        this.erroreModalVisibile = true;
        this.selectedPdcViewKey = this.lastSelectedPdcViewKey;
        return;
      }

      this.lastSelectedPdcViewKey = this.selectedPdcViewKey;
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showAddPiano = false;
      this.isEditing = false;
      this.isEditingMadre = false;
      this.fetchCurrentLibraryFile();
    },
    fetchFileFromBackend() {
      const isClientPdc = this.currentPdcIsClient;
      const requestConfig = {
        responseType: "arraybuffer", // Importante per i dati binari
      };
      if (isClientPdc) {
        requestConfig.params = {
          client_key: this.selectedClientPdcKey,
        };
      }

      return axios
        .get(
          `${API_BASE_URL}${isClientPdc ? "/excel/client_pdc" : "/excel"}`,
          requestConfig
        )
        .then((response) => {
          // Recupera la data di ultima modifica dall'header della risposta
          const lastModified = response.headers["x-last-modified"];
          this.lastModified = lastModified; // Salva la data in una variabile Vue se necessario

          const data = new Uint8Array(response.data); // Trasformiamo i dati in un array di byte
          const workbook = XLSX.read(data, { type: "array" }); // Leggiamo il file Excel
          const firstSheetName = workbook.SheetNames[0]; // Otteniamo il nome del primo foglio
          const worksheet = workbook.Sheets[firstSheetName];

          // Convertiamo i dati del foglio in formato JSON
          this.jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          // Assicura che tutte le righe abbiano la stessa lunghezza
          const maxColumns = this.jsonData[0].length;
          this.jsonData.forEach((row) => {
            while (row.length < maxColumns) {
              row.push(""); // Aggiunge celle vuote se una riga è più corta
            }
          });

          //**Rimuove solo l'ultima colonna se è completamente vuota**
          const lastColumnIndex = this.jsonData[0].length - 1;
          const isLastColumnEmpty = this.jsonData.every(
            (row) => row[lastColumnIndex] === ""
          );
          if (isLastColumnEmpty) {
            this.jsonData.forEach((row) => row.pop());
          }

          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.pendingDeletedRowCount = 0;
          this.modifiedCells = {};
          this.errors = {};
          this.hasUnsavedChanges = false;
          this.provisionalRows = [];
          this.deletedRows = {};
          this.newRow = new Array(this.jsonData[0].length).fill(""); // Assicura che newRow abbia lo stesso numero di celle
          this.tableKey += 1;
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            console.error(
              isClientPdc
                ? "Piano cliente non presente."
                : "Piano ancora non presente."
            );
            this.jsonData = [];
            this.lastSavedData = [];
            this.modifiedCells = {};
            this.errors = {};
            this.hasUnsavedChanges = false;
            this.tableKey += 1;
          } else {
            console.error("Errore nel caricamento del file Excel:", error);
          }
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },
    fetchMadrePDC(openModal = true) {
      const isClientArchive = this.currentPdcIsClient;
      const requestConfig = {
        responseType: "arraybuffer",
      };
      if (isClientArchive) {
        requestConfig.params = {
          client_key: this.selectedClientPdcKey,
          file: "archive",
        };
      }

      return axios
        .get(
          `${API_BASE_URL}${
            isClientArchive ? "/excel/client_pdc" : "/excel/madre"
          }`,
          requestConfig
        )
        .then((response) => {
          const lastModified = response.headers["x-last-modified"];
          this.lastModified = lastModified || this.lastModified;
          const data = new Uint8Array(response.data);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];

          // Converti in array di array
          this.madreJsonData = XLSX.utils.sheet_to_json(worksheet, {
            header: 1,
          });

          // Normalizzazioni DATEV (D_A / D_LP)
          this.madreJsonData = this.madreJsonData.map((row, idx) => {
            if (idx > 0 && row[2] !== undefined) {
              if (row[0] === "D_A") row[0] = "DATEV AZIENDE";
              if (row[0] === "D_LP") row[0] = "DATEV LIBERI PROF.";
            }
            return row;
          });

          // Padding colonne (assicurati che tutte le righe abbiano la stessa lunghezza)
          const maxCols = this.madreJsonData[0]?.length || 0;
          this.madreJsonData.forEach((row) => {
            while (row.length < maxCols) {
              row.push("");
            }
          });

          // Rimuovi ultima colonna se completamente vuota
          const lastIdx = maxCols - 1;
          if (
            lastIdx >= 0 &&
            this.madreJsonData.every((r) => r[lastIdx] === "")
          ) {
            this.madreJsonData.forEach((r) => r.pop());
          }

          // Crea snapshot per annullamento e rilevamento modifiche (semplice come nell'esempio)
          this.madreLastSavedData = JSON.parse(
            JSON.stringify(this.madreJsonData)
          );

          // Resetta flag modifiche e stato editing
          this.archiveMadreMissing = false;
          this.hasUnsavedChangesMadre = false;
          this.pendingDeletedMadreRowCount = 0;
          this.isEditingMadre = false;
          this.modifiedCellsMadre = {};

          if (openModal) {
            this.madreModalVisible = true;
          }
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            console.warn("Archivio madre non trovato (404)");

            // Tabella vuota (solo header opzionale)
            this.madreJsonData = [
              ["Software", "Descrizione Cod. Conto", "Cod. Conto"], // oppure [] se vuoi zero righe
            ];

            // Snapshot stato "salvato"
            this.madreLastSavedData = JSON.parse(
              JSON.stringify(this.madreJsonData)
            );

            this.archiveMadreMissing = true;
            this.hasUnsavedChangesMadre = false;
            this.isEditingMadre = false;
            this.modifiedCellsMadre = {};

            if (openModal) {
              this.madreModalVisible = true;
            }
          } else {
            console.error("Errore caricamento archivio madre:", err);
          }
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },

    toggleEditingMadre() {
      console.log("Toggle → isEditingMadre diventa:", !this.isEditingMadre);
      this.isEditingMadre = !this.isEditingMadre;
      this.madreTableKey++;

      this.$nextTick(() => {
        const cell = document.querySelector(
          '#madrePDCTable td[contenteditable="true"]'
        );
        console.log("Cella editabile trovata?", !!cell);
        if (cell)
          console.log("È davvero modificabile ora?", cell.isContentEditable);
      });
    },
    downloadPDCMadre() {
      if (this.madreJsonData.length <= 1) return;

      const isClientArchive = this.currentPdcIsClient;
      const requestConfig = {
        responseType: "blob",
      };
      if (isClientArchive) {
        requestConfig.params = {
          client_key: this.selectedClientPdcKey,
          file: "archive",
        };
      }

      axios
        .get(
          `${API_BASE_URL}${
            isClientArchive ? "/excel/client_pdc" : "/excel/madre/download"
          }`,
          requestConfig
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Prendi il nome dal backend (Content-Disposition) oppure fallback fisso
          let fileName =
            "Prospetti Paghe - Archivio Descrizioni Cod. Conto.xlsx";

          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            // Gestisce sia filename= che filename*=UTF-8''
            const match = contentDisposition.match(
              /filename[^;=\n]*=([^;\n]*)/i
            );
            if (match && match[1]) {
              fileName = match[1].replace(/['"]/g, "").trim();
            }
          }

          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          this.successModalMessaggio = "File scaricato con successo!";
          this.successModalVisibile = true;
        })
        .catch((err) => {
          console.error("Errore download:", err);
          let msg = "Impossibile scaricare il file.";
          if (err.response?.status === 404) msg = "Archivio madre non trovato.";
          alert(msg);
        });
    },

    replaceFileMadre() {
      const fileInput = this.$refs.fileInputMadre;
      const file = fileInput?.files?.[0];

      if (!file) return;

      // Controlli base sul file → ora usiamo il modal di errore
      const validExtensions = ["xlsx", "xls", "csv"];
      const ext = file.name.split(".").pop().toLowerCase();

      if (!validExtensions.includes(ext)) {
        this.erroreModalMessaggio =
          "Formato non supportato. Usa .xlsx, .xls o .csv";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        // 10 MB
        this.erroreModalMessaggio =
          "File troppo grande. Dimensione massima consentita: 10 MB";
        this.erroreModalVisibile = true;
        fileInput.value = "";
        return;
      }

      // Avvia caricamento
      this.uploadingMadre = true;
      this.uploadProgressMadre = 0;

      const formData = new FormData();
      formData.append("file", file);
      if (this.currentPdcIsClient) {
        formData.append("client_key", this.selectedClientPdcKey);
        formData.append("file", "archive");
      }

      axios
        .post(
          `${API_BASE_URL}${
            this.currentPdcIsClient
              ? "/update_excel/client_pdc"
              : "/upload_excel_madre"
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgressMadre = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          }
        )
        .then(() => {
          this.successModalMessaggio =
            "Archivio Descrizioni Cod. Conto sostituito con successo!";
          this.successModalVisibile = true;

          this.fetchMadrePDC(false);

          this.hasUnsavedChangesMadre = false;
          this.modifiedCellsMadre = {};
          this.isEditingMadre = false;
        })
        .catch((err) => {
          console.error(
            "Errore durante la sostituzione dell'archivio madre:",
            err
          );

          let msg = "Errore durante la sostituzione dell'archivio.";

          if (err.response) {
            if (err.response.status === 400) {
              msg =
                err.response.data?.error || "File non valido o formato errato.";
            } else if (err.response.status === 413) {
              msg = "File troppo grande.";
            } else if (err.response.status === 500) {
              msg = "Errore interno del server.";
            } else if (err.response.status === 401) {
              msg = "Sessione scaduta. Effettua nuovamente il login.";
            }
          }

          // MODAL
          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          this.uploadingMadre = false;
          this.uploadProgressMadre = 0;
          fileInput.value = ""; // reset per poter ricaricare lo stesso file
        });
    },
    // isColumnVisible(colIndex) {
    //   return true;
    // },
    updateCellMadre(rowIndex, colIndex, value) {
      if (rowIndex === 0) return;

      const table = document.getElementById("madrePDCTable");
      const cell = table?.rows[rowIndex]?.cells[colIndex + 1];
      if (!cell) {
        console.warn(`Cella non trovata: row=${rowIndex}, col=${colIndex}`);
        return;
      }

      const selection = window.getSelection();
      let cursorPosition = selection?.anchorOffset || 0;

      let formattedValue = value;
      let oldSeparatorCount = 0;
      let newSeparatorCount = 0;
      let isValid = true;

      const sistema = (this.madreJsonData[rowIndex][0] || "")
        .toUpperCase()
        .trim();

      // 1. Regola "N.A." universale (solo colonne che non sono sistema/descrizione/codice conto)
      const previousValue = this.madreJsonData[rowIndex][colIndex] || "";
      const isEmptyOrNA =
        previousValue.trim() === "" ||
        previousValue.trim().toUpperCase() === "N.A.";
      const hasLetters = /[a-zA-Z]/.test(value);
      const hasNumbers = /\d/.test(value);

      if (
        colIndex !== 1 &&
        colIndex !== 2 &&
        isEmptyOrNA &&
        hasLetters &&
        !hasNumbers
      ) {
        formattedValue = "N.A.";
      }

      // 2. COLONNA CODICE CONTO (colIndex === 2) → formattazione + validazione
      else if (colIndex === 2) {
        let numeric = value.replace(/\D/g, "");

        if (sistema.includes("TEAMSYSTEM")) {
          oldSeparatorCount = (value.match(/\//g) || []).length;
          numeric = numeric.slice(0, 7);
          if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(
              2,
              4
            )}/${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}/${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          isValid =
            formattedValue === "" ||
            /^\d{2}\/\d{2}\/\d{3}$/.test(formattedValue);
        } else if (sistema.includes("SISTEMI")) {
          oldSeparatorCount = (value.match(/\./g) || []).length;
          numeric = numeric.slice(0, 9);
          if (numeric.length >= 7) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4, 6)}.${numeric.slice(6)}`;
          } else if (numeric.length >= 5) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(
              2,
              4
            )}.${numeric.slice(4)}`;
          } else if (numeric.length >= 3) {
            formattedValue = `${numeric.slice(0, 2)}.${numeric.slice(2)}`;
          } else {
            formattedValue = numeric;
          }
          newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          isValid =
            formattedValue === "" ||
            /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/.test(formattedValue);
        } else if (sistema.includes("SEAC")) {
          formattedValue = numeric.slice(0, 6);
          isValid = formattedValue === "" || formattedValue.length === 6;
        } else if (sistema.includes("DATEV")) {
          formattedValue = numeric.slice(0, 11);
          isValid =
            formattedValue === "" ||
            (formattedValue.length >= 5 && formattedValue.length <= 11);
        } else if (sistema.includes("ZUCCHETTI")) {
          formattedValue = numeric;
          isValid = formattedValue === "" || formattedValue.length >= 5;
        } else {
          formattedValue = numeric;
          isValid = true;
        }

        if (this.isCodContoDefault(formattedValue)) {
          isValid = false;
        }

        cursorPosition += newSeparatorCount - oldSeparatorCount;
      }

      // 3. Tutte le altre colonne → solo trim (testo libero)
      else {
        formattedValue = (value || "").trim();
      }

      // Aggiorna array
      this.madreJsonData[rowIndex][colIndex] = formattedValue;

      // Modified / unsaved
      const original = this.madreLastSavedData?.[rowIndex]?.[colIndex] ?? "";
      if (String(formattedValue) !== String(original)) {
        this.$set(this.modifiedCellsMadre, `${rowIndex}-${colIndex}`, true);
      } else {
        this.$delete(this.modifiedCellsMadre, `${rowIndex}-${colIndex}`);
      }
      this.hasUnsavedChangesMadre = !this.isDataEqual(
        this.madreJsonData,
        this.madreLastSavedData
      );

      // Aggiorna DOM + cursore + error
      this.$nextTick(() => {
        if (cell) {
          cell.innerText = formattedValue || "";

          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, formattedValue.length)
          );
          range.collapse(true);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);

          if (!isValid && formattedValue !== "") {
            cell.classList.add("error-cell");
            this.$set(this.errorsMadre, `${rowIndex}-${colIndex}`, true); // ← aggiungi errore
          } else {
            cell.classList.remove("error-cell");
            this.$delete(this.errorsMadre, `${rowIndex}-${colIndex}`); // ← rimuovi errore
          }
        }
      });
    },
    saveChangesMadre(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChangesMadre) {
        // Opzionale: messaggio "Nessuna modifica" (come nel tuo altro metodo)
        // this.noChangesMessageMadre = true;
        // setTimeout(() => { this.noChangesMessageMadre = false; }, 2000);
        return;
      }

      // Controlla se ci sono errori attivi nelle celle (identico al funzionante)
      if (Object.keys(this.errorsMadre || {}).length > 0) {
        this.erroreModalMessaggio =
          "Correggi i codici conto evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return; // blocca il salvataggio
      }
      if (!skipDeletionConfirmation && this.pendingDeletedMadreRowCount > 0) {
        this.confirmSaveWithPendingDeletions(
          this.pendingDeletedMadreRowCount,
          () => this.saveChangesMadre(event, true),
          "archivio"
        );
        return;
      }

      // Cursore attesa (esattamente come nell'altro)
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event && event.target) {
        event.target.style.cursor = "progress";
      }

      this.uploadingMadre = true;

      // Creazione workbook e sheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.madreJsonData);
      XLSX.utils.book_append_sheet(wb, ws, "Archivio");

      // Creazione blob
      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // FormData
      const formData = new FormData();
      formData.append("file", blob, "archivio_madre.xlsx");
      if (this.currentPdcIsClient) {
        formData.append("client_key", this.selectedClientPdcKey);
        formData.append("file", "archive");
      }

      // Invio axios
      axios
        .post(
          `${API_BASE_URL}${
            this.currentPdcIsClient
              ? "/update_excel/client_pdc"
              : "/update_excel_madre"
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response); // per debug, come nell'altro

          this.successModalMessaggio = "Modifiche salvate con successo!";
          this.successModalVisibile = true;

          // Reset snapshot e stati (identico)
          this.madreLastSavedData = JSON.parse(
            JSON.stringify(this.madreJsonData)
          );
          this.modifiedCellsMadre = {};
          this.errorsMadre = {}; // ← reset errori dopo successo
          this.hasUnsavedChangesMadre = false;

          this.pendingDeletedMadreRowCount = 0;

          // Opzionale: refresh o altre azioni come finalizeAllRows se le hai
          // this.finalizeAllRowsMadre?.(); // se esiste
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file madre:", error);
          this.erroreModalMessaggio =
            error.response?.data?.error || "Errore nel salvataggio del file.";
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          // Ripristino cursore (identico)
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event && event.target) {
            event.target.style.cursor = "pointer";
          }

          this.uploadingMadre = false;
          // Opzionale: refresh dashboard o altro
          // this.refreshDashboardMadre?.();
        });
    },

    cancelChangesMadre() {
      if (!this.hasUnsavedChangesMadre) return;

      this.madreJsonData = JSON.parse(JSON.stringify(this.madreLastSavedData));
      this.modifiedCellsMadre = {};
      this.hasUnsavedChangesMadre = false;
      this.pendingDeletedMadreRowCount = 0;
    },
    resetConfirmModal() {
      this.confirmModalVisibile = false;
      this.confirmModalTitle = "Elimina Piano dei Conti";
      this.confirmModalMessaggio = "";
      this.confirmModalShowArchiveOption = false;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.deleteArchiveAlongWithPdc = false;
      this.confirmModalDeleteOptions = [];
      this.deleteLibraryTargets = {};
      this.confirmModalCallback = null;
    },
    setConfirmDeleteOptions(options = [], selectedKeys = []) {
      const targets = {};
      options.forEach((option) => {
        targets[option.key] = selectedKeys.includes(option.key);
      });
      this.confirmModalDeleteOptions = options;
      this.deleteLibraryTargets = targets;
    },
    getSelectedConfirmDeleteKeys() {
      return this.confirmModalDeleteOptions
        .filter((option) => this.deleteLibraryTargets?.[option.key])
        .map((option) => option.key);
    },
    buildPdcDeleteOptions() {
      const suffix = this.currentPdcIsClient
        ? `di ${this.selectedClientPdcLabel}`
        : "principale";
      return [
        {
          key: "pdc",
          label: `Piano dei Conti ${suffix}`,
        },
        {
          key: "archive",
          label: `Archivio Descrizioni Cod. Conto ${suffix}`,
        },
      ];
    },
    resetDeletedPdcState(selectedKeys) {
      if (selectedKeys.includes("pdc")) {
        this.jsonData = [];
        this.lastSavedData = [];
        this.modifiedCells = {};
        this.errors = {};
        this.hasUnsavedChanges = false;
        this.messageToShow = "noRows";
        this.tableKey += 1;
      }
      if (selectedKeys.includes("archive")) {
        this.madreJsonData = [[]];
        this.madreLastSavedData = [];
        this.modifiedCellsMadre = {};
        this.errorsMadre = {};
        this.hasUnsavedChangesMadre = false;
        this.pendingDeletedMadreRowCount = 0;
        this.archiveMadreMissing = true;
        this.madreModalVisible = false;
      }
    },
    getPdcDeleteSuccessMessage(selectedKeys) {
      const scope = this.currentPdcIsClient ? "cliente" : "principali";
      if (selectedKeys.includes("pdc") && selectedKeys.includes("archive")) {
        return `Piano dei Conti e Archivio Descrizioni ${scope} eliminati con successo.`;
      }
      if (selectedKeys.includes("archive")) {
        return `Archivio Descrizioni ${scope} eliminato con successo.`;
      }
      return `Piano dei Conti ${scope} eliminato con successo.`;
    },
    openPdcDeleteModal(event, selectedFileKey = null) {
      selectedFileKey =
        selectedFileKey || (this.isPdcArchiveView ? "archive" : "pdc");
      this.setConfirmDeleteOptions(this.buildPdcDeleteOptions(), [
        selectedFileKey,
      ]);
      this.confirmModalTitle = this.currentPdcIsClient
        ? "Elimina file cliente"
        : "Elimina file principali";
      this.confirmModalMessaggio = this.currentPdcIsClient
        ? `Seleziona i file da eliminare per ${this.selectedClientPdcLabel}.\nI dati presenti nei file selezionati verranno rimossi in modo permanente.`
        : "Seleziona i file da eliminare.\nI dati presenti nei file selezionati verranno rimossi in modo permanente.";
      this.confirmModalShowArchiveOption = false;
      this.confirmModalConfirmLabel = "Elimina";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        const selectedKeys = this.getSelectedConfirmDeleteKeys();
        this.resetConfirmModal();
        if (!confirmed || selectedKeys.length === 0) return;

        const deletedViewKey = this.selectedPdcViewKey;
        const preferredAfterDelete = ["pdc", "archive"]
          .filter((fileKey) => !selectedKeys.includes(fileKey))
          .map((fileKey) => ({
            fileKey,
            viewKey: deletedViewKey,
          }));

        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";
        if (event?.target) event.target.style.cursor = "progress";

        const request = this.currentPdcIsClient
          ? axios.post(`${API_BASE_URL}/delete_excel/client_pdc`, {
              client_key: this.selectedClientPdcKey,
              delete_pdc: selectedKeys.includes("pdc"),
              delete_archive: selectedKeys.includes("archive"),
            })
          : axios.post(`${API_BASE_URL}/delete_PDC`, {
              delete_pdc: selectedKeys.includes("pdc"),
              delete_archive: selectedKeys.includes("archive"),
            });

        request
          .then(() => {
            this.resetDeletedPdcState(selectedKeys);
            this.successModalMessaggio =
              this.getPdcDeleteSuccessMessage(selectedKeys);
            this.successModalVisibile = true;
            return this.fetchClientPdcPlans(preferredAfterDelete).then(() =>
              this.fetchCurrentLibraryFile()
            );
          })
          .catch((err) => {
            console.error("Errore eliminazione file libreria:", err);
            this.erroreModalMessaggio =
              err.response?.data?.error ||
              "Errore durante l'eliminazione dei file selezionati.";
            this.erroreModalVisibile = true;
          })
          .finally(() => {
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
            if (event?.target) event.target.style.cursor = "pointer";
          });
      };
    },
    getPendingDeletionCount() {
      return this.pendingDeletedRowCount;
    },
    confirmSaveWithPendingDeletions(count, onConfirm, context = "software") {
      const target =
        context === "archivio"
          ? {
              singular:
                "Con il salvataggio verranno eliminati i dati della riga rimossa dall'archivio.",
              plural:
                "Con il salvataggio verranno eliminati i dati delle righe rimosse dall'archivio.",
            }
          : {
              singular:
                "Con il salvataggio verranno eliminati i dati della riga rimossa per tutti i software contabili.",
              plural:
                "Con il salvataggio verranno eliminati i dati delle righe rimosse per tutti i software contabili.",
            };
      this.confirmModalTitle = "Salva modifiche";
      this.confirmModalMessaggio =
        count === 1
          ? `Tra le modifiche correnti e' inclusa anche l'eliminazione di 1 riga. ${target.singular}`
          : `Tra le modifiche correnti sono incluse anche ${count} eliminazioni di riga. ${target.plural}`;
      this.confirmModalShowArchiveOption = false;
      this.confirmModalConfirmLabel = "Salva";
      this.confirmModalCancelLabel = "Annulla";
      this.confirmModalConfirmClass = "btn-primary";
      this.confirmModalConfirmIcon = "fa-solid fa-floppy-disk";
      this.deleteArchiveAlongWithPdc = false;
      this.confirmModalVisibile = true;
      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();
        if (confirmed) onConfirm();
      };
    },

    deleteFile() {
      // Mostra il modal di conferma (stesso sistema dell'altro componente)
      this.confirmModalTitle = "Elimina Archivio Descrizioni Cod. Conto";
      this.confirmModalMessaggio = `Sei sicuro di voler eliminare l'intero Archivio Descrizioni Cod. Conto?\nTutti i dati presenti verranno eliminati.`;
      this.confirmModalShowArchiveOption = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.deleteArchiveAlongWithPdc = false;
      this.confirmModalVisibile = true;

      // Callback che viene eseguito quando l'utente risponde al modal
      this.confirmModalCallback = (confirmed) => {
        // Chiudi sempre il modal di conferma
        this.resetConfirmModal();

        if (!confirmed) {
          return; // utente ha annullato
        }

        // Imposta cursore attesa (opzionale, come nell'altro)
        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";

        const deleteRequest = this.currentPdcIsClient
          ? axios.post(`${API_BASE_URL}/delete_excel/client_pdc`, {
              client_key: this.selectedClientPdcKey,
              file: "archive",
            })
          : axios.post(`${API_BASE_URL}/delete_excel_madre`);

        deleteRequest
          .then(() => {
            // Successo: mostra modal successo
            this.successModalMessaggio =
              "L'Archivio Descrizioni Cod. Conto è stato eliminato con successo.";
            this.successModalVisibile = true;

            // Resetta tutto
            this.madreJsonData = [[]]; // o [] se preferisci vuoto
            this.madreLastSavedData = [];
            this.modifiedCellsMadre = {};
            this.hasUnsavedChangesMadre = false;
            this.pendingDeletedMadreRowCount = 0;
            this.archiveMadreMissing = true;
            this.madreModalVisible = false; // chiudi la modale della tabella
            this.fetchClientPdcPlans();
          })
          .catch((err) => {
            console.error("Errore eliminazione archivio madre:", err);

            // Mostra errore (puoi usare un modal errore se ce l'hai, altrimenti alert)
            alert(
              "Errore durante l'eliminazione dell'Archivio Descrizioni.\n" +
                (err.response?.data?.error || "Errore sconosciuto")
            );
          })
          .finally(() => {
            // Ripristina cursore
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
          });
      };
    },
    deleteClientPdcFile(event) {
      this.confirmModalTitle = "Elimina Piano dei Conti cliente";
      this.confirmModalMessaggio = `Sei sicuro di voler eliminare il Piano dei Conti di ${this.selectedClientPdcLabel}?\nTutti i dati presenti verranno eliminati.`;
      this.confirmModalShowArchiveOption = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.deleteArchiveAlongWithPdc = false;
      this.confirmModalVisibile = true;

      this.confirmModalCallback = (confirmed) => {
        this.resetConfirmModal();
        if (!confirmed) return;

        document.documentElement.style.cursor = "progress";
        document.body.style.cursor = "progress";
        if (event?.target) event.target.style.cursor = "progress";

        axios
          .post(`${API_BASE_URL}/delete_excel/client_pdc`, {
            client_key: this.selectedClientPdcKey,
            file: "pdc",
          })
          .then(() => {
            this.successModalMessaggio =
              "Il Piano dei Conti cliente e' stato eliminato con successo.";
            this.successModalVisibile = true;
            this.jsonData = [];
            this.lastSavedData = [];
            this.modifiedCells = {};
            this.errors = {};
            this.hasUnsavedChanges = false;
            this.tableKey += 1;
            return this.fetchClientPdcPlans();
          })
          .catch((err) => {
            console.error("Errore eliminazione piano cliente:", err);
            this.erroreModalMessaggio =
              err.response?.data?.error ||
              "Errore durante l'eliminazione del Piano dei Conti cliente.";
            this.erroreModalVisibile = true;
          })
          .finally(() => {
            document.documentElement.style.cursor = "default";
            document.body.style.cursor = "default";
            if (event?.target) event.target.style.cursor = "pointer";
          });
      };
    },
    deleteMadreRow(rowIndex, event) {
      this.performDeleteMadreRow(rowIndex, event);
    },
    performDeleteMadreRow(rowIndex, event) {
      // Mostra animazione cancellazione
      this.$set(this.deletedMadreRows, rowIndex, true);
      this.$set(this.activeDeleteMadre, rowIndex, true);

      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) event.target.style.cursor = "progress";
      this.pendingDeletedMadreRowCount += 1;

      setTimeout(() => {
        // Rimuovi riga
        this.madreJsonData.splice(rowIndex, 1);

        // Aggiorna hover e active
        this.hoveredMadreRow = null;
        this.$delete(this.deletedMadreRows, rowIndex);
        this.$delete(this.activeDeleteMadre, rowIndex);

        // Flag modifiche
        this.hasUnsavedChangesMadre = !this.isDataEqual(
          this.madreJsonData,
          this.madreLastSavedData
        );

        // Reset cursore
        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        if (event?.target) event.target.style.cursor = "pointer";
      }, 700); // tempo animazione come nel tuo esempio
    },
    openUploadPianoModal() {
      this.errorMessage = "";
      this.resetUploadPdcTargetState();
      this.fetchUploadClienti();
      this.showAddPiano = true;
      this.showAddBilancino = false;
      this.showAddRow = false;
    },
    closeUploadPianoModal() {
      if (this.uploading) return;

      this.showAddPiano = false;
      this.selectedPiano = null;
      this.rows = [];
      this.errorMessage = "";
      this.resetUploadPdcTargetState();
    },
    triggerFileInput() {
      this.openUploadPianoModal();
    },
    resetUploadPdcTargetState() {
      this.uploadPdcScope = this.currentPdcIsClient
        ? "existing_client"
        : "main";
      this.selectedUploadClientKey = this.currentPdcIsClient
        ? this.selectedClientPdcKey
        : "";
      this.uploadNewClient = {
        titolo_cliente: "",
        codice_fiscale: "",
        codice_ditta: "",
      };
      this.uploadPdcErrors = {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      };
    },
    async fetchUploadClienti() {
      this.loadingUploadClients = true;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get_clienti_by_studio`
        );
        this.uploadClienti = response.data?.success
          ? response.data.clienti
          : [];
      } catch (error) {
        console.error("Errore caricamento clienti anagrafica:", error);
        this.uploadClienti = [];
      } finally {
        this.loadingUploadClients = false;
      }
    },
    formatUploadClientFiscalCode() {
      this.uploadNewClient.codice_fiscale = String(
        this.uploadNewClient.codice_fiscale || ""
      )
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 16);
      this.uploadPdcErrors.codice_fiscale = "";
    },
    isValidUploadFiscalCode(value) {
      const normalized = String(value || "")
        .trim()
        .toUpperCase();
      return /^\d{11}$/.test(normalized) || /^[A-Z0-9]{16}$/.test(normalized);
    },
    validateUploadPdcTarget() {
      this.uploadPdcErrors = {
        client: "",
        titolo_cliente: "",
        codice_fiscale: "",
      };

      if (this.uploadPdcScope === "existing_client") {
        if (!this.selectedUploadClientKey) {
          this.uploadPdcErrors.client = "Seleziona un cliente";
          return false;
        }
      }

      if (this.uploadPdcScope === "new_client") {
        if (!this.uploadNewClient.titolo_cliente?.trim()) {
          this.uploadPdcErrors.titolo_cliente =
            "La Denominazione Cliente e' obbligatoria";
        }
        if (!this.uploadNewClient.codice_fiscale?.trim()) {
          this.uploadPdcErrors.codice_fiscale =
            "Il Codice Fiscale e' obbligatorio";
        } else if (
          !this.isValidUploadFiscalCode(this.uploadNewClient.codice_fiscale)
        ) {
          this.uploadPdcErrors.codice_fiscale =
            "Inserisci un Codice Fiscale valido";
        }
      }

      return !Object.values(this.uploadPdcErrors).some(Boolean);
    },
    async ensureUploadClientKey() {
      if (this.uploadPdcScope === "main") return null;
      if (this.uploadPdcScope === "existing_client") {
        return this.selectedUploadClientKey;
      }

      const payload = {
        titolo_cliente: this.uploadNewClient.titolo_cliente.trim(),
        codice_fiscale: this.uploadNewClient.codice_fiscale.trim(),
        codice_ditta: this.uploadNewClient.codice_ditta.trim(),
      };
      const response = await axios.post(
        `${API_BASE_URL}/aggiungi_cliente`,
        payload
      );
      if (!response.data?.success) {
        throw new Error(response.data?.error || "Errore salvataggio cliente");
      }
      await this.fetchUploadClienti();
      return payload.titolo_cliente;
    },
    handleFileUpload(fileOrEvent) {
      const file = fileOrEvent?.target?.files
        ? fileOrEvent.target.files[0]
        : fileOrEvent;

      this.selectedPiano = file || null;
      this.rows = [];
      if (!this.selectedPiano) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        this.rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      };
      reader.readAsArrayBuffer(this.selectedPiano);
    },
    triggerBilancinoInput() {
      this.$refs.BilancinoInput.click();
    },
    handleBilancinoInput(event) {
      // If we're restoring, skip processing to avoid infinite loop
      if (this.restoringFile) {
        this.restoringFile = false;
        // Check if files were cleared unexpectedly and reapply restoration
        if (this.bilancinoFile && !this.$refs.bilancinoInput.files.length) {
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.bilancinoFile);
            this.$refs.bilancinoInput.files = dataTransfer.files;
          });
        }
        return;
      }

      const newFile = event.target.files[0];

      // Detect cancel: files.length === 0 (browser cleared it)
      if (!newFile) {
        if (this.bilancinoFile) {
          this.$nextTick(() => {
            const dataTransfer = new DataTransfer();
            dataTransfer.items.add(this.bilancinoFile);
            this.$refs.bilancinoInput.files = dataTransfer.files;
            this.restoringFile = true; // Set flag for potential change event
            this.fileTitle = this.bilancinoFile.name; // Ensure fileTitle is in sync
          });
        } else {
          this.fileTitle = "Nessun file selezionato";
        }
        return;
      }

      // Estrazione estensione file
      const filename = newFile.name;
      const estensione = filename.split(".").pop().toLowerCase();

      // Set fileType per distinguere CSV da Excel
      if (estensione === "csv") {
        this.fileType = "csv";
      } else if (["xls", "xlsx", "xlsm"].includes(estensione)) {
        this.fileType = "excel";
      } else {
        this.fileType = "";
      }

      // Se il file è un PDF, genera l'URL per visualizzazione
      if (newFile.type === "application/pdf") {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = URL.createObjectURL(newFile);
      } else {
        if (this.filePDF_URL) URL.revokeObjectURL(this.filePDF_URL); // Clean up previous URL
        this.filePDF_URL = null;
      }

      // Se non c'era un file prima, lo assegna direttamente
      if (!this.bilancinoFile) {
        this.bilancinoFile = newFile;
        this.fileTitle = this.bilancinoFile.name;
        this.leggiFileExcelOCsv(newFile, estensione);
        return;
      }

      // Controlla se il file è diverso dal precedente (per nome o data)
      if (
        this.bilancinoFile.name !== newFile.name ||
        this.bilancinoFile.lastModified !== newFile.lastModified
      ) {
        this.bilancinoFile = newFile;
        this.refreshConversione2();
        this.leggiFileExcelOCsv(newFile, estensione);
      }

      this.fileTitle = this.bilancinoFile.name;
    },
    leggiFileExcelOCsv(file, estensione) {
      if (estensione === "csv") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const testoCsv = e.target.result;
          this.ExcelRows = testoCsv.split("\n").map((line) => line.split(","));
        };
        reader.readAsText(file);
      } else if (estensione === "xls" || estensione === "xlsx") {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          this.ExcelRows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        };
        reader.readAsArrayBuffer(file);
      } else {
        this.ExcelRows = [];
        this.fileType = "";
      }
    },
    openPDFPreview() {
      this.showPDF = true;
    },
    sendBilancino() {
      if (!this.bilancinoFile) return;

      if (!this.output_PC) {
        this.erroreModalMessaggio =
          "Devi selezionare il software contabile prima di procedere!";
        this.erroreModalVisibile = true;
        return;
      }

      this.calculating = true;
      const requestId = ++this.activeScanRequestId;

      const formData = new FormData();
      formData.append("file", this.bilancinoFile);
      formData.append("output_PC", this.output_PC);

      const settings = getUserSettings();
      formData.append(
        "flag_saldoProspettiPaghe",
        settings.flag_saldoProspettiPaghe
      );

      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/edit_PDC_with_bilancino`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (this.isStaleScanRequest(requestId)) return;
          this.clearDelayMessageTimer();
          this.applyCodContoDefaultFromResponse(res.data || {});

          if (!res.data.input_PC) {
            this.erroreModalMessaggio =
              "Errore: input_PC non presente nella risposta del server.";
            this.erroreModalVisibile = true;
            return;
          }

          this.input_PC = res.data.input_PC;

          // Caso SEAC
          if (this.input_PC === "SEAC") {
            if (!res.data.NumeroClienti || !res.data.vettoreClienti_SEAC) {
              this.erroreModalMessaggio =
                "Errore: dati SEAC incompleti nella risposta del server.";
              this.erroreModalVisibile = true;
              return;
            }

            this.NumeroClienti = res.data.NumeroClienti;
            this.vettoreClienti_SEAC = res.data.vettoreClienti_SEAC;
            this.input_file_path = res.data.input_file_path;
            this.fase1_SEAC = true;
            this.showAddBilancino = true;
            this.isShifted = true;
            this.nextConversionStep(requestId);
            return;
          }

          // vettoreCodConto
          if (Array.isArray(res.data.vettoreCodConto)) {
            this.vettoreCodConto = res.data.vettoreCodConto.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) => {
                    if (
                      [1, 2, 3, 4, 5, 6].includes(index) &&
                      (cell === "None" ||
                        this.isCodContoDefault(cell) ||
                        cell == null)
                    ) {
                      return null;
                    }
                    return cell;
                  })
                : row
            );
          } else {
            this.vettoreCodConto = [];
          }

          // vettoreCodContoPDC
          if (Array.isArray(res.data.vettoreCodContoPDC)) {
            const mappedPDC = res.data.vettoreCodContoPDC.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) => {
                    if (
                      [1, 2, 3, 4, 5, 6].includes(index) &&
                      (cell === "None" ||
                        this.isCodContoDefault(cell) ||
                        cell == null)
                    ) {
                      return null;
                    }
                    return cell;
                  })
                : row
            );

            this.$set(this, "vettoreCodContoPDC", mappedPDC);
            this.originalPDC = JSON.parse(JSON.stringify(mappedPDC));

            console.log(
              "PDC caricato e originalPDC salvato:",
              this.originalPDC?.length ?? 0,
              "righe"
            );
          } else {
            this.$set(this, "vettoreCodContoPDC", []);
            this.originalPDC = null;
          }

          this.clientCustomPdcEntries =
            res.data.client_custom_pdc_entries || {};
          this.setPdcClientGroups(res.data.pdc_client_groups || {});
          this.isEditMode = false;
          this.isEditModePDC = false;

          this.editPDCresponse = true;
          this.showAddBilancino = true;
          this.isShifted = true;

          this.nextConversionStep(requestId);

          this.$nextTick(() => {
            console.log("=== DOPO caricamento vettori PDC ===");
            console.log(
              "vettoreCodConto.length     =",
              this.vettoreCodConto?.length ?? 0
            );
            console.log(
              "vettoreCodContoPDC.length  =",
              this.vettoreCodContoPDC?.length ?? 0
            );
          });
        })
        .catch((err) => {
          if (this.isStaleScanRequest(requestId)) return;
          this.clearDelayMessageTimer();

          console.error("Errore sendBilancino:", err);

          let msg = "Errore nella richiesta al server.";

          if (err.response) {
            const status = err.response.status;
            const data = err.response.data;

            if (status === 400) {
              msg = data?.error || "Richiesta non valida.";
            } else if (status === 401) {
              msg = "Sessione scaduta. Effettua nuovamente il login.";
            } else if (status === 404) {
              msg = "Utente non trovato.";
            } else if (status === 413) {
              msg = "File troppo grande.";
            } else if (status === 500) {
              msg = data?.error || "Errore interno del server.";
            } else {
              msg = data?.error || "Errore sconosciuto dal server.";
            }
          } else if (err.message) {
            msg = `Errore di rete: ${err.message}`;
          }

          this.erroreModalMessaggio = msg;
          this.erroreModalVisibile = true;
        })
        .finally(() => {
          if (!this.isStaleScanRequest(requestId)) {
            this.calculating = false;
          }
        });
    },

    proseguiFase2_SEAC() {
      if (!this.vettoreClienti_SEAC.every(hasValidSeacClientChoice)) {
        this.errorMessage =
          "Seleziona un tipo di contabilità per ogni cliente.";
        setTimeout(() => {
          this.errorMessage = "";
        }, 4000);
        return;
      }

      this.calculating2 = true;
      const requestId = ++this.activeScanRequestId;
      const formData = new FormData();
      formData.append(
        "vettoreClienti_SEAC",
        JSON.stringify(this.vettoreClienti_SEAC)
      );
      formData.append("output_PC", this.output_PC);
      formData.append("file", this.bilancinoFile); // file originale

      axios
        .post(`${API_BASE_URL}/edit_PDC_with_bilancino_SEAC`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          if (this.isStaleScanRequest(requestId)) return;
          this.applyCodContoDefaultFromResponse(res.data || {});
          // Controllo base
          if (!res.data.vettoreCodConto) {
            this.errorMessage =
              "Errore: vettoreCodConto non presente nella risposta.";
            return;
          }

          // ───────────────────────────────────────────────
          // 1. vettoreCodConto (nuovi codici – già presente)
          // ───────────────────────────────────────────────
          const cleanedData = res.data.vettoreCodConto.map((row) =>
            Array.isArray(row)
              ? row.map((cell, index) => {
                  if (
                    [1, 2, 3, 4, 5, 6].includes(index) &&
                    (cell == null ||
                      cell === "None" ||
                      this.isCodContoDefault(cell))
                  ) {
                    return null;
                  }
                  return cell;
                })
              : row
          );
          this.vettoreCodConto = cleanedData;
          console.log(
            "vettoreCodConto SEAC post filter:",
            this.vettoreCodConto
          );

          // ───────────────────────────────────────────────
          // 2. vettoreCodContoPDC (codici già salvati) ← AGGIUNTA
          // ───────────────────────────────────────────────
          if (Array.isArray(res.data.vettoreCodContoPDC)) {
            const mappedPDC = res.data.vettoreCodContoPDC.map((row) =>
              Array.isArray(row)
                ? row.map((cell, index) => {
                    if (
                      [1, 2, 3, 4, 5, 6].includes(index) &&
                      (cell == null ||
                        cell === "None" ||
                        this.isCodContoDefault(cell))
                    ) {
                      return null;
                    }
                    return cell;
                  })
                : row
            );

            this.$set(this, "vettoreCodContoPDC", mappedPDC);

            // Copia originale per eventuale reset modifiche
            this.originalPDC = JSON.parse(JSON.stringify(mappedPDC));

            console.log(
              "SEAC → vettoreCodContoPDC caricato:",
              this.vettoreCodContoPDC?.length ?? 0,
              "righe"
            );
          } else {
            this.$set(this, "vettoreCodContoPDC", []);
            this.originalPDC = null;
          }

          this.clientCustomPdcEntries =
            res.data.client_custom_pdc_entries || {};
          this.setPdcClientGroups(res.data.pdc_client_groups || {});

          // Transizione di fase
          this.fase1_SEAC = false;
          this.editPDCresponse = true;
          this.isShifted = true;
          this.showAddBilancino = true;

          // Reset stati edit
          this.isEditMode = false;
          this.isEditModePDC = false;

          this.nextConversionStep(requestId);
        })
        .catch((err) => {
          if (this.isStaleScanRequest(requestId)) return;
          if (err.response?.data?.error) {
            this.errorMessage = err.response.data.error;
          } else {
            this.errorMessage = "Errore nella richiesta al server.";
          }
          console.error("Errore proseguiFase2_SEAC:", err);
        })
        .finally(() => {
          if (this.isStaleScanRequest(requestId)) return;
          this.calculating2 = false;
          if (this.errorMessage) {
            setTimeout(() => {
              this.errorMessage = "";
            }, 4000);
          }
        });
    },
    fillEmptyWithNA() {
      console.log("RIEMPIMENTO N.A. IN CORSO...");

      const fill = (vector, validColumns) => {
        if (!Array.isArray(vector) || vector.length === 0) return;
        if (!Array.isArray(validColumns)) return;

        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers?.[colIndex] || "";

            // Escludi descrizioni e tutte le colonne DARE/AVERE
            if (
              col.includes("Descrizione") ||
              col.includes("Descrizione Cod. Conto") ||
              col.startsWith("Cod. Conto DARE") ||
              col.startsWith("Cod. Conto AVERE") ||
              col === "DARE" ||
              col === "AVERE"
            ) {
              return;
            }

            const value = row[colIndex];
            if (!value || String(value).trim() === "") {
              this.$set(row, colIndex, "N.A.");
            }
          });
        });
      };

      // Vettore principale
      fill(this.vettoreCodConto, this.getValidColumns() || []);

      // Vettore PDC (se esiste e ha dati)
      if (
        Array.isArray(this.vettoreCodContoPDC) &&
        this.vettoreCodContoPDC.length > 0
      ) {
        fill(
          this.vettoreCodContoPDC,
          this.validColumnsPDC || this.getValidColumns() || []
        );
      }

      this.showErrorModal = false;
      // this.$forceUpdate();  // quasi mai necessario se usi $set
    },
    fillEmptyWithNoCorr() {
      console.log("RIEMPIMENTO 'NESSUNA CORRELAZIONE' IN CORSO...");

      const fill = (vector, validColumns) => {
        if (!Array.isArray(vector) || vector.length === 0) return;
        if (!Array.isArray(validColumns)) return;

        vector.forEach((row) => {
          validColumns.forEach((colIndex) => {
            const col = this.headers?.[colIndex] || "";

            // Riempi SOLO le colonne di descrizione codice conto
            if (
              col === "Descrizione Cod. Conto" ||
              col === "Descrizione Cod. Conto 2"
            ) {
              const value = row[colIndex];
              if (!value || String(value).trim() === "") {
                this.$set(row, colIndex, "NESSUNA CORRELAZIONE");
              }
            }
          });
        });
      };

      // Vettore principale
      fill(this.vettoreCodConto, this.getValidColumns() || []);

      // Vettore PDC (se esiste)
      if (
        Array.isArray(this.vettoreCodContoPDC) &&
        this.vettoreCodContoPDC.length > 0
      ) {
        fill(
          this.vettoreCodContoPDC,
          this.validColumnsPDC || this.getValidColumns() || []
        );
      }

      this.showErrorModal = false;
    },
    selezionaColonna(colonna) {
      this.vettoreClienti_SEAC = selectSeacAccountingType(
        this.vettoreClienti_SEAC,
        colonna
      );
    },
    nextConversionStep(requestId = this.activeScanRequestId) {
      setTimeout(() => {
        if (this.isStaleScanRequest(requestId)) return;
        this.showResult = true; // Applica la classe "show" per farlo comparire
      }, 1000); // Ritardo della transizione per il secondo contenitore
    },
    loadUserPreferredSoftware() {
      const settings = getUserSettings();
      const saved = settings.software_contabile || "default";

      const mapping = {
        TEAMSYSTEM: "TEAMSYSTEM",
        DATEV: "DATEV",
        ZUCCHETTI: "ZUCCHETTI",
        SISTEMI: "SISTEMI",
        SEAC: "SEAC",
      };

      if (mapping[saved]) {
        this.output_PC = mapping[saved];
        this.selectedSoftware = mapping[saved];
        this.selectedSoftwareAddRow = mapping[saved];
        this.selectedAddRowSoftwares = [mapping[saved]];
      } else {
        this.selectedSoftware = "ALL";
      }
    },
    async uploadFile(payload = null) {
      const file = payload?.file || this.selectedPiano;
      if (!file) return;
      if (!this.validateUploadPdcTarget()) return;

      this.uploading = true;

      try {
        const clientKey = await this.ensureUploadClientKey();
        const isClientUpload = Boolean(clientKey);
        const fileKind = this.isPdcArchiveView ? "archive" : "pdc";
        const formData = new FormData();
        formData.append("file", file);
        if (isClientUpload) {
          formData.append("client_key", clientKey);
          formData.append("file_kind", fileKind);
        }

        const endpoint = isClientUpload
          ? "/update_excel/client_pdc"
          : this.isPdcArchiveView
          ? "/upload_excel_madre"
          : "/upload_PDC";

        const response = await axios.post(
          `${API_BASE_URL}${endpoint}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status === 200) {
          this.selectedPdcViewKey = isClientUpload
            ? `client:${clientKey}`
            : "main";
          this.selectedPdcFileKey = fileKind;
          await this.fetchClientPdcPlans([
            { fileKey: fileKind, viewKey: this.selectedPdcViewKey },
          ]);
          await this.fetchCurrentLibraryFile();
          this.refreshDashboard();

          this.successModalMessaggio = this.isPdcArchiveView
            ? "Archivio caricato con successo!"
            : "Piano caricato con successo!";
          this.successModalVisibile = true;
          this.showAddPiano = false;
          this.selectedPiano = null;
          this.rows = [];
        }
      } catch (error) {
        console.error(
          "Errore durante il caricamento del Piano dei Conti:",
          error
        );

        let msg = "Errore durante il caricamento del file.";

        if (error.response) {
          const status = error.response.status;
          const data = error.response.data;

          if (status === 400) {
            msg = data?.error || "Il file non rispetta la struttura richiesta.";
          } else if (status === 401) {
            msg = "Sessione scaduta. Effettua nuovamente il login.";
          } else if (status === 404) {
            msg = "Utente non trovato.";
          } else if (status === 413) {
            msg = "File troppo grande.";
          } else if (status === 500) {
            msg = data?.error || "Errore interno del server.";
          } else {
            msg = data?.error || "Errore sconosciuto dal server.";
          }
        } else if (error.message) {
          msg = `Errore di rete: ${error.message}`;
        }

        // ← MOSTRA IL MODAL DI ERRORE
        this.erroreModalMessaggio = msg;
        this.erroreModalVisibile = true;
      } finally {
        this.uploading = false;
      }
    },

    isEditableColumn(colIndex) {
      if (this.input_PC === "SEAC" && colIndex === 1) {
        return true;
      }
      if (
        this.isEditMode &&
        (colIndex === 1 || colIndex === 8 || colIndex === 9)
      ) {
        return true;
      }
      return colIndex >= 2 && colIndex <= 7;
    },
    isEditableColumnPDC(colIndex) {
      if (this.input_PC === "SEAC" && colIndex === 1) {
        return true;
      }
      if (
        this.isEditModePDC &&
        (colIndex === 1 || colIndex === 8 || colIndex === 9)
      ) {
        return true;
      }
      return colIndex >= 2 && colIndex <= 7;
    },
    isEditableColumntable(colIndex) {
      return colIndex >= 1 && colIndex <= 7;
    },
    isCellModified(row, col) {
      return this.modifiedCells[`${row}-${col}`] === true;
    },
    rebuildCellStates() {
      const newModified = {};
      const newErrors = {};

      const numRows = Math.min(this.jsonData.length, this.lastSavedData.length);
      const numCols = this.headers.length;

      for (let rowIndex = 0; rowIndex < numRows; rowIndex++) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          const current = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          const original = this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";

          if (String(current) !== String(original)) {
            newModified[key] = true;
          }

          // Validazione colonne Datev
          const columnName = this.headers[colIndex];
          const numericValue = String(current).replace(/\D/g, "");
          const isDatev =
            columnName === "Cod. Conto - Datev Aziende" ||
            columnName === "Cod. Conto - Datev Lib. Prof.";

          if (
            isDatev &&
            numericValue.length > 0 &&
            (numericValue.length < 5 || numericValue.length > 11)
          ) {
            newErrors[key] = true;
          }
        }
      }

      // Righe aggiunte segnate come modificate
      for (
        let rowIndex = numRows;
        rowIndex < this.jsonData.length;
        rowIndex++
      ) {
        for (let colIndex = 0; colIndex < numCols; colIndex++) {
          const key = `${rowIndex}-${colIndex}`;
          newModified[key] = true;
        }
      }

      // Aggiorna reactive
      this.modifiedCells = newModified;
      this.errors = newErrors;
    },
    getDisplayedRowIndex(rowIndex) {
      return this.filteredDisplayRows.findIndex(
        (row) => row.originalIndex === rowIndex
      );
    },
    isMainTableColumnVisible(colIndex) {
      return colIndex === 1 || this.visibleColumns.includes(colIndex);
    },
    updateCell(rowIndex, colIndex, value) {
      const table = document.getElementById("excelTable");
      const cell = table?.querySelector(
        `[data-row-index="${rowIndex}"][data-col-index="${colIndex}"]`
      );
      if (!cell) return;

      const columnName = this.headers[colIndex] || "";
      const isDescriptionColumn = columnName.includes("Descrizione");

      // --- LOGICA "N.A." universale (escluse tutte le colonne descrittive) ---
      if (!isDescriptionColumn) {
        const previousValue = this.jsonData[rowIndex][colIndex] || "";
        const isEmptyOrNA =
          previousValue.trim() === "" ||
          previousValue.trim().toUpperCase() === "N.A.";
        const hasLetters = /[a-zA-Z]/.test(value);
        const hasNumbers = /\d/.test(value);

        if (isEmptyOrNA && hasLetters && !hasNumbers) {
          this.jsonData[rowIndex][colIndex] = "N.A.";
          if (cell) cell.innerText = "N.A.";

          this.$delete(this.errors, `${rowIndex}-${colIndex}`);

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== "N.A.") {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );

          this.$forceUpdate();
          return;
        }
      }

      if (isDescriptionColumn) {
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;
        const isValid = value !== ""; // Valida se la cella non è vuota

        this.$nextTick(() => {
          if (cell) {
            cell.innerText = value;

            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, value.length)
            );
            range.collapse(true);
            const newSelection = window.getSelection();
            newSelection.removeAllRanges();
            newSelection.addRange(range);

            // Gestione errori: evidenzia se la cella è vuota
            if (!isValid) {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }
          }

          this.jsonData[rowIndex][colIndex] = value || "";

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });

        return;
      }
      // Gestione formattazione specifica per TeamSystem, SEAC e Sistemi
      if (colIndex === 2 || colIndex === 6 || colIndex === 7) {
        let formattedValue = value.replace(/\D/g, ""); // Rimuove tutti i caratteri non numerici
        const selection = window.getSelection();
        let cursorPosition = selection?.anchorOffset || 0;
        let oldSeparatorCount = 0;
        let newSeparatorCount = 0;
        let isValid = true;

        if (colIndex === 2) {
          // TeamSystem: formato XX/XX/XXX, limite 7 numeri
          oldSeparatorCount = (value.match(/\//g) || []).length;
          formattedValue = formattedValue.slice(0, 7);
          if (formattedValue.length >= 5) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}/${formattedValue.slice(2, 4)}/${formattedValue.slice(4)}`;
            newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          } else if (formattedValue.length >= 3) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}/${formattedValue.slice(2)}`;
            newSeparatorCount = (formattedValue.match(/\//g) || []).length;
          }
          // Validazione TeamSystem
          const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
          isValid =
            formattedValue === "" || teamSystemRegex.test(formattedValue);
        } else if (colIndex === 6) {
          // SEAC: solo numeri, esattamente 6 cifre
          formattedValue = formattedValue.slice(0, 6);
          isValid = formattedValue === "" || formattedValue.length === 6;
        } else if (colIndex === 7) {
          // Sistemi: formato XX.XX.XX o XX.XX.XX.XXX, limite 9 numeri
          oldSeparatorCount = (value.match(/\./g) || []).length;
          formattedValue = formattedValue.slice(0, 9);
          if (formattedValue.length >= 7) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(
              4,
              6
            )}.${formattedValue.slice(6)}`;
            newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          } else if (formattedValue.length >= 5) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2, 4)}.${formattedValue.slice(4)}`;
            newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          } else if (formattedValue.length >= 3) {
            formattedValue = `${formattedValue.slice(
              0,
              2
            )}.${formattedValue.slice(2)}`;
            newSeparatorCount = (formattedValue.match(/\./g) || []).length;
          }
          // Validazione Sistemi
          const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;
          isValid = formattedValue === "" || sistemiRegex.test(formattedValue);
        }

        if (this.isCodContoDefault(formattedValue)) {
          isValid = false;
        }

        // Aggiusta la posizione del cursore in base ai separatori aggiunti
        cursorPosition += newSeparatorCount - oldSeparatorCount;

        this.$nextTick(() => {
          if (cell) {
            cell.innerText = formattedValue;
            const range = document.createRange();
            range.setStart(
              cell.firstChild || cell,
              Math.min(cursorPosition, formattedValue.length)
            );
            range.collapse(true);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);

            // Gestione errori: non impostare errori per celle vuote
            if (!isValid && formattedValue !== "") {
              this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
            } else {
              this.$delete(this.errors, `${rowIndex}-${colIndex}`);
            }
          }

          // Salva SEMPRE il valore (anche se errato) in jsonData
          this.jsonData[rowIndex][colIndex] = formattedValue || "";

          const originalValue =
            this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
          const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";

          if (String(originalValue) !== String(currentValue)) {
            this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
          }

          this.hasUnsavedChanges = !this.isDataEqual(
            this.jsonData,
            this.lastSavedData
          );
        });

        return;
      }

      // Altre colonne (es. Datev)
      const selection = window.getSelection();
      let cursorPosition = selection?.anchorOffset || 0;
      const isDatev =
        columnName === "Cod. Conto - Datev Aziende" ||
        columnName === "Cod. Conto - Datev Lib. Prof.";
      const numericValue = isDatev
        ? value.replace(/\D/g, "").slice(0, 11)
        : value.replace(/\D/g, "");
      const isValid =
        !isDatev ||
        numericValue.length === 0 ||
        (numericValue.length >= 5 && numericValue.length <= 11);
      const isReservedDefault = this.isCodContoDefault(numericValue);

      this.$nextTick(() => {
        if (cell) {
          // Aggiorna il contenuto della cella
          cell.innerText = numericValue;

          // Riposiziona il cursore
          const range = document.createRange();
          range.setStart(
            cell.firstChild || cell,
            Math.min(cursorPosition, numericValue.length)
          );
          range.collapse(true);
          const newSelection = window.getSelection();
          newSelection.removeAllRanges();
          newSelection.addRange(range);

          // Gestione errori: non impostare errori per celle vuote
          if ((!isValid || isReservedDefault) && numericValue !== "") {
            this.$set(this.errors, `${rowIndex}-${colIndex}`, true);
          } else {
            this.$delete(this.errors, `${rowIndex}-${colIndex}`);
          }
        }

        // Salva SEMPRE il valore (anche se errato)
        this.jsonData[rowIndex][colIndex] = numericValue || "";

        const originalValue = this.lastSavedData?.[rowIndex]?.[colIndex] ?? "";
        const currentValue = this.jsonData?.[rowIndex]?.[colIndex] ?? "";
        if (String(originalValue) !== String(currentValue)) {
          this.$set(this.modifiedCells, `${rowIndex}-${colIndex}`, true);
        } else {
          this.$delete(this.modifiedCells, `${rowIndex}-${colIndex}`);
        }

        this.hasUnsavedChanges = !this.isDataEqual(
          this.jsonData,
          this.lastSavedData
        );
      });
    },

    isDataEqual(data1, data2) {
      // Verifica che i dati abbiano la stessa struttura
      if (!data1 || !data2 || data1.length !== data2.length) return false;

      // Converti tutti i valori in stringa, trattando null e undefined come ""
      const stringifyData1 = JSON.stringify(
        data1.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      const stringifyData2 = JSON.stringify(
        data2.map((row) =>
          row.map((cell) =>
            cell !== null && cell !== undefined ? String(cell) : ""
          )
        )
      );
      return stringifyData1 === stringifyData2;
    },
    preventNonNumeric(event) {
      // Blocca i tasti che non sono numeri (0-9)
      if (
        !/[0-9]/.test(event.key) &&
        event.key !== "Backspace" &&
        event.key !== "Tab" &&
        event.key !== "ArrowLeft" &&
        event.key !== "ArrowRight"
      ) {
        event.preventDefault(); // Blocca l'input
      }
    },
    showTooltip(rowIndex, colIndex, row) {
      if (colIndex === 1 && rowIndex !== 0) {
        console.log(
          "Row data:",
          row,
          "Comparing row[1]:",
          row[1],
          "with row[0]:",
          row[0]
        );
        if (row[1] !== row[0]) {
          this.tooltip = {
            visible: true,
            content: row[0] || "", // Evita valori undefined
            rowIndex: rowIndex,
          };
        } else {
          this.tooltip = {
            visible: false,
            content: "",
            rowIndex: null,
          };
        }
      }
    },
    hideTooltip() {
      this.tooltip.visible = false;
      this.tooltip.content = "";
      this.tooltip.rowIndex = null;
    },
    restoreOriginalDescription(rowIndex) {
      const row = this.jsonData?.[rowIndex];
      if (!Array.isArray(row)) return;

      const originalDescription = row[0] || "";
      this.$set(row, 1, originalDescription);
      this.$delete(this.errors, `${rowIndex}-1`);

      const savedValue = this.lastSavedData?.[rowIndex]?.[1] ?? "";
      if (String(savedValue) !== String(originalDescription)) {
        this.$set(this.modifiedCells, `${rowIndex}-1`, true);
      } else {
        this.$delete(this.modifiedCells, `${rowIndex}-1`);
      }

      this.hasUnsavedChanges = !this.isDataEqual(
        this.jsonData,
        this.lastSavedData
      );
      this.hideTooltip();
    },
    toggleInvitiDropdown() {
      this.showInvitiDropdown = !this.showInvitiDropdown;
    },
    toggleEditing() {
      if (!this.hasDataRows) {
        this.isEditing = false;
        return;
      }

      if (!this.isEditing) {
        this.isEditing = true;
      }
    },
    isDescrizioneCodContoColumn(headerName) {
      const nomeContoLabels = [
        "Descrizione Cod. Conto",
        "Descrizione Cod. Conto - Datev Aziende",
        "Descrizione Cod. Conto - Datev Lib. Prof.",
        "Descrizione Cod. Conto - TeamSystem",
        "Descrizione Cod. Conto - Zucchetti",
        "Descrizione Cod. Conto - SEAC",
        "Descrizione Cod. Conto - Sistemi",
        "Descrizione - Cod. Conto Default",
      ];
      return nomeContoLabels.includes(headerName);
    },
    handleClickOutside(event) {
      this.closePdcFilterDropdownsOnOutsideClick(event);
      const target = event.target;
      const isArchiveMenuInside = this.$refs.archiveMenuRef?.contains(target);
      const isPdcLibraryMenuInside =
        this.$refs.pdcLibraryMenuRef?.contains(target);
      const isMainInside =
        this.$refs.exceltableRef?.contains(target) ||
        this.$refs.dashboardRef?.contains(target) ||
        this.$refs.pdcViewSelectorRef?.contains(target) ||
        isPdcLibraryMenuInside ||
        this.$refs.softwareSelectPdc?.contains(target) ||
        target?.closest?.("#softwareSelectPdc");

      if (this.isEditing && !isMainInside) {
        this.isEditing = false;
        console.log("isEditing resettato a false da handleClickOutside");
      }

      if (this.archiveMenuOpen && !isArchiveMenuInside) {
        this.archiveMenuOpen = false;
      }

      if (this.pdcLibraryMenuOpen && !isPdcLibraryMenuInside) {
        this.pdcLibraryMenuOpen = false;
      }
    },
    toggleArchiveMenu() {
      this.archiveMenuOpen = !this.archiveMenuOpen;
    },
    openArchiveMadre() {
      this.archiveMenuOpen = false;
      this.fetchMadrePDC();
    },
    getHeaderText(header) {
      // Mappa il testo degli header
      if (header === "Descrizione Cod. Conto Originale") {
        return "Descrizione Cod. Conto Prospetto Paghe";
      } else if (header === "Descrizione Cod. Conto") {
        return "Descrizione Cod. Conto personalizzata";
      }
      return header; // Restituisci l'header originale se non ci sono modifiche
    },
    getTooltip(header) {
      // Restituisci il testo del tooltip in base all'header
      if (header === "Descrizione Cod. Conto Originale") {
        return "Descrizione che troverai nell'elaborazione del Prospetto Paghe";
      } else if (header === "Descrizione Cod. Conto") {
        return "La descrizione che utilizzi nel tuo Piano dei Conti. Può anche coincidere con la Descrizione Cod. Conto Prospetto Paghe";
      }
      return ""; // Nessun tooltip per gli altri header
    },
    showTooltipIcon(header) {
      // Mostra l'icona del tooltip solo per gli header specificati
      return (
        header === "Descrizione Cod. Conto Originale" ||
        header === "Descrizione Cod. Conto"
      );
    },
    saveChanges(event, skipDeletionConfirmation = false) {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      // Controlla se ci sono errori attivi nelle celle
      if (Object.keys(this.errors).length > 0) {
        this.erroreModalMessaggio =
          "Correggi i codici conto evidenziati in rosso per salvare le modifiche.";
        this.erroreModalVisibile = true;
        return; // blocca il salvataggio
      }
      const pendingDeletionCount = this.getPendingDeletionCount();
      if (!skipDeletionConfirmation && pendingDeletionCount > 0) {
        this.confirmSaveWithPendingDeletions(pendingDeletionCount, () =>
          this.saveChanges(event, true)
        );
        return;
      }
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event && event.target) {
        event.target.style.cursor = "progress";
      }
      // Creazione di un nuovo workbook e sheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(this.jsonData);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // Creazione del file Excel in formato blob
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const excelBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Creazione del FormData per l'invio del file
      const formData = new FormData();
      formData.append("file", excelBlob, "piano_dei_conti_modificato.xlsx");
      if (this.currentPdcIsClient) {
        formData.append("client_key", this.selectedClientPdcKey);
      }

      // Invio al backend con axios
      axios
        .post(
          `${API_BASE_URL}${
            this.currentPdcIsClient
              ? "/update_excel/client_pdc"
              : "/update_excel"
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.successModalMessaggio = this.currentPdcIsClient
            ? "Piano cliente salvato con successo!"
            : "Modifiche salvate con successo!";
          this.successModalVisibile = true;
          this.lastSavedData = JSON.parse(JSON.stringify(this.jsonData));
          this.pendingDeletedRowCount = 0;
          this.modifiedCells = {};
          this.errors = {};
          this.finalizeAllRows();
          this.hasUnsavedChanges = false;
          // Carica i dati aggiornati
          this.messageToShow = "dataLoaded"; // Mostra "Dati caricati correttamente"
          return this.fetchFileFromBackend()
            .then(() => this.fetchClientPdcPlans())
            .finally(() => {
              this.refreshDashboard();
            });
        })
        .catch((error) => {
          console.error("Errore nel salvataggio del file:", error);
          this.erroreModalMessaggio =
            error.response?.data?.error || "Errore nel salvataggio del file.";
          this.erroreModalVisibile = true;
          this.messageToShow = null;
        })
        .finally(() => {
          document.documentElement.style.cursor = "default";
          document.body.style.cursor = "default";
          if (event && event.target) {
            event.target.style.cursor = "pointer";
          }
        });
    },
    handleSaveBeforeLeave() {
      const fakeEvent = { target: { style: { cursor: "pointer" } } };

      if (this.isLeavingDueToMadreChanges) {
        this.saveChangesMadre(fakeEvent);
      } else {
        this.saveChanges(fakeEvent);
      }

      this.showSaveModal = false;
      this.pendingNavigationAfterSuccess = true; // aspettiamo il successo per navigare
    },
    attemptCloseMadreModal() {
      if (!this.hasUnsavedChangesMadre) {
        // Nessuna modifica → chiudi subito
        this.madreModalVisible = false;
        return;
      }

      // Ci sono modifiche → apri il modal di conferma
      this.isLeavingDueToMadreChanges = true; // flag già introdotto prima
      this.showSaveModal = true;
      // NON impostiamo nextRoute qui, perché non stiamo navigando con router
      // ma vogliamo solo chiudere il modal madre dopo salvataggio/annulla
    },
    cancelLeave() {
      this.showSaveModal = false;
      this.nextRoute = null;
      this.isLeavingDueToMadreChanges = false;
      this.pendingNavigationAfterSuccess = false;
    },
    discardChangesAndLeave() {
      if (this.isLeavingDueToMadreChanges) {
        this.cancelChangesMadre();
        this.madreModalVisible = false;
      } else {
        this.cancelChanges();
      }

      this.showSaveModal = false;
      this.isLeavingDueToMadreChanges = false;

      if (this.nextRoute) {
        const proceed = this.nextRoute;
        this.nextRoute = null;
        proceed();
      }
    },
    onSuccessModalClosed() {
      this.successModalVisibile = false;

      // Esegui azione post-salvataggio in base al contesto
      if (this.pendingNavigationAfterSuccess && this.nextRoute) {
        const proceed = this.nextRoute;
        this.nextRoute = null;
        proceed();
      }

      if (this.isLeavingDueToMadreChanges) {
        this.madreModalVisible = false;
      }

      // Reset di tutti gli stati "in attesa"
      this.pendingNavigationAfterSuccess = false;
      this.isLeavingDueToMadreChanges = false;
    },
    toggleTableExpansion() {
      this.isTableExpanded = !this.isTableExpanded;
    },
    toggleTablePDCExpansion() {
      this.isTablePDCExpanded = !this.isTablePDCExpanded;
    },
    mostraSuccesso(msg) {
      this.successModalMessaggio = msg;
      this.successModalVisibile = true;
    },
    mostraErrore(msg) {
      this.erroreModalMessaggio = msg;
      this.erroreModalVisibile = true;
    },
    cancelChanges() {
      if (!this.hasUnsavedChanges) {
        this.noChangesMessage = true;
        setTimeout(() => {
          this.noChangesMessage = false;
        }, 2000);
        return;
      }
      this.jsonData = JSON.parse(JSON.stringify(this.lastSavedData));
      this.tableKey++; // Forza il re-render della tabella
      this.hasUnsavedChanges = false;
      this.pendingDeletedRowCount = 0;
      this.finalizeAllRows();
      this.rebuildCellStates();
      this.refreshDashboard();
    },
    refreshAddRow() {
      this.showAddRow = false;
      this.newRow = Array(this.currentAddRowHeaders.length).fill("");
    },
    openAddRowModal() {
      const headers = this.currentAddRowHeaders;
      if (!headers.length) return;

      this.showAddRow = true;
      this.showAddBilancino = false;
      this.showAddPiano = false;

      if (this.newRow.length !== headers.length) {
        this.newRow = Array(headers.length).fill("");
      }

      if (this.isPdcArchiveView) {
        const currentSoftware =
          this.selectedSoftware && this.selectedSoftware !== "ALL"
            ? this.selectedSoftware
            : this.selectedSoftwareAddRow;
        const defaultSoftware = this.addRowSoftwareOptions.some(
          (option) => option.value === currentSoftware
        )
          ? currentSoftware
          : "TEAMSYSTEM";
        this.$set(this.newRow, 0, defaultSoftware);
        this.selectedAddRowSoftwares = [];
        return;
      }

      if (!this.selectedAddRowSoftwares.length) {
        this.selectedAddRowSoftwares = [
          this.selectedSoftwareAddRow || "TEAMSYSTEM",
        ];
      }
    },
    updateSelectedAddRowSoftwares(softwares) {
      this.selectedAddRowSoftwares = softwares;
      if (softwares.length) {
        this.selectedSoftwareAddRow = softwares[0];
      }
    },
    handleAddRowFieldInput({ index, value, format }) {
      if (this.isPdcArchiveView) {
        this.$set(
          this.newRow,
          index,
          format
            ? this.formatLibraryAccountCode(
                value,
                this.newRow[0] || this.selectedSoftware
              )
            : value
        );
        return;
      }

      if (format) {
        this.formatCodiceConto({ target: { value } }, index);
        return;
      }

      this.$set(this.newRow, index, value);
    },
    refreshAddBilancino() {
      this.vettoreCodConto = [];
      this.vettoreCodContoPDC = [];
      this.resetPdcClientState();
      this.ExcelRows = [];
      this.showResult = false;
      this.showAddBilancino = false;
      this.isShifted = false;
      this.input_PC = "";
      this.output_PC = "";
      this.editPDCresponse = false;
      this.selectedFile = null;
      this.bilancinoFile = null;
      this.filePDF_URL = null;
      this.loadUserPreferredSoftware();
      if (this.$refs.bilancinoInput) {
        this.$refs.bilancinoInput.value = "";
      }
    },
    isStaleScanRequest(requestId) {
      return requestId !== this.activeScanRequestId;
    },
    openScanResetConfirm(mode = "full") {
      this.pendingScanResetMode = mode;
      this.showScanResetConfirmModal = true;
    },
    async confirmScanReset() {
      this.showScanResetConfirmModal = false;
      this.isResettingScan = true;
      this.activeScanRequestId += 1;
      this.clearDelayMessageTimer();
      this.resetScanState(this.pendingScanResetMode === "full");
      await new Promise((resolve) => setTimeout(resolve, 280));
      this.isResettingScan = false;
      this.pendingScanResetMode = "full";
    },
    resetScanState(clearFile = true) {
      this.vettoreCodConto = [];
      this.vettoreCodContoPDC = [];
      this.resetPdcClientState();
      (this.vettorePDCVisible = false), (this.ExcelRows = []);
      this.isShifted = false;
      this.input_PC = "";
      this.output_PC = "";
      this.errorMessage = "";
      this.showErrorModal = false;
      this.fase1_SEAC = false;
      this.vettoreClienti_SEAC = [];
      this.originalPDC = null;
      this.selectedFile = null;
      if (clearFile) {
        this.bilancinoFile = null;
        this.filePDF_URL = null;
      }
      if (clearFile && this.$refs.bilancinoInput) {
        this.$refs.bilancinoInput.value = "";
      }
      this.showResult = false;
      this.editPDCresponse = false;
      this.calculating = false;
      this.calculating2 = false;
      this.loadUserPreferredSoftware();
    },
    refreshConversione() {
      if (this.calculating || this.calculating2) {
        this.openScanResetConfirm("full");
        return;
      }
      this.resetScanState(true);
    },
    refreshConversione2() {
      if (this.calculating || this.calculating2) {
        this.openScanResetConfirm("soft");
        return;
      }
      this.resetScanState(false);
    },
    deleteRow(rowIndex, event) {
      this.performDeleteRow(rowIndex, event);
    },
    performDeleteRow(rowIndex, event) {
      // 🔹 Imposta il cursore su "wait" su tutto il documento (HTML + Body)
      document.documentElement.style.cursor = "progress";
      document.body.style.cursor = "progress";
      if (event?.target) event.target.style.cursor = "progress";
      // Mostra il messaggio di eliminazione per la riga specifica
      this.deletedRows = { ...this.deletedRows, [rowIndex]: true };
      // Attiva la classe per rendere il pulsante rosso
      this.$set(this.activeDelete, rowIndex, true);
      const isProvisionalRow = this.provisionalRows.includes(rowIndex);
      if (!isProvisionalRow) {
        this.pendingDeletedRowCount += 1;
      }

      setTimeout(() => {
        // 1) Rimuovi la riga dai dati
        this.jsonData.splice(rowIndex, 1);

        // 2) Ripulisci e riallinea provisionalRows
        this.provisionalRows = this.provisionalRows
          .filter((i) => i !== rowIndex) // togli la riga cancellata
          .map((i) => (i > rowIndex ? i - 1 : i)); // shift index delle righe successive

        // 3) Ricostruisci modifiedCells spostando gli indici > rowIndex
        const newModified = {};
        Object.keys(this.modifiedCells).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return; // skip la riga cancellata
          const newRow = r > rowIndex ? r - 1 : r;
          newModified[`${newRow}-${c}`] = this.modifiedCells[key];
        });
        this.modifiedCells = newModified;

        // 4) Stessa cosa per gli errori
        const newErrors = {};
        Object.keys(this.errors).forEach((key) => {
          const [r, c] = key.split("-").map(Number);
          if (r === rowIndex) return;
          const newRow = r > rowIndex ? r - 1 : r;
          newErrors[`${newRow}-${c}`] = this.errors[key];
        });
        this.errors = newErrors;

        // 5) Ripristina hover/delete-button e cursore
        this.hoveredRow = null;
        this.$delete(this.deletedRows, rowIndex);
        this.$delete(this.activeDelete, rowIndex);

        this.tableKey++;
        // 6) Aggiorna hasUnsavedChanges
        this.hasUnsavedChanges = !this.isDataEqual(
          this.jsonData,
          this.lastSavedData
        );
        if (!this.hasDataRows) {
          this.isEditing = false;
        }

        // 7) Ripristina cursore a default
        document.documentElement.style.cursor = "default";
        document.body.style.cursor = "default";
        if (event?.target) event.target.style.cursor = "pointer";
      }, 700);
    },
    deleteAllExceptFirst(event) {
      this.confirmModalTitle = "Elimina Piano dei Conti";
      this.confirmModalShowArchiveOption = true;
      this.deleteArchiveAlongWithPdc = false;
      this.confirmModalConfirmClass = "btn-danger";
      this.confirmModalConfirmIcon = "";
      this.confirmModalVisibile = true;
      this.confirmModalMessaggio =
        "Sei sicuro di voler eliminare il Piano dei Conti?\nTutti i dati salvati andranno persi";
      this.confirmModalCallback = (confirmed) => {
        const deleteArchiveAlongWithPdc = this.deleteArchiveAlongWithPdc;
        if (confirmed) {
          // L'utente ha cliccato "Sì"
          document.documentElement.style.cursor = "progress";
          document.body.style.cursor = "progress";
          event.target.style.cursor = "progress";

          axios
            .post(`${API_BASE_URL}/delete_PDC`, {
              delete_archive: deleteArchiveAlongWithPdc,
            })
            .then((deleteResponse) => {
              console.log(
                "Risposta eliminazione file:",
                deleteResponse.data.message
              );
              // Svuota jsonData e aggiorna la tabella
              this.jsonData = [];
              this.messageToShow = "noRows"; // Mostra "Nessun codice conto presente"
              this.tableKey += 1; // Forza il re-render della tabella
              if (deleteArchiveAlongWithPdc) {
                this.madreJsonData = [[]];
                this.madreLastSavedData = [];
                this.modifiedCellsMadre = {};
                this.errorsMadre = {};
                this.hasUnsavedChangesMadre = false;
                this.madreModalVisible = false;
                this.successModalMessaggio =
                  "Piano dei Conti e Archivio Descrizioni Cod. Conto eliminati con successo!";
              } else {
                this.successModalMessaggio =
                  "Piano dei Conti eliminato con successo!";
              }
              this.successModalVisibile = true;
              this.hasUnsavedChanges = false;
            })
            .catch((deleteError) => {
              console.error(
                "Errore durante l'eliminazione del file:",
                deleteError
              );
              if (deleteError.response?.status === 500) {
                alert(
                  "Errore durante l'eliminazione del file: " +
                    (deleteError.response?.data?.error || "Errore sconosciuto")
                );
              }
            })
            .finally(() => {
              this.refreshAddBilancino();
              document.documentElement.style.cursor = "default";
              document.body.style.cursor = "default";
              event.target.style.cursor = "pointer";
            });
        }
        // Chiudi il modal in ogni caso
        this.resetConfirmModal();
      };
    },
    // Messaggio di errore in caso di inserimento non valido
    getErrorMessage(index) {
      if (index === 1) {
        return "Il formato del Codice Conto TeamSystem deve essere: XX/XX/XXX.";
      } else if (index === 2 || index === 3) {
        return "Il Codice Conto Datev deve essere un numero da 5 a 11 cifre";
      } else if (index === 4) {
        return "Il Codice Conto Zucchetti deve essere un numero";
      } else if (index === 0) {
        return "Inserisci la descrizione del codice conto.";
      }
      return "";
    },
    // Placeholder per i campi
    getPlaceholder(index) {
      if (index === 0 || index === 1) {
        return "Descrizione"; // Placeholder per Descrizione Codice Conto
      } else if (
        index === 2 ||
        index === 3 ||
        index === 4 ||
        index === 5 ||
        index === 6 ||
        index === 7
      ) {
        return "Codice Conto"; // Placeholder per gli altri Codici Conto
      }
      return "";
    },

    // Funzione per la validazione
    validateRow() {
      const errors = [];
      const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
      const seacRegex = /^\d{6}$/; // SEAC: esattamente 6 cifre
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      // Validazione per Descrizione Cod. Conto Originale (newRow[0]) - Obbligatorio
      if (!this.newRow[0]?.trim()) {
        errors.push("• Descrizione Cod. Conto da individuare mancante.");
      }

      // Validazione per Descrizione Cod. Conto (newRow[1]) - Già presente
      if (!this.newRow[1]?.trim()) {
        errors.push("• Descrizione Cod. Conto personalizzata mancante.");
      }

      // Controlla se la descrizione esiste già
      const descrizioneInserita = this.newRow[1]?.trim();
      const descrizioniEsistenti = this.jsonData
        .slice(1) // Salta l'intestazione
        .map((row) => row[1]?.trim());
      if (
        descrizioneInserita &&
        descrizioniEsistenti.includes(descrizioneInserita)
      ) {
        errors.push("• Esiste già una riga con questa descrizione.");
      }

      // Validazione per il Codice Conto TeamSystem (newRow[2])
      if (
        this.newRow[2]?.trim() &&
        !teamSystemRegex.test(this.newRow[2].trim())
      ) {
        errors.push(
          "• Il formato del Codice Conto TeamSystem deve essere: XX/XX/XXX"
        );
      }

      // Validazione dei Codici Conto (Datev, Liberi Professionisti, Zucchetti)
      const numberRegex = /^\d+$/;
      const codiceContoIndexes = [3, 4, 5]; // Indici per Datev, Liberi Professionisti, Zucchetti
      for (let i of codiceContoIndexes) {
        const value = this.newRow[i]?.trim();
        if (value && !numberRegex.test(value)) {
          errors.push(
            `• Il Codice Conto alla colonna ${
              i + 1
            } deve essere un numero intero.`
          );
        } else if (value && [3, 4].includes(i) && value.length > 11) {
          errors.push(
            `â€¢ Il Codice Conto Datev alla colonna ${
              i + 1
            } deve contenere massimo 11 cifre.`
          );
        }
      }

      // Validazione SEAC (newRow[6])
      if (this.newRow[6]?.trim() && !seacRegex.test(this.newRow[6].trim())) {
        errors.push(
          "• Il Codice Conto SEAC deve contenere esattamente 6 cifre."
        );
      }

      // Validazione Sistemi (newRow[7])
      if (this.newRow[7]?.trim() && !sistemiRegex.test(this.newRow[7].trim())) {
        errors.push(
          "• Il Codice Conto Sistemi deve essere nel formato XX.XX.XX oppure XX.XX.XX.XXX"
        );
      }

      // Controlla se almeno uno dei campi dei codici conto (da newRow[2] a newRow[7]) è compilato
      for (let i = 2; i <= 7; i += 1) {
        const value = this.newRow[i]?.trim();
        if (value && this.isCodContoDefault(value)) {
          errors.push(
            `- Il codice conto ${this.codContoDefault} e riservato e non puo essere salvato.`
          );
          break;
        }
      }

      const codiciContoCompilati = this.newRow
        .slice(2, 8) // Indici 2, 3, 4, 5, 6, 7
        .some((val) => val?.trim() !== "");
      if (!codiciContoCompilati) {
        errors.push("• Inserisci almeno un codice conto.");
      }

      // Mostra errori, se presenti
      if (errors.length > 0) {
        this.erroreModalMessaggio = errors.join("\n");
        this.erroreModalVisibile = true;
        return false;
      }

      return true;
    },
    toggleEditMode() {
      this.isEditMode = !this.isEditMode; // Toggle edit mode
    },
    toggleEditModePDC() {
      this.isEditModePDC = !this.isEditModePDC; // Toggle edit mode
    },
    // BLOCCA lettere se c'è già un numero
    blockLetters(event, rowIndex, colKey, colIndex, vettore) {
      const headerName = this.filteredHeaders[colIndex]; // o filteredHeaders
      if (!headerName || !headerName.includes("Cod. conto")) {
        return; // ← NON fare nulla → permetti tutto
      }
      const currentValue = vettore[rowIndex][colKey] || "";
      const hasNumbers = /\d/.test(currentValue);
      // === Gestione speciale per Backspace/Delete su "N.A." ===
      if (
        currentValue === "N.A." &&
        (event.key === "Backspace" || event.key === "Delete")
      ) {
        event.preventDefault(); // Blocca il comportamento di default
        this.$set(vettore[rowIndex], colKey, ""); // Svuota la cella
        return; // Esci subito
      }
      // Se c'è almeno un numero → BLOCCA tutte le lettere
      if (hasNumbers) {
        const key = event.key;

        // Tasti sempre permessi
        const allowed = [
          "Backspace",
          "Delete",
          "Tab",
          "Escape",
          "Enter",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
        ];

        // Ctrl+C, Ctrl+V, Ctrl+A, Ctrl+Z
        if (event.ctrlKey || event.metaKey) return;

        // Se non è numero e non è tasto permesso → BLOCCA
        if (!allowed.includes(key) && !/[0-9]/.test(key)) {
          event.preventDefault();
        }
      }
    },
    blockPaste(event, colIndex) {
      const headerName = this.filteredHeaders[colIndex];
      if (!headerName || !headerName.includes("Cod. conto")) {
        return;
      }
      event.preventDefault();
      const pasted = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      const numbersOnly = pasted.replace(/\D/g, "");

      // Inserisci solo i numeri
      document.execCommand("insertText", false, numbersOnly);
    },
    isPDCModified() {
      if (!this.originalPDC) return false;
      if (this.vettoreCodContoPDC.length !== this.originalPDC.length)
        return true;

      for (let i = 0; i < this.vettoreCodContoPDC.length; i++) {
        for (let j = 0; j < this.vettoreCodContoPDC[i].length; j++) {
          if (this.vettoreCodContoPDC[i][j] !== this.originalPDC[i][j]) {
            return true;
          }
        }
      }
      return false;
    },
    validateInput(rowIndex, colIndex, vettore) {
      const columnName = this.filteredHeaders[colIndex];
      if (!columnName) return;

      let value = vettore[rowIndex][this.validColumns[colIndex]];

      if (
        columnName === "Descrizione nel Prospetto Paghe" ||
        columnName === "Descrizione Cod. Conto" ||
        columnName === "Descrizione Cod. Conto 2" ||
        columnName === "Descrizione Cod. Conto - Datev Aziende" ||
        columnName === "Descrizione Cod. Conto - Datev Lib. Prof."
      ) {
        return;
      }
      // --- NUOVA LOGICA ROBUSTA PER "Nessuno" ---
      // Prendi solo le lettere e verifica se compongono "nessuno" (ignorando numeri e simboli)
      const onlyLetters = (value || "").replace(/[^a-zA-Z]/g, "").toLowerCase();
      if (onlyLetters === "na") {
        // Se ci sono cifre nel valore (anche inserite in mezzo), usale come nuovo valore.
        const onlyNumbers = (value || "").replace(/\D/g, "");
        if (onlyNumbers.length > 0) {
          value = onlyNumbers;
        } else {
          // Non ci sono numeri: tieni esattamente "Nessuno"
          vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
          return;
        }
      }

      // Se dopo aver gestito il caso "Nessuno" il valore contiene ancora lettere,
      // allora è un input letterale non valido -> reset a "Nessuno"
      if (/[a-zA-Z]/.test(value)) {
        vettore[rowIndex][this.validColumns[colIndex]] = "N.A.";
        return;
      }
      if (columnName === "Cod. Conto - TeamSystem") {
        value = value.replace(/[^0-9]/g, "");

        if (value.length > 2 && value[2] !== "/") {
          value = value.slice(0, 2) + "/" + value.slice(2);
        }
        if (value.length > 5 && value[5] !== "/") {
          value = value.slice(0, 5) + "/" + value.slice(5);
        }

        value = value.slice(0, 9);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto - Sistemi") {
        value = value.replace(/[^0-9]/g, "");

        if (value.length > 2 && value[2] !== ".") {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
        if (value.length > 5 && value[5] !== ".") {
          value = value.slice(0, 5) + "." + value.slice(5);
        }
        if (value.length > 8 && value[8] !== ".") {
          value = value.slice(0, 8) + "." + value.slice(8);
        }

        value = value.slice(0, 12);
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else if (columnName === "Cod. Conto - SEAC") {
        value = value.replace(/[^0-9]/g, "");
        value = value.slice(0, 6); // Limita a massimo 6 cifre numeriche
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      } else {
        value = value.replace(/\D/g, "");
        vettore[rowIndex][this.validColumns[colIndex]] = value;
      }
    },
    addRow() {
      if (this.isPdcArchiveView) {
        this.addRowMadre();
        return;
      }

      if (this.validateRow()) {
        const insertIndex = 1;

        this.jsonData.splice(insertIndex, 0, [...this.newRow]);

        // Aggiusta indici delle righe provvisorie e celle modificate
        this.provisionalRows = this.provisionalRows.map((index) =>
          index >= insertIndex ? index + 1 : index
        );
        this.provisionalRows.push(insertIndex);

        this.errors = this.shiftObjectKeys(this.errors, insertIndex);
        this.modifiedCells = this.shiftObjectKeys(
          this.modifiedCells,
          insertIndex
        );

        // ⚠️ Solo adesso svuoti newRow
        this.newRow = new Array(this.jsonData[0].length).fill("");
        this.showAddRow = false;

        this.hasUnsavedChanges = !this.isDataEqual(
          this.jsonData,
          this.lastSavedData
        );
        this.tableKey += 1;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    addRowMadre() {
      if (!this.validateArchiveMadreRow()) return;

      const insertIndex = 1;
      this.madreJsonData.splice(insertIndex, 0, [...this.newRow]);
      this.modifiedCellsMadre = this.shiftObjectKeys(
        this.modifiedCellsMadre,
        insertIndex
      );
      this.currentAddRowHeaders.forEach((_, index) => {
        this.$set(this.modifiedCellsMadre, `${insertIndex}-${index}`, true);
      });
      this.newRow = Array(this.currentAddRowHeaders.length).fill("");
      this.showAddRow = false;
      this.archiveMadreMissing = false;
      this.hasUnsavedChangesMadre = !this.isDataEqual(
        this.madreJsonData,
        this.madreLastSavedData
      );
      this.madreTableKey += 1;
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    validateArchiveMadreRow() {
      const errors = [];
      const software = String(this.newRow[0] || "").trim();
      const description = String(this.newRow[1] || "").trim();
      const accountCode = String(this.newRow[2] || "").trim();
      const formattedAccountCode = this.formatLibraryAccountCode(
        accountCode,
        software
      );

      if (!software) errors.push("â€¢ Software contabile mancante.");
      if (!description) errors.push("â€¢ Descrizione codice conto mancante.");
      if (!accountCode) errors.push("â€¢ Codice conto mancante.");

      if (accountCode && this.isCodContoDefault(formattedAccountCode)) {
        errors.push(
          `- Il codice conto ${this.codContoDefault} e riservato e non puo essere salvato.`
        );
      }

      if (errors.length) {
        this.erroreModalMessaggio = errors.join("\n");
        this.erroreModalVisibile = true;
        return false;
      }

      this.$set(this.newRow, 0, software.toUpperCase());
      this.$set(this.newRow, 2, formattedAccountCode);
      return true;
    },
    formatLibraryAccountCode(value, software) {
      let numeric = String(value || "").replace(/\D/g, "");
      const normalizedSoftware = String(software || "")
        .trim()
        .toUpperCase();

      if (normalizedSoftware.includes("TEAMSYSTEM")) {
        numeric = numeric.slice(0, 7);
        if (numeric.length >= 5) {
          return `${numeric.slice(0, 2)}/${numeric.slice(2, 4)}/${numeric.slice(
            4
          )}`;
        }
        if (numeric.length >= 3) {
          return `${numeric.slice(0, 2)}/${numeric.slice(2)}`;
        }
        return numeric;
      }
      if (normalizedSoftware.includes("SISTEMI")) {
        numeric = numeric.slice(0, 9);
        if (numeric.length >= 7) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2, 4)}.${numeric.slice(
            4,
            6
          )}.${numeric.slice(6)}`;
        }
        if (numeric.length >= 5) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2, 4)}.${numeric.slice(
            4
          )}`;
        }
        if (numeric.length >= 3) {
          return `${numeric.slice(0, 2)}.${numeric.slice(2)}`;
        }
        return numeric;
      }
      if (normalizedSoftware.includes("SEAC")) {
        return numeric.slice(0, 6);
      }
      if (normalizedSoftware.includes("DATEV")) {
        return numeric.slice(0, 11);
      }
      return numeric;
    },
    shiftObjectKeys(map, insertedAtRowIndex) {
      const shifted = {};
      for (const key in map) {
        const [row, col] = key.split("-").map(Number);
        if (row >= insertedAtRowIndex) {
          shifted[`${row + 1}-${col}`] = map[key];
        } else {
          shifted[key] = map[key];
        }
      }
      return shifted;
    },
    // Funzione per annullare l'aggiunta della riga
    cancelAddRow() {
      this.newRow = new Array(this.jsonData[0].length).fill(""); // Reset del newRow
    },
    finalizeAllRows() {
      this.provisionalRows = [];
    },
    downloadPDC() {
      const isClientPdc = this.currentPdcIsClient;
      const requestConfig = {
        responseType: "arraybuffer", // Per trattare i dati binari
      };
      if (isClientPdc) {
        requestConfig.params = {
          client_key: this.selectedClientPdcKey,
        };
      }

      axios
        .get(
          `${API_BASE_URL}${isClientPdc ? "/excel/client_pdc" : "/excel"}`,
          requestConfig
        )
        .then((response) => {
          downloadBlob(
            response.data,
            isClientPdc
              ? `Prospetti Paghe - Piano dei Conti - ${this.selectedClientPdcLabel}.xlsx`
              : "Prospetti Paghe - Piano dei Conti.xlsx",
            response.headers["content-disposition"]
          );
        })
        .catch((error) => {
          console.error("Errore nel download del file Excel:", error);
        });
    },
    addRowsInPDC() {
      if (!this.validateAllInputs()) {
        return; // esce subito se validazione fallisce
      }

      this.calculating2 = true;

      // 1. Determina le colonne valide per il vettore principale
      const validColumns = this.getValidColumns();

      // 2. Prepara il vettore principale (lo stesso di prima, ma più leggibile)
      let finalVector = this.vettoreCodConto.map(
        (row) =>
          row
            .map((cell, index) =>
              index === 0 || validColumns.includes(index) ? cell : null
            )
            .slice(0, -2) // togli le ultime due colonne come fai già
      );

      // 3. Unisci il vettore PDC SOLO se è stato modificato e contiene dati
      if (
        this.isPDCModified?.() &&
        Array.isArray(this.vettoreCodContoPDC) &&
        this.vettoreCodContoPDC.length > 0
      ) {
        // Usa le stesse colonne valide oppure quelle specifiche del PDC (se esistono)
        const pdcValidCols = this.validColumnsPDC || validColumns;

        const pdcRows = this.vettoreCodContoPDC.map((row) =>
          row
            .map((cell, index) =>
              index === 0 || pdcValidCols.includes(index) ? cell : null
            )
            .slice(0, -2)
        );

        finalVector = [...finalVector, ...pdcRows];

        console.log(`Aggiunte ${pdcRows.length} righe da PDC modificato`);
      } else {
        console.log("PDC non modificato o vuoto → non unito");
      }

      console.log("Vettore finale da inviare:", finalVector);

      const payload = {
        input_PC: this.input_PC,
        output_PC: this.output_PC,
        vettoreCodConto: finalVector, // ← qui va finalVector,
      };
      const pdcClientGroupsPayload =
        this.buildPdcClientGroupsPayloadForLibrary();
      if (pdcClientGroupsPayload) {
        payload.pdc_client_groups = pdcClientGroupsPayload;
        payload.client_custom_pdc_entries = this.clientCustomPdcEntries;
      }
      this.startDelayMessageTimer();

      axios
        .post(`${API_BASE_URL}/add_bilancino_PDC`, payload, {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.clearDelayMessageTimer();
          console.log("Caricato con successo (add_bilancino_PDC)", res);

          // Resetta i flag di conferma avvertenze (come nel metodo corretto)
          this.naConfirmed = false;
          this.noCorrConfirmed = false;

          setTimeout(() => {
            this.fetchFileFromBackend?.();
            this.fetchClientPdcPlans?.();

            this.refreshDashboard(); // refresh finale, come nel codice di riferimento
          }, 1500);
        })
        .catch((err) => {
          this.clearDelayMessageTimer();
          console.error("Errore add_bilancino_PDC:", err.response?.data || err);

          // Mostra messaggio utente (opzionale, ma consigliato per coerenza)
          this.errorMessage =
            err.response?.data?.error ||
            "Errore durante l'aggiunta al piano dei conti";
        });
    },
    proceedWithWarnings() {
      this.naConfirmed = true;
      this.noCorrConfirmed = true;
      this.showErrorModal = false;
      this.addRowsInPDC();
    },
    validateAllInputs() {
      const validColumns = this.getValidColumns() || [];

      // Inizializzazione strutture errori
      let emptyCells = {
        "Codici Conto mancanti": [],
        "Descrizioni nel Prospetto Paghe mancanti": [],
        "Descrizioni Codici Conto mancanti": [],
      };
      let formatErrors = [];
      let reservedCodContoDefaultCells = [];
      let naCells = [];
      let noCorrCells = [];

      // Espressioni regolari
      const teamSystemRegex = /^\d{2}\/\d{2}\/\d{3}$/;
      const numberRegex = /^\d+$/;
      const sistemiRegex = /^\d{2}\.\d{2}\.\d{2}(\.\d{3})?$/;

      // Colonne da escludere dai controlli obbligatori e di formato
      const colonneEscluse = [
        "Cod. Conto DARE - TeamSystem",
        "Cod. Conto AVERE - TeamSystem",
        "Cod. Conto DARE - SEAC",
        "Cod. Conto AVERE - SEAC",
        "Cod. Conto DARE - Sistemi",
        "Cod. Conto AVERE - Sistemi",
        "Cod. Conto DARE - Datev Aziende",
        "Cod. Conto AVERE - Datev Aziende",
        "Cod. Conto DARE - Datev Lib. Prof.",
        "Cod. Conto AVERE - Datev Lib. Prof.",
        "Cod. Conto DARE - Zucchetti",
        "Cod. Conto AVERE - Zucchetti",
        "DARE",
        "AVERE",
      ];

      // Funzione di validazione protetta
      const validateVector = (
        vector,
        headers = [],
        validCols = [],
        prefix = ""
      ) => {
        // Protezione fondamentale: se vector non è un array → esci
        if (!Array.isArray(vector)) {
          console.warn(
            `validateVector: il vettore non è un array (prefix: ${prefix})`,
            vector
          );
          return;
        }

        // Protezione su headers e validCols
        if (!Array.isArray(headers) || !Array.isArray(validCols)) {
          console.warn(
            `validateVector: headers o validCols non sono array (prefix: ${prefix})`
          );
          return;
        }

        // 1. Controllo celle vuote + formato
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i] || `Colonna ${colIndex + 1}`;
            const col = this.headers?.[colIndex] || "Sconosciuta";

            if (colonneEscluse.includes(col)) {
              continue;
            }

            const cellValue = vector[rowIndex]?.[colIndex];
            const cellStr = (cellValue == null ? "" : String(cellValue)).trim();

            // Saltiamo N.A. e NESSUNA CORRELAZIONE per vuote/formato
            if (
              ["N.A.", "NESSUNA CORRELAZIONE"].includes(cellStr.toUpperCase())
            ) {
              continue;
            }

            if (
              this.isCodContoValueColumnName(col) &&
              this.isCodContoDefault(cellStr)
            ) {
              reservedCodContoDefaultCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader || col}`
              );
              continue;
            }

            // Celle vuote
            if (!cellValue || cellStr === "") {
              if (col === "Descrizione nel Prospetto Paghe") {
                emptyCells["Descrizioni nel Prospetto Paghe mancanti"].push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  } - Descrizione nel Prospetto Paghe`
                );
              } else if (
                ["Descrizione Cod. Conto", "Descrizione Cod. Conto 2"].includes(
                  col
                )
              ) {
                emptyCells["Descrizioni Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
                );
              } else {
                emptyCells["Codici Conto mancanti"].push(
                  `${prefix}Riga ${rowIndex + 1} - ${col}`
                );
              }
              continue;
            }

            // Controlli formato
            if (col === "Cod. Conto - TeamSystem" && cellValue) {
              if (!teamSystemRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: formato errato (XX/XX/XXX)`
                );
              }
            }

            if (col === "Cod. Conto - Sistemi" && cellValue) {
              if (!sistemiRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: formato errato (XX.XX.XX o XX.XX.XX.XXX)`
                );
              }
            }

            if (col === "Cod. Conto - SEAC" && cellValue) {
              const cleaned = String(cellValue).replace(/[^0-9]/g, "");
              if (!numberRegex.test(cleaned) || cleaned.length !== 6) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve contenere esattamente 6 cifre`
                );
              }
            }

            if (
              [
                "Cod. Conto - Datev Aziende",
                "Cod. Conto - Datev Lib. Prof.",
              ].includes(col) &&
              cellValue
            ) {
              if (!numberRegex.test(cellValue)) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve essere un numero intero`
                );
              } else if (
                String(cellValue).length < 5 ||
                String(cellValue).length > 11
              ) {
                formatErrors.push(
                  `${prefix}Riga ${
                    rowIndex + 1
                  }, ${col}: deve contenere da 5 a 11 cifre`
                );
              }
            }

            if (
              col === "Cod. Conto - Zucchetti" &&
              cellValue &&
              !numberRegex.test(cellValue)
            ) {
              formatErrors.push(
                `${prefix}Riga ${
                  rowIndex + 1
                }, ${col}: deve essere un numero intero`
              );
            }
          }
        }

        // 2. Rilevazione N.A. e NESSUNA CORRELAZIONE (solo per avvisi)
        for (let rowIndex = 0; rowIndex < vector.length; rowIndex++) {
          for (let i = 0; i < validCols.length; i++) {
            const colIndex = validCols[i];
            const visibleHeader = headers[i] || `Colonna ${colIndex + 1}`;
            const col = this.headers?.[colIndex] || "Sconosciuta";

            if (colonneEscluse.includes(col)) continue;

            const cellValue = vector[rowIndex]?.[colIndex];
            const cellStr = String(cellValue || "")
              .trim()
              .toUpperCase();

            if (!col.includes("Descrizione") && cellStr === "N.A.") {
              naCells.push(`${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`);
            }

            if (
              (col === "Descrizione Cod. Conto" ||
                col === "Descrizione Cod. Conto 2") &&
              cellStr === "NESSUNA CORRELAZIONE"
            ) {
              noCorrCells.push(
                `${prefix}Riga ${rowIndex + 1} - ${visibleHeader}`
              );
            }
          }
        }
      };

      // Esecuzione validazione ───────────────────────────────────────────────

      // Vettore principale → deve esistere e essere array
      if (Array.isArray(this.vettoreCodConto)) {
        validateVector(
          this.vettoreCodConto,
          this.filteredHeaders || [],
          validColumns,
          ""
        );
      } else {
        console.error(
          "validateAllInputs: vettoreCodConto non è un array",
          this.vettoreCodConto
        );
        // Puoi decidere se mostrare errore bloccante qui
        // this.errorsData = [...]; this.showErrorModal = true; return false;
      }

      // Vettore PDC → opzionale, ma se esiste deve essere array
      if (
        this.vettoreCodContoPDC !== undefined &&
        Array.isArray(this.vettoreCodContoPDC) &&
        this.vettoreCodContoPDC.length > 0
      ) {
        validateVector(
          this.vettoreCodContoPDC,
          this.filteredHeaders || [],
          this.validColumnsPDC || [],
          "[SALVATI] "
        );
      }

      // ─── Reporting errori ──────────────────────────────────────────────

      const detectedErrors = [];

      if (emptyCells["Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          type: "empty-cells",
          title: "Codici Conto mancanti:",
          messages: emptyCells["Codici Conto mancanti"],
        });
      }
      if (emptyCells["Descrizioni nel Prospetto Paghe mancanti"].length > 0) {
        detectedErrors.push({
          type: "empty-cells",
          title: "Descrizioni nel Prospetto Paghe mancanti:",
          messages: emptyCells["Descrizioni nel Prospetto Paghe mancanti"],
        });
      }
      if (emptyCells["Descrizioni Codici Conto mancanti"].length > 0) {
        detectedErrors.push({
          type: "empty-cells",
          title: "Descrizioni Codici Conto mancanti:",
          messages: emptyCells["Descrizioni Codici Conto mancanti"],
        });
      }

      if (formatErrors.length > 0) {
        detectedErrors.push({
          type: "format-errors",
          title: "Codici Conto non validi:",
          messages: formatErrors,
        });
      }
      if (reservedCodContoDefaultCells.length > 0) {
        detectedErrors.push({
          type: "format-errors",
          title: `Codice conto ${this.codContoDefault} riservato:`,
          messages: reservedCodContoDefaultCells,
        });
      }

      // AVVISI N.A. / NESSUNA CORRELAZIONE
      if (detectedErrors.length === 0) {
        const hasNA = !this.naConfirmed && naCells.length > 0;
        const hasNoCorr = !this.noCorrConfirmed && noCorrCells.length > 0;

        if (hasNA || hasNoCorr) {
          const plural = (c, s, p) => (c === 1 ? s : p);
          const foundM = (c) => (c === 1 ? "Trovato" : "Trovati");
          const foundF = (c) => (c === 1 ? "Trovata" : "Trovate");
          const assignedM = (c) => (c === 1 ? "assegnato" : "assegnati");
          const thisTheseM = (c) => (c === 1 ? "questo" : "questi");
          const thisTheseF = (c) => (c === 1 ? "questa" : "queste");
          const theTheM = (c) => (c === 1 ? "Il" : "I");
          const theTheF = (c) => (c === 1 ? "La" : "Le");
          const willBe = (c) => (c === 1 ? "verrà" : "verranno");
          const valuedM = (c) => (c === 1 ? "valorizzato" : "valorizzati");
          const keptF = (c) => (c === 1 ? "mantenuta" : "mantenute");

          let title = "",
            messages = [],
            question = "";

          if (hasNA && hasNoCorr) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundM(naCells.length + noCorrCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' e ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = [...naCells, ...noCorrCells];
            question = `Vuoi proseguire? ${theTheM(
              naCells.length
            )} ${cod} ${willBe(naCells.length)} ${valuedM(
              naCells.length
            )} con 'N.A.' e ${theTheF(
              noCorrCells.length
            ).toLowerCase()} ${nom} ${willBe(noCorrCells.length)} ${keptF(
              noCorrCells.length
            )} come 'NESSUNA CORRELAZIONE'.`;
          } else if (hasNA) {
            const cod = plural(naCells.length, "Codice Conto", "Codici Conto");
            title = `${foundM(naCells.length)} ${
              naCells.length
            } ${cod} con 'N.A.' (non ${assignedM(naCells.length)}):`;
            messages = naCells;
            question = `Vuoi proseguire senza assegnare ${thisTheseM(
              naCells.length
            )} ${cod}?<br>${
              willBe(naCells.length).charAt(0).toUpperCase() +
              willBe(naCells.length).slice(1)
            } ${valuedM(naCells.length)} con 'N.A.'.`;
          } else if (hasNoCorr) {
            const nom = plural(
              noCorrCells.length,
              "Descrizione Codice Conto",
              "Descrizioni Codici Conto"
            );
            title = `${foundF(noCorrCells.length)} ${
              noCorrCells.length
            } ${nom} con 'NESSUNA CORRELAZIONE':`;
            messages = noCorrCells;
            question = `Vuoi proseguire con ${thisTheseF(
              noCorrCells.length
            )} ${nom} senza correlazione?<br>${
              willBe(noCorrCells.length).charAt(0).toUpperCase() +
              willBe(noCorrCells.length).slice(1)
            } ${keptF(noCorrCells.length)} come 'NESSUNA CORRELAZIONE'.`;
          }

          detectedErrors.push({
            type: "combined-warning",
            title,
            messages,
            question,
          });
        }
      }

      if (detectedErrors.length > 0) {
        this.errorsData = detectedErrors;
        this.showErrorModal = true;
        return false;
      }

      return true;
    },
    refreshDashboard() {
      this.rows = [];
      this.ExcelRows = [];
      this.calculating = false;
      this.calculating2 = false;
      (this.input_PC = ""), (this.output_PC = "");
      this.vettoreCodConto = [];
      this.vettoreCodContoPDC = [];
      this.selectedFile = null;
      this.bilancinoFile = null;
      this.selectedPiano = null;
      this.isShifted = false;
      this.isTransitionDone = false;
      this.expanded = true;
      this.isTableExpanded = false;
      this.editPDCresponse = false;
      // this.isEditing = false;
      this.errorMessage = "";
      this.showAddRow = false;
      this.showAddBilancino = false;
      this.showResult = false;
      this.showAddPiano = false;
      this.filePDF_URL = false;
      // 🔴 Protezione contro undefined
      if (this.jsonData && this.jsonData.length > 0) {
        this.newRow = Array(this.jsonData[0].length).fill("");
      } else {
        console.warn("Nuovo piano dei conti caricato.");
        this.newRow = []; // Evita errori
      }
      this.loadUserPreferredSoftware();
    },
    getValidColumns() {
      // Mappa delle colonne da escludere in base a output_PC
      const excludedColumnsMap = {
        TEAMSYSTEM: [0, 3, 4, 5, 6, 7, 9],
        DATEV: [0, 2, 5, 6, 7, 9],
        ZUCCHETTI: [0, 2, 3, 4, 6, 7, 9],
        SEAC: [0, 2, 3, 4, 5, 7, 9],
        SISTEMI: [0, 2, 3, 4, 5, 6, 9],
      };

      // Ottieni gli indici da escludere per il valore attuale di output_PC
      const excludedColumns = excludedColumnsMap[this.output_PC] || [];

      // Restituisci solo gli indici che non sono da escludere
      return this.headers
        .map((_, index) => index)
        .filter((index) => !excludedColumns.includes(index));
    },
    formatCodiceConto(event, index) {
      let value = event.target.value.replace(/\D/g, ""); // Rimuove tutti i caratteri non numerici per tutti i casi

      if (index === 2) {
        // TeamSystem: formato XX/XX/XXX, limite 7 numeri
        value = value.slice(0, 7);
        if (value.length >= 5) {
          value =
            value.slice(0, 2) + "/" + value.slice(2, 4) + "/" + value.slice(4);
        } else if (value.length >= 3) {
          value = value.slice(0, 2) + "/" + value.slice(2);
        }
      } else if (index === 6) {
        // SEAC: solo numeri, massimo 6 cifre
        value = value.slice(0, 6);
        // Nessun separatore automatico
      } else if (index === 7) {
        // Sistemi: formato XX.XX.XX o XX.XX.XX.XXX, limite 9 numeri
        value = value.slice(0, 9);
        if (value.length >= 7) {
          value =
            value.slice(0, 2) +
            "." +
            value.slice(2, 4) +
            "." +
            value.slice(4, 6) +
            "." +
            value.slice(6);
        } else if (value.length >= 5) {
          value =
            value.slice(0, 2) + "." + value.slice(2, 4) + "." + value.slice(4);
        } else if (value.length >= 3) {
          value = value.slice(0, 2) + "." + value.slice(2);
        }
      } else if (index === 3 || index === 4) {
        // Datev: solo numeri, massimo 11 cifre
        value = value.slice(0, 11);
      } else {
        // Altri index (Zucchetti, etc.): solo numeri, senza limite specifico
      }

      // Imposta il valore nel campo di input e aggiorna newRow
      event.target.value = value;
      this.newRow[index] = value; // Aggiorna il valore nella row in modo dinamico
    },
    hasNessunaCorrelazione(value) {
      if (typeof value === "string") {
        return value.toLowerCase().includes("nessuna correlazione");
      }
      return false;
    },
    isNessuno(value) {
      return value === "N.A.";
    },
    startDelayMessageTimer() {
      this.delayTimer = setTimeout(() => {
        this.showDelayedMessage = true;
      }, 10000);
      // Cambia il testo dopo 40 secondi totali
      this.updateTimer = setTimeout(() => {
        this.delayedMessageUpdated = true;
      }, 35000);
    },
    clearDelayMessageTimer() {
      clearTimeout(this.delayTimer);
      clearTimeout(this.updateTimer);
      this.showDelayedMessage = false;
      this.delayedMessageUpdated = false;
    },
  },
};
</script>

<style scoped>
.main-container {
  box-sizing: border-box;
  width: 100%;
  padding: 0.75rem clamp(1rem, 5vw, 6rem) 2.25rem;
}

body {
  margin-left: 2rem;
}
.library-page-header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-height: 5.85rem;
  margin: 0 0 0.675rem;
  padding: 0.72rem 11rem 0.72rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  overflow: hidden;
  border: 1px solid rgba(20, 118, 94, 0.1);
  border-radius: 12px;
  background: linear-gradient(105deg, #f5fbf8 0%, #eef8f3 68%, #e9f5ef 100%);
  box-shadow: 0 7px 20px rgba(33, 105, 81, 0.055);
}

.library-page-header__icon {
  position: relative;
  z-index: 1;
  display: block;
  flex: 0 0 3.7rem;
  width: 3.7rem;
  height: 3.7rem;
  object-fit: contain;
}

.library-page-header__copy {
  position: relative;
  z-index: 1;
  min-width: 0;
}

.library-page-header__title-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-width: 0;
}

.library-page-header__title {
  margin: 0;
  color: #15334b;
  font-size: 1.42rem;
  font-weight: 750;
  letter-spacing: -0.015em;
  line-height: 1.15;
}

.library-page-header__subtitle {
  margin: 0.3rem 0 0;
  color: #657c88;
  font-size: 0.82rem;
  line-height: 1.35;
}

.library-page-header__visual {
  position: absolute;
  z-index: 0;
  display: block;
  pointer-events: none;
  user-select: none;
}

.library-page-header__visual--conto {
  right: 1.05rem;
  bottom: -3.85rem;
  width: 12.5rem;
  opacity: 0.48;
}

.library-scope-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.32rem;
  padding: 0.3rem 0.55rem;
  border: 1px solid #d4ebdf;
  border-radius: 999px;
  background: #eaf7f0;
  color: #187958;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}
.library-scope-badge i {
  font-size: 0.65rem;
}
/* table,
th,
td {
  border: 1px solid black;
} */
th,
td {
  padding: 10px;
  text-align: left;
}
th {
  background-color: #f2f2f2;
}

.dashboard {
  margin-top: 0rem;
  margin-bottom: 0rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
}
.dashboardmadre {
  margin-bottom: 1.5rem;
}
.buttons {
  display: flex;
  align-items: center;
  gap: 0.3rem; /* Spaziatura consistente tra i pulsanti */
  padding: 0.5rem 0.75rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); /* Ombra leggera per un look moderno */
  transition: box-shadow 0.3s ease;
}
.buttons:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Effetto hover per profondità */
}
.buttons > button,
.buttons > a {
  align-items: center;
  gap: 0.35rem;
  padding: 0.6rem 0.85rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent; /* Pulsanti trasparenti di default per un look minimal */
  white-space: nowrap;
}
.buttons > button {
  display: flex;
}
.buttons > button:hover,
.buttons > a:hover {
  background-color: #f0f0f0;
  transform: translateY(-1px);
}
.buttons > button:active,
.buttons > a:active {
  transform: translateY(0);
  background-color: #e0e0e0;
}
.addrowbuttons-add-bilancino {
  margin-top: 0.5rem;
  gap: 0.5rem;
  display: flex;
  justify-content: center;
}
.addrowbuttons-add-bilancino > button {
  width: auto;
  padding: 0.8rem;
  margin: 0.6rem;
  cursor: pointer;
}
.strumenti,
.strumenti2 {
  background-color: #f0f0f0; /* Sfondo leggero per il pulsante strumenti */
  color: #555;
  font-weight: 600;
}
.strumenti:hover,
.strumenti2:hover {
  background-color: #e0e0e0;
}
.strumenti:active,
.strumenti2:active {
  background-color: #d0d0d0;
}
.addRowButton,
.addBilancinoButton,
.btn-carica,
.btn-scarica {
  background-color: #f0f0f0;
  color: #555;
}
.btn-madre-pdc:hover,
.addRowButton:hover,
.addBilancinoButton:hover,
.btn-carica:hover,
.btn-scarica:hover {
  background-color: #e0e0e0;
}
.addRowButton:active,
.addBilancinoButton:active,
.btn-carica:active,
.btn-scarica:active {
  background-color: #d0d0d0;
}
.active-button {
  background-color: #e0e0e0 !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}
.btninput:disabled,
.btninput:disabled * {
  cursor: not-allowed !important;
}
.savebuttondiv:disabled {
  cursor: not-allowed;
}
.savebuttondiv:disabled i,
.savebuttondiv:disabled span {
  color: #818080 !important;
  cursor: inherit;
}
.archive-missing-notice {
  margin: 0 auto 0.8rem;
  width: 100%;
  max-width: 36rem;
  padding: 1.15rem 1.2rem;
  border: 1px solid #dce6de;
  border-radius: 12px;
  background: linear-gradient(180deg, #f8fbf9 0%, #eef5f1 100%);
  color: #4c6058;
  font-size: 0.95rem;
  line-height: 1.55;
}
.archive-missing-notice p {
  margin: 0;
}
.archive-missing-inline-action {
  display: inline;
  padding: 0;
  border: none;
  background: transparent;
  color: #2f6a53;
  font: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 0.14em;
  cursor: pointer;
}
.archive-missing-inline-action:hover {
  color: #234c3c;
}
.btn-madre-pdc:disabled {
  opacity: 0.7;
  background-color: #f0f0f0;
  color: #737373;
}
.tool-button {
  padding: 0.35rem !important;
  background-color: transparent;
  margin-right: 0;
}
.tool-button:hover .back {
  color: rgb(33, 105, 81);
}
.toolicon {
  font-size: 1.1rem;
  color: #666;
  margin-left: -0.1rem;
}
.download-icon {
  color: #28a745;
}
.badge {
  background-color: #ff4d4d;
  color: white;
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  border-radius: 50%;
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
}
.lastbuttons {
  padding-top: 20px;
  padding-bottom: 4rem;
}
.modificaButton {
  background-color: #4caf50;
  border-radius: 5px;
}
.modificaButton:hover {
  background-color: #45a049;
}
.annullamodifiche {
  background-color: #c94d41;
  border-radius: 5px;
}
.annullamodifiche:hover {
  background-color: #c12323;
}
.donwloadUploadIcons {
  padding-left: 0rem;
}
.delete-button {
  font-size: 0.9rem;
  color: #6b7280;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 6px;
  transition: background-color 0.3s;
}
.delete-button:hover,
.delete-button.active {
  transform: scale(1.1); /* Aggiungi un effetto leggero di ingrandimento */
  background-color: #e61d1d !important;
  border-radius: 4px;
  color: #ffffff !important;
}
.delete-button1 {
  font-size: 1.1rem;
  color: white;
  background-color: #f9f9f9;
  border: none;
  cursor: pointer;
  padding: 4px 5px;
  transition: background-color 0.3s;
}
.delete-button1:hover,
.delete-button1.active {
  transform: scale(1.1); /* Aggiungi un effetto leggero di ingrandimento */
  background-color: #e61d1d;
  border-radius: 4px;
}
tr.highlight-row .delete-button {
  background-color: #ffeeba; /* Giallo acceso */
  color: black !important; /* Contrasto leggibile */
}
.add-row-form {
  margin-top: 2rem;
  margin-bottom: 1.8rem;
  padding: 0 5px;
  background-color: #f9f9f9;
}
add-row-form table {
  border-collapse: collapse; /* Per evitare spazi tra le celle */
}
.addrowheaders {
  background-color: #d9d7dea1;
}
.add-row-form input {
  height: 1.6rem;
  width: 95%;
}
.leggibilancino:active {
  background-color: #616269; /* Colore più scuro quando il pulsante è premuto */
  transform: translateY(
    0
  ); /* Ripristina la posizione quando il pulsante è attivo */
}
.addrowbuttons {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
.addrowbuttons > button {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.05rem;
  cursor: pointer;
  text-align: center;
  padding: 0.75rem;
  margin: 0.5rem;
}

.addrow-buttons-add-bilancino {
  margin-top: 0.5rem;
  gap: 0.5rem;
  display: flex;
  justify-content: center;
}
.addrow-buttons-add-bilancino > button {
  width: auto;
  padding: 0.8rem;
  margin: 0.6rem;
  cursor: pointer;
}
.download-icon {
  font-size: 1rem; /* Dimensione dell'icona */
  color: #28a745;
}

.upload-icon {
  font-size: 1.2rem; /* Dimensione dell'icona */
  color: #5c5c5c; /* Verde brillante */
}

.upload-icon:hover {
  color: #a1a1a1; /* Verde scuro al passaggio del mouse */ /* Colore al passaggio del mouse */
}
.back {
  font-size: 1.5rem !important;
  color: #7d7d7d;
}
.backinheader {
  font-size: 1.55rem !important;
}
.back:hover {
  color: rgb(33, 105, 81);
}
.selectSoftwareInput {
  height: 1.8rem;
  color: rgb(0, 0, 0);
  width: 95%;
}
.riga {
  position: relative;
}
.loading-cursor {
  cursor: progress;
}
.highlight-row {
  background-color: #ffeeba !important; /* Giallo chiaro */
  transition: background-color 0.3s ease-in-out !important;
}
tr.highlight-row td {
  background-color: #ffeeba !important; /* Giallo chiaro */
  transition: background-color 0.3s ease-in-out !important;
}
table {
  border-spacing: 0;
  border: none !important;
  width: 100%;
}
#excelTable {
  position: relative;
  margin-top: 1.5rem;
  margin-bottom: 5rem;
  width: auto;
  min-width: 38rem;
  border-collapse: collapse;
  margin-top: 20px;
}
#excelTable th:nth-child(1),
#excelTable td:nth-child(1) {
  width: 1rem !important;
}
#excelTable th:nth-child(2),
#excelTable td:nth-child(2) {
  min-width: 20rem !important;
  text-align: left;
}

#excelTable th:not(.delete-column):nth-child(n + 3),
#excelTable td:not(.delete-column):nth-child(n + 3) {
  min-width: 8rem !important;
}
#excelTable.focused-software-table {
  width: min(60rem, 100%);
  min-width: 0;
}
#excelTable.focused-software-table th:nth-child(2),
#excelTable.focused-software-table td:nth-child(2) {
  width: 36rem;
  min-width: 26rem !important;
}
#excelTable.focused-software-table th:not(.delete-column):nth-child(n + 3),
#excelTable.focused-software-table td:not(.delete-column):nth-child(n + 3) {
  width: 20rem;
  min-width: 14rem !important;
}
#excelTable.focused-software-table.focused-software-table--double {
  width: min(70rem, 100%);
}
#excelTable.focused-software-table.focused-software-table--double
  th:nth-child(2),
#excelTable.focused-software-table.focused-software-table--double
  td:nth-child(2) {
  width: 30rem;
  min-width: 22rem !important;
}
#excelTable.focused-software-table.focused-software-table--double
  th:not(.delete-column):nth-child(n + 3),
#excelTable.focused-software-table.focused-software-table--double
  td:not(.delete-column):nth-child(n + 3) {
  width: 16rem;
  min-width: 12rem !important;
}
#excelTable.has-empty-body {
  margin-bottom: 0;
}
#excelTable.has-empty-body .row-index {
  display: none;
}
#excelTable > tr {
  height: 3rem;
  box-sizing: border-box;
}
#addRowTable {
  width: 82rem;
}
#addRowTable th,
#addRowTable td {
  text-align: center;
}
#addRowTable th:nth-child(1),
#addRowTable td:nth-child(1),
#addRowTable th:nth-child(2),
#addRowTable td:nth-child(2) {
  width: 17%; /* Prima colonna, larghezza minima di 150px */
}
#addRowTable th:nth-child(3),
#addRowTable td:nth-child(3),
#addRowTable th:nth-child(4),
#addRowTable td:nth-child(4),
#addRowTable th:nth-child(5),
#addRowTable td:nth-child(5),
#addRowTable th:nth-child(6),
#addRowTable td:nth-child(6),
#addRowTable th:nth-child(7),
#addRowTable td:nth-child(7),
#addRowTable th:nth-child(8),
#addRowTable td:nth-child(8) {
  width: 11%; /* Prima colonna, larghezza minima di 150px */
}
.delete-column {
  width: 3rem !important;
  min-width: 3rem !important;
  max-width: 3rem !important;
  text-align: center !important;
}
.file-upload-container {
  display: inline-block;
}

.btninput {
  display: flex;
  align-items: center;
  gap: 7px;
}

.hidden-file-input {
  display: none;
}
.software-output-select {
  margin-left: 10px;
  padding: 3px;
  font-size: 0.8rem;
}
.btn-send-bilancino {
  background-color: #4caf50;
  border-radius: 5px;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  margin-top: 10px;
}

.btn-send-bilancino:hover {
  background-color: #45a049;
}

.btn-send-bilancino:disabled {
  background-color: #d3d3d3;
  cursor: default;
}
.fase1-seac {
  width: 54rem;
  height: 24rem;
  margin-left: 1.5rem;
}
.response-message-add-bilancino {
  width: 62rem;
  height: auto;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-top: 1.5rem;
}
.nessun-piano-header {
  margin: 0;
  font-weight: 700;
  font-style: normal;
  color: #22352d;
  font-size: 1.15rem;
  line-height: 1.3;
  letter-spacing: 0.01em;
}
.empty-plan-icon {
  width: 2.7rem;
  height: 2.7rem;
  flex: 0 0 2.7rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--empty-soft);
  color: var(--empty-accent);
  font-size: 1.2rem;
}
.empty-plan-body {
  width: 100%;
  max-width: 58rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}
.empty-plan-line {
  margin: 0;
  color: #5d6b79;
  font-size: 1rem;
  line-height: 1.55;
}
.empty-plan-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}
.empty-plan-action {
  min-height: 2.35rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.52rem 0.85rem;
  border-radius: 8px;
  font-size: 0.95rem !important;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease, transform 0.18s ease;
}
.empty-plan-action:hover {
  transform: translateY(-1px);
}
.empty-plan-action--primary {
  border: 1px solid var(--empty-accent);
  background: var(--empty-accent);
  color: #ffffff !important;
}
.empty-plan-action--primary:hover {
  background: var(--empty-accent-hover);
  border-color: var(--empty-accent-hover);
}
.empty-plan-action--secondary {
  border: 1px solid #cfdcd4;
  background: #ffffff;
  color: var(--empty-accent);
}
.empty-plan-action--secondary:hover {
  background: var(--empty-soft);
  border-color: #bfd1c5;
}
.empty-plan-line .convertitore {
  font-size: inherit !important;
  font-weight: 600;
}
.div-add-bilancino {
  position: relative;
  width: 18rem;
  display: flex;
  flex-direction: column; /* Gli elementi all'interno sono disposti in colonna */
  padding: 0.8rem 2rem 1.8rem 2rem;
  align-items: center;
  justify-content: flex-start; /* Posizionamento degli elementi in alto */
  order: 1; /* Ordine iniziale: è il primo elemento */
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgba(223, 223, 223, 0.82) !important;
  border-radius: 20px;
  box-shadow: 2px 2px 8px rgba(107, 107, 107, 0.1);
  transition: transform 0.8s ease-in-out, margin-bottom 0.2s ease-in-out 0.8s;
}

.div-add-bilancino.shift-left {
  align-items: center; /* Allinea gli elementi verticalmente al centro */
  transform: translateX(-136%);
  margin-bottom: 4.5rem;
}
.calcolatrice-add-bilancino {
  position: relative;
  padding-bottom: 2rem;
  margin-top: 1.75rem;
}
.container-wrapper-add-bilancino {
  position: relative;
  display: flex;
  align-items: flex-start; /* Allinea verticalmente in cima */
  justify-content: center; /* Allinea .contenitore al centro inizialmente */
  width: 100%;
}
.margin-active {
  margin-bottom: 5.5rem;
}
.input-container .action-button {
  background-color: #318261;
}
.file-input-add-bilancino {
  width: 17.4rem;
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}
.select-input-add-bilancino {
  width: 100%;
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 1.5rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #fff;
}
.result-container-add-bilancino {
  position: absolute;
  min-width: 62rem;
  left: 29%;
  opacity: 0; /* Inizialmente nascosto */
  transition: opacity 3s ease-in-out 5s;
  order: 2; /* Ordine iniziale: è il secondo elemento */
  border-radius: 5px;
  margin-top: 2rem;
  margin-bottom: 5rem;
  border: 1px solid rgba(198, 198, 198, 0.525);
  background-color: white;
}
.result-container-add-bilancino.show {
  opacity: 1;
}
.title-add-bilancino {
  color: #2d604f;
  display: block;
  font-size: 1.16em;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
  font-weight: bold;
  width: 17rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #b2b2b2;
}
.titleaddpiano {
  font-weight: bold;
  color: #2d604f;
  font-size: 1.12rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #b2b2b2;
  width: 16rem;
}
.headerButtons-add-bilancino {
  position: absolute;
  opacity: 100%;
  transform: scale(0.75);
  top: 0rem;
  left: -3.2rem;
  display: flex;
  flex-direction: column; /* Dispone gli elementi in verticale */
  align-items: center; /* Centra gli elementi orizzontalmente (opzionale) */
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgb(202 223 205 / 60%) !important;
  border-radius: 18px;
  padding: 0.6rem 0.5rem 0.6rem 0.5rem;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
}
.btn-madre-pdc:hover,
.headerButtons-add-bilancino:hover {
  cursor: pointer;
}
.headerButtons-add-bilancino:hover .refresh {
  color: rgb(91, 94, 91);
}
.codcontotable-add-bilancino {
  position: relative;
  border-spacing: 0;
}
.codcontotable-add-bilancino-datev {
  width: 100%;
  table-layout: fixed;
}
.codcontotable-add-bilancino-datev th,
.codcontotable-add-bilancino-datev td {
  padding: 6px 8px;
  line-height: 1.14;
}
.codcontotable-add-bilancino-datev th {
  font-size: 0.82rem;
}
.codcontotable-add-bilancino-datev th:nth-child(1),
.codcontotable-add-bilancino-datev td:nth-child(1) {
  width: 3.6%;
}
.codcontotable-add-bilancino-datev th:nth-child(2),
.codcontotable-add-bilancino-datev td:nth-child(2) {
  width: 17%;
}
.codcontotable-add-bilancino-datev th:nth-child(3),
.codcontotable-add-bilancino-datev td:nth-child(3) {
  width: 13%;
}
.codcontotable-add-bilancino-datev th:nth-child(4),
.codcontotable-add-bilancino-datev td:nth-child(4) {
  width: 10%;
}
.codcontotable-add-bilancino-datev th:nth-child(5),
.codcontotable-add-bilancino-datev td:nth-child(5) {
  width: 24%;
}
.codcontotable-add-bilancino-datev th:nth-child(6),
.codcontotable-add-bilancino-datev td:nth-child(6) {
  width: 14%;
}
.codcontotable-add-bilancino-datev th:nth-child(7),
.codcontotable-add-bilancino-datev td:nth-child(7),
.codcontotable-add-bilancino-datev th:nth-child(8),
.codcontotable-add-bilancino-datev td:nth-child(8) {
  width: 9.2%;
}
.codcontotable-add-bilancino thead {
  position: sticky;
  top: 0; /* Posiziona la riga in cima durante lo scorrimento */
  z-index: 10;
  border-spacing: 0;
}
.codcontotable-add-bilancino th,
.codcontotable-add-bilancino td {
  padding: 7px 8px;
  margin: 0;
  border: 1px solid #ddd;
  white-space: normal !important;
  line-height: 1.18;
}
.softwaredetected {
  margin-bottom: 1rem;
  margin-top: -0.6rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: rgb(244, 244, 244);
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  font-size: 0.85rem !important;
}
.finebtn {
  width: 5rem !important;
  margin-top: 2rem;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  background-color: #84929e;
  color: white;
  font-size: 1.05rem;
  transition: background-color 0.3s ease;
}
.finebtn:hover {
  background-color: #687682;
}
.annullaAddRow {
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: center;
  padding: 0.75rem;
  margin: 0.5rem;
  width: 6rem !important;
  background-color: grey !important;
}
.PDC_header {
  --empty-accent: #5f8476;
  --empty-accent-hover: #4c6058;
  --empty-soft: #e7f1ec;
  width: min(100%, 60rem);
  margin: 2rem auto 0;
  padding: 1.25rem 1.45rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  text-align: left;
  background: #ffffff;
  border: 1px solid #d9e2de;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(76, 96, 88, 0.07);
}
.PDCcontainer {
  flex: 1; /* Occupa lo spazio disponibile, spingendo il footer verso il basso */
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
}
.table-empty-message {
  width: 100%;
  min-width: 38rem;
  min-height: 5.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 0 5rem;
  border: 1px solid #cfcfcf;
  border-top: none;
  background: #fbfbfb;
  color: #3f4f5f;
  font-size: 1.15rem;
  font-style: italic;
  text-align: center;
}

#excelTable.focused-software-table + .table-empty-message {
  width: min(60rem, 100%);
  min-width: 0;
}

#excelTable.focused-software-table.focused-software-table--double
  + .table-empty-message {
  width: min(70rem, 100%);
}

.table-empty-message p {
  margin: 0;
}

.library-selection-empty-state {
  width: min(100%, 42rem);
  min-height: 7rem;
  margin: 1.2rem 0 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border: 1px solid #dbe4e8;
  border-radius: 8px;
  background: #fbfcfd;
  color: #536675;
  text-align: center;
}

.library-selection-empty-state i {
  color: #7a8c98;
  font-size: 1.25rem;
}

.library-selection-empty-state p {
  margin: 0;
  font-size: 1rem;
  font-style: italic;
}
.menu-invia-piano {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* Allinea il contenuto al centro */
  justify-content: flex-start;
  gap: 1.5rem; /* Spaziatura tra gli elementi */
  padding: 2.5rem 1.2rem 2rem 1.2rem;
  width: 25rem;
  margin: 0rem auto;
  margin-bottom: 2rem;
  background-color: rgb(243 243 243 / 99%);
  border: 2px solid rgba(223, 223, 223, 0.82);
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(107, 107, 107, 0.1);
  margin-top: 0.75rem;
}
.file-input-add-piano {
  padding: 0.55rem 0 0.55rem 0.55rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  border: 1px solid #cccccc;
  border-radius: 5px;
  background-color: #fff;
}
.anteprimaexcel.piano {
  position: absolute;
  top: -28px;
  right: 23px;
}
.label-container {
  position: relative;
  display: flex;
  align-items: center; /* Allinea label e info-piano sulla stessa linea */
  gap: 8px; /* Distanza tra il testo e l'icona */
}
.info-piano {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 14px;
  height: 14px;
  font-size: 11px;
  color: #555;
  border: 1px solid #555;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  top: -18px; /* Sposta leggermente verso l'alto */
  right: 2px;
}

.tooltip-piano {
  visibility: hidden;
  background-color: #ffffff;
  border: 1px solid grey;
  color: #393939;
  justify-content: center;
  text-align: left;
  padding: 8px;
  border-radius: 5px;
  position: absolute;
  right: -13.2rem;
  top: 0rem;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  font-size: 12px;
  white-space: normal;
  max-width: 7.5rem;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
}

.info-piano:hover .tooltip-piano {
  visibility: visible;
  opacity: 1;
}
.btn-invia {
  padding: 0.75rem;
  background-color: #007bff; /* Azzurro per il pulsante Converti */
  color: #fff;
  border: none;
  border-radius: 5px;
  font-size: 1.1rem;
  cursor: pointer;
  text-align: center;
}
.btn-invia:disabled {
  opacity: 0.6;
  cursor: default;
}
.linkstrumentiPDC {
  text-decoration: none;
  color: rgb(31, 116, 37);
  font-weight: bold;
  cursor: pointer;
  font-size: 1.1rem;
}
.linkstrumentiPDC:hover {
  color: #316850;
}
.dot-anim::after {
  content: "";
  display: inline-block;
  width: 1em;
  text-align: left;
  animation: dots 1.5s steps(3, end) infinite;
}

@keyframes dots {
  0% {
    content: "";
  }
  33% {
    content: ".";
  }
  66% {
    content: "..";
  }
  100% {
    content: "...";
  }
}
.waiting-message {
  position: absolute;
  width: 19.5rem;
  top: 20rem !important;
  background-color: rgba(243, 243, 243, 0.954);
  color: #1b1b1b;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 14px;
  pointer-events: none;
  z-index: 9999;
  transition: top 0.05s linear, left 0.05s linear;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.5s ease-in-out;
}
.provisional-row {
  background-color: #cee9cb;
}
.row-index {
  width: 0.5rem !important;
  background-color: #ffffff;
  font-family: monospace;
  color: #777;
  user-select: none;
  padding: 5px !important;
  text-align: center !important;
}
.table-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-bottom: 3rem;
  width: 86.3rem;
}

.div-pdc-madre {
  position: relative;
  display: flex;
  justify-content: flex-start;
  width: 86.3rem;
  margin: -1.5rem 0 1rem;
}
.row-number-cell {
  text-align: center !important;
  font-family: monospace;
  color: #666;
  padding-right: 8px;
  background-color: #f5f5f5;
  width: 16px;
  min-width: 16px;
  max-width: 16px;
  user-select: none;
}
.headerIndici {
  font-weight: normal !important;
  text-align: center !important;
}
.dashboarddiv {
  position: relative;
  width: 86.3rem;
  min-height: auto;
  display: flex;
  align-items: flex-start; /* allinea in alto */
  margin-bottom: 1rem;
}
.dashboard-feedback {
  position: absolute;
  top: -1.7rem;
  right: 1.25rem;
  pointer-events: none;
}
.dashboardsave {
  display: flex;
  align-items: center;
  gap: 1rem; /* Spaziatura consistente tra i pulsanti */
  padding: 0.68rem 1rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); /* Ombra leggera per un look moderno */
  transition: box-shadow 0.3s ease;
  margin-bottom: 1.2rem;
  margin-left: 1rem;
}
.dashboardsave:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Effetto hover per profondità */
}
.buttons > button {
  display: flex;
}
.buttons:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Effetto hover per profondità */
}
.buttons > button,
.buttons > a {
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease,
    box-shadow 0.3s ease;
  border: none;
  color: #333;
  background-color: transparent; /* Pulsanti trasparenti di default per un look minimal */
}
.buttons > button {
  display: flex;
}
.ultimamodifica {
  position: absolute;
  top: 0.55rem;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;
  margin-left: auto;
  text-align: right;
  min-width: 14.5rem;
  padding-top: 0;
  pointer-events: none;
}
.ultimamodificatext {
  width: auto;
  font-size: 0.9rem;
  font-style: italic;
  white-space: nowrap;
}

.causale-library-cluster {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  min-width: 0;
}

.causale-library-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  height: 2.1rem;
  padding: 0 0.58rem 0 0.62rem;
  border: 1px solid #d6dfeb;
  border-radius: 8px;
  background: #ffffff;
  color: #102a3e;
  font-size: 0.84rem;
  font-weight: 750;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 3px 9px rgba(16, 42, 62, 0.06);
}

.causale-library-trigger:hover,
.causale-library-trigger.active {
  border-color: #9eb7d4;
  background: #f8fbff;
}

.causale-library-trigger-label {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
  padding-right: 0.55rem;
}

.causale-library-trigger-label-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.causale-library-trigger-value {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 3.2rem;
  padding-left: 0.5rem;
  border-left: 1px solid #dbe5ef;
  color: #17324d;
  font-size: 0.86rem;
  font-weight: 800;
  line-height: 1;
  text-align: left;
}

.causale-library-trigger > i {
  margin-left: 0.36rem;
  color: #52677c;
  font-size: 0.72rem;
}

.causale-library-trigger-label .info-icon {
  z-index: auto;
}

.causale-library-trigger-label .tooltip {
  z-index: 35;
}

.causale-library-panel {
  position: absolute;
  top: calc(100% + 0.42rem);
  left: 0;
  z-index: 42;
  width: 20rem;
  box-sizing: border-box;
  padding: 0.84rem 0.88rem;
  border: 1px solid #d8e2ec;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 14px 30px rgba(16, 42, 62, 0.16);
  text-align: left;
}

.causale-library-panel-label {
  display: block;
  margin-bottom: 0.56rem;
  color: #52677c;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: left;
}

.causale-library-panel-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.55rem;
}

.causale-library-input {
  width: 5.75rem;
  height: 2rem;
  border: 1px solid #bfcbd5;
  border-radius: 7px;
  padding: 0 0.45rem;
  font-weight: 800;
  text-align: left;
  text-transform: uppercase;
}

.causale-library-button {
  border: 1px solid #bfd2e4;
  border-radius: 7px;
  background: #2367ad;
  color: #fff;
  font-weight: 800;
  padding: 0.44rem 0.7rem;
  cursor: pointer;
}

.causale-library-button--ghost {
  background: #fff;
  color: #2367ad;
}

.causale-library-button:disabled {
  opacity: 0.65;
  cursor: wait;
}

.causale-library-panel-hint {
  display: block;
  margin-top: 0.58rem;
  color: #66788a;
  font-size: 0.75rem;
  text-align: left;
}

.causale-library-error {
  display: block;
  margin-top: 0.35rem;
  color: #b42318;
  font-size: 0.78rem;
  font-weight: 700;
}
.table-meta-row {
  position: relative;
  width: 83rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.2rem;
  margin: 0.1rem 0 1.05rem;
}

.inline-archive-wrapper {
  width: 100%;
}

.library-control-row {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
}

.library-active-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.62rem;
  min-width: 0;
  padding: 0.72rem 0.82rem;
  border: 1px solid #d8e4dd;
  border-radius: 12px;
  background: linear-gradient(180deg, #f5faf7 0%, #eaf2ed 100%);
  box-shadow: 0 8px 20px rgba(76, 96, 88, 0.08);
}

.library-active-summary {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 0.72rem;
  row-gap: 0.08rem;
  align-items: baseline;
  min-width: 0;
}

.library-active-eyebrow {
  grid-row: 1 / span 2;
  align-self: center;
  padding: 0.28rem 0.46rem;
  border: 1px solid rgba(111, 133, 124, 0.2);
  border-radius: 8px;
  background: #eef5f1;
  color: #4c6058;
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.library-active-summary strong {
  min-width: 0;
  color: #102a3e;
  font-size: 1.05rem;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-active-details {
  min-width: 0;
  color: #5d6f78;
  font-size: 0.84rem;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-active-dot {
  padding: 0 0.3rem;
  color: #8a9aa2;
}

.library-active-controls {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  gap: 0.72rem 0.9rem;
  min-width: 0;
  width: 100%;
  padding-top: 0;
  border-top: 0;
}

.library-active-controls.has-datev-causale .search-input-wrap {
  flex-basis: 11.4rem;
  width: 11.4rem;
}

.library-active-controls.has-datev-causale .causale-library-trigger {
  width: 18.5rem;
}

.library-active-controls.has-datev-causale .causale-library-panel {
  width: 19.7rem;
}

.library-active-controls.has-datev-causale .causale-library-trigger-label {
  flex: 0 0 auto;
}

.library-active-controls.has-datev-causale .causale-library-trigger-value {
  flex: 1 1 auto;
  min-width: 3.2rem;
}

.library-file-menu {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.16rem;
  flex: 0 0 16rem;
  width: 16rem;
  min-width: 16rem;
  max-width: 16rem;
}

.library-file-trigger {
  display: inline-grid;
  position: relative;
  grid-template-columns: minmax(0, 1fr) 1.15rem;
  align-items: center;
  gap: 0.55rem;
  width: 16rem;
  min-width: 16rem;
  max-width: 16rem;
  height: 2.4rem;
  padding: 0 0.58rem 0 0.78rem;
  border: 1px solid #d7dde2;
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f1f3f5 100%);
  color: #26323d;
  box-shadow: 0 5px 14px rgba(53, 64, 76, 0.06);
  cursor: pointer;
  overflow: hidden;
  text-align: left;
}

.library-file-trigger:hover,
.library-file-trigger.active {
  border-color: #c7cfd7;
  background: linear-gradient(180deg, #ffffff 0%, #eceff2 100%);
}

.library-file-trigger.is-client-file {
  border-color: rgba(213, 138, 33, 0.42);
  background: linear-gradient(180deg, #fff8e9 0%, #fcebc4 100%);
}

.library-file-trigger.is-client-file:hover,
.library-file-trigger.is-client-file.active {
  border-color: rgba(197, 116, 18, 0.66);
  background: linear-gradient(180deg, #fff3dc 0%, #f8dfad 100%);
}

.library-file-trigger-label {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  height: 100%;
  padding: 0;
  border-right: 0;
  background: transparent;
  color: #3f4750;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger.is-client-file .library-file-trigger-label {
  color: #7a5010;
}

.library-file-trigger-label span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger-book {
  flex: 0 0 auto;
  color: #3f4750;
  font-size: 0.78rem;
}

.library-file-trigger.is-client-file .library-file-trigger-book,
.library-file-trigger.is-client-file > i {
  color: #b67518;
}

.library-file-trigger-scope {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.26rem;
  min-width: 0;
  width: 100%;
  margin-top: 0.25rem;
  padding: 0 0.72rem;
  color: #344154;
  font-size: 0.68rem;
  font-weight: 760;
  line-height: 1.05;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger-scope-prefix {
  flex: 0 0 auto;
  color: #6b7280;
  font-weight: 680;
  text-transform: none;
}

.library-file-trigger-scope span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-trigger > i {
  padding-right: 0;
  color: #3f4750;
  font-size: 0.78rem;
}

.library-file-trigger.is-client-file .library-file-trigger-scope {
  color: #344154;
}

.library-file-trigger.is-client-file > i {
  color: #b67518;
}

.library-file-dropdown {
  position: absolute;
  top: calc(100% + 0.42rem);
  left: 0;
  z-index: 45;
  display: flex;
  flex-direction: column;
  min-width: 26rem;
  max-width: 36rem;
  max-height: 25.5rem;
  padding: 0.5rem;
  border: 1px solid #d7e2dc;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 16px 34px rgba(16, 42, 62, 0.18);
  overflow-y: auto;
}

.library-file-section-title {
  padding: 0.34rem 0.5rem 0.2rem;
  color: #6d7f87;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  text-align: center;
}

.library-file-option {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.8rem;
  width: 100%;
  padding: 0.62rem 0.7rem;
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  color: #102a3e;
  text-align: left;
  cursor: pointer;
}

.library-file-option:hover {
  background: #f4f8f6;
  border-color: #dce7e1;
}

.library-file-option.active {
  background: #eaf5f0;
  border-color: #98bbae;
}

.library-file-option.is-empty,
.library-file-client-action.is-empty {
  color: #52636b;
  background: #fafcfb;
}

.library-file-option.is-missing,
.library-file-client-action.is-missing {
  color: #748189;
  background: #fbfbfb;
}

.library-file-option-body {
  display: flex;
  align-items: flex-start;
  gap: 0.54rem;
  min-width: 0;
}

.library-file-option-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.library-file-option strong,
.library-file-option small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.library-file-option strong {
  font-size: 0.92rem;
}

.library-file-option small {
  color: #637680;
  font-size: 0.76rem;
  font-weight: 600;
}

.library-file-status {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-left: 0.38rem;
  padding: 0.08rem 0.36rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-style: normal;
  font-weight: 800;
  line-height: 1.1;
  vertical-align: middle;
}

.library-file-status--empty {
  background: #eef1f3;
  color: #60717a;
}

.library-file-status--missing {
  background: #fff4d7;
  color: #8a6200;
}

.library-file-status--compact {
  position: absolute;
  top: -0.34rem;
  right: -0.28rem;
  margin-left: 0;
  padding: 0.06rem 0.28rem;
  border: 1px solid #fff;
  font-size: 0.58rem;
  box-shadow: 0 1px 4px rgba(16, 42, 62, 0.12);
  pointer-events: none;
}

.library-file-option-file-icon,
.library-file-option-check {
  flex: 0 0 auto;
  color: #216951;
  font-size: 0.82rem;
}

.library-file-option-file-icon {
  width: 1rem;
  margin-top: 0.14rem;
  text-align: center;
}

.library-file-option-check {
  margin-top: 0.15rem;
}

.library-file-client-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.55rem;
  padding: 0.78rem 0.82rem;
  border: 1px solid #e2e8e5;
  border-radius: 10px;
  background: #fbfdfc;
}

.library-file-client-group + .library-file-client-group {
  margin-top: 0.42rem;
}

.library-file-client-heading {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.42rem;
  width: 100%;
  min-width: 0;
  color: #17324d;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1.2;
  text-align: left;
}

.library-file-client-heading i {
  flex: 0 0 auto;
  color: #f0a51c;
  font-size: 0.82rem;
}

.library-file-client-heading span {
  display: block;
  min-width: 0;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  overflow-wrap: anywhere;
  text-align: left;
}

.library-file-client-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.38rem;
}

.library-file-client-action {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.38rem;
  flex: 1 1 0;
  min-width: 10.6rem;
  min-height: 2rem;
  box-sizing: border-box;
  padding: 0.38rem 0.5rem;
  border: 1px solid #d7e2dc;
  border-radius: 8px;
  background: #ffffff;
  color: #244156;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
}

.library-file-client-action:hover {
  border-color: #e3b767;
  background: #fff3dc;
  color: #7a5010;
}

.library-file-client-action.active {
  border-color: #d58a21;
  background: #fbeccb;
  color: #6b4309;
}

.library-file-client-action:disabled {
  opacity: 0.68;
  cursor: not-allowed;
}

.library-file-client-action:disabled:hover {
  border-color: #d7e2dc;
  background: #fbfbfb;
  color: #748189;
}

.library-file-client-action i {
  color: inherit;
  font-size: 0.78rem;
}

.library-file-client-action span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.software-selector {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex-wrap: nowrap;
  justify-content: flex-start;
  margin: 0;
}

.library-view-path {
  display: inline-flex;
  align-items: stretch;
  gap: 0;
  min-width: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  filter: drop-shadow(0 6px 14px rgba(76, 96, 88, 0.06));
}

.library-view-path-separator {
  display: none;
}

.software-context-group {
  display: inline-flex;
  align-items: stretch;
  flex: 0 0 auto;
  min-width: 0;
  filter: drop-shadow(0 3px 8px rgba(76, 96, 88, 0.08));
}

.software-context-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.52rem 0.66rem 0.52rem 0.76rem;
  border: 1px solid rgba(111, 133, 124, 0.28);
  border-right: none;
  border-radius: 10px 0 0 10px;
  background: linear-gradient(180deg, #f7fafc 0%, #edf2f7 100%);
  color: #43566a;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.software-context-group select {
  min-width: 9rem;
  width: 9rem;
  min-height: 2.45rem;
  padding: 0.52rem 2rem 0.52rem 0.72rem;
  border: 1px solid #d6dfeb;
  border-radius: 10px;
  color: #17324d;
  background: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%2364707d' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat, no-repeat;
  background-position: right 0.85rem center, center;
  background-size: 0.72rem 0.42rem, 100% 100%;
  font-size: 0.86rem;
  box-shadow: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.software-context-group select:focus {
  outline: none;
  border-color: #7da9d8;
  box-shadow: 0 0 0 3px rgba(125, 169, 216, 0.18);
  position: relative;
  z-index: 1;
}

.pdc-view-selector {
  display: inline-flex;
  align-items: stretch;
  min-width: 0;
  filter: none;
}

.pdc-view-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.64rem 0.5rem 0.74rem;
  border: 1px solid rgba(111, 133, 124, 0.2);
  border-right: none;
  border-radius: 9px 0 0 9px;
  background: #eef4f8;
  color: #26445e;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  white-space: nowrap;
}

.pdc-view-selector select {
  min-width: 12.5rem;
  max-width: 16rem;
  padding: 0.5rem 2rem 0.5rem 0.72rem;
  border: 1px solid #d8e1eb;
  border-radius: 10px;
  color: #17324d;
  background: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%2364707d' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.85rem center;
  background-size: 0.72rem 0.42rem;
  font-size: 0.88rem;
  overflow: hidden;
  text-overflow: ellipsis;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.pdc-view-selector--owner select {
  min-width: 9rem;
  max-width: 12rem;
  border-left-color: rgba(111, 133, 124, 0.24);
  border-radius: 0 10px 10px 0;
  box-shadow: none;
}

.pdc-file-view-selector select {
  min-width: 11.5rem;
  max-width: 13rem;
  padding: 0.58rem 2rem 0.58rem 0.92rem;
  border-color: #d7dde2;
  border-right: none;
  border-radius: 10px 0 0 10px;
  background-color: #f7f8f9;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%234c6058' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"),
    linear-gradient(180deg, #ffffff 0%, #f1f3f5 100%);
  color: #3f4750;
  font-size: 0.76rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;
}

.pdc-file-view-selector select:hover {
  border-color: #c7cfd7;
  background-color: #f1f3f5;
}

.pdc-view-selector select:focus {
  outline: none;
  border-color: #7da9d8;
  box-shadow: 0 0 0 3px rgba(125, 169, 216, 0.18);
  position: relative;
  z-index: 1;
}

.search-input-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 1 15rem;
  width: 15rem;
}

.search-icon {
  position: absolute;
  left: 0.8rem;
  color: #8f9aaa;
  font-size: 0.95rem;
  pointer-events: none;
}

.search-input-pdc {
  width: 100%;
  max-width: 100%;
  padding: 0.6rem 0.85rem 0.6rem 2.2rem;
  border: 1px solid #d6dfeb;
  border-radius: 10px;
  font-size: 0.95rem;
  background: #ffffff;
}

.search-input-pdc:focus {
  outline: none;
  border-color: #7da9d8;
  box-shadow: 0 0 0 3px rgba(125, 169, 216, 0.18);
}
.savebutton {
  font-size: 1.2rem;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.3s ease;
}
.savebutton.unsaved {
  cursor: pointer;
  color: rgb(33, 105, 81);
  transform: scale(1.08);
}
.addRowButton.unsaved {
  background-color: #fbf9dd;
  transition: background-color 0.3s ease;
}
.addRowButton.unsaved:hover {
  background-color: #f7f3c1;
}
.cancelbutton {
  font-size: 1.2rem;
  padding-top: 0.1rem;
  color: #cbcaca;
  transition: color 0.3s ease, transform 0.2s ease;
}
.cancelbutton.unsaved {
  opacity: 1;
  cursor: pointer;
  color: rgb(180, 39, 29);
  transform: scale(1.08);
  /*color: #ffa500; o un altro colore che preferisci */
}
.savebuttondiv:not(.unsaved):not(:disabled):hover {
  background-color: inherit !important; /* Mantieni il colore di sfondo */
  cursor: default; /* Cursore non interattivo */
}
.savebuttondiv:not(.unsaved) span {
  color: #cbcaca;
}
.nochanges-message {
  width: 15rem;
  text-align: right;
  font-size: 0.96rem;
  color: gray;
  font-style: italic;
  transition: opacity 0.3s;
}
.archive-menu {
  position: relative;
  display: flex;
}
.archive-menu-trigger {
  position: relative;
  border: 1px solid #d8d8d8;
  outline: none;
  font: inherit;
  cursor: pointer;
  color: inherit;
  white-space: nowrap;
  background-color: #f3f3f3 !important;
  border-radius: 10px !important;
  padding: 0.46rem 0.78rem !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
}
.archive-menu-trigger:hover {
  background-color: #ebebeb !important;
}
.archive-chevron {
  font-size: 0.8rem;
  color: #7d7d7d;
  margin-left: -0.05rem;
}
.archive-menu-dropdown {
  position: absolute;
  top: calc(100% + 0.35rem);
  left: 0;
  display: none;
  min-width: 17rem;
  padding: 0.35rem;
  background: #fff;
  border: 1px solid #dde3ea;
  border-radius: 12px;
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
  z-index: 20;
}
.archive-menu-dropdown::before {
  content: "";
  position: absolute;
  top: -0.5rem;
  left: 0;
  width: 100%;
  height: 0.5rem;
}
.archive-menu--open .archive-menu-dropdown {
  display: block;
}
.archive-menu.disabled .archive-menu-dropdown {
  display: none;
}
.archive-menu-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 0.85rem;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #333;
  font-size: 0.94rem;
  cursor: pointer;
  text-align: left;
}
.archive-menu-item:hover {
  background-color: #f3f5f7;
}
td.modified-cell {
  background-color: #cee9cb !important;
}

td.error-cell {
  background-color: #f7cdcd !important;
}
.row-deleting td {
  background-color: #ffdddd !important;
  color: #000 !important;
}
.row-deleting-cell {
  background-color: #ffcccc !important;
  border: 2px solid red !important;
  color: black !important;
}
.row-deletingmadre {
  background-color: #ffcccc;
  transition: opacity 0.7s;
  opacity: 0;
}

.highlight-rowmadre {
  background-color: #f0f0f0;
}
.error-message-leggi-bilancino {
  position: absolute;
  top: 21rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  text-align: center;
  color: #da3838e4;
  font-weight: bold;
  padding: 0.5rem 1rem; /* padding per dare un po’ di spazio */
  background: #fff0; /* opzionale, per evidenziare */
  border-radius: 4px; /* opzionale */
  box-sizing: border-box;
  max-width: 90vw;
}
.error-message-leggi-piano {
  position: absolute;
  top: 16rem;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  text-align: center;
  color: #da3838e4;
  font-weight: bold;
  padding: 0.5rem 1rem; /* padding per dare un po’ di spazio */
  background: #fff0; /* opzionale, per evidenziare */
  border-radius: 4px; /* opzionale */
  box-sizing: border-box;
  max-width: 90vw;
}
.skeleton-loader {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.skeleton {
  background-color: #e0e0e0;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
}

.skeleton::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 1.5s infinite;
}

.skeleton-title {
  width: 70%;
  height: 24px;
}

.skeleton-text {
  width: 100%;
  height: 16px;
}

.skeleton-button {
  width: 30%;
  height: 36px;
  border-radius: 8px;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.btn-condividi {
  background-color: #7ab6f5;
  color: white;
  border: none;
  padding: 9px 18px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s ease;
}

.btn-condividi:hover {
  background-color: #0056b3;
}

.badge {
  background: red;
  color: white;
  font-size: 0.75rem;
  padding: 2px 6px;
  border-radius: 9999px;
  position: absolute;
  top: -5px;
  right: -5px;
  font-weight: bold;
}
.italic-text {
  font-style: italic;
  font-size: 0.75rem;
  color: rgb(156, 156, 156);
}
.italic-none {
  font-style: italic;
  font-size: 0.95rem;
  color: rgb(156, 156, 156);
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Sfondo oscurato */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background-color: rgb(255, 255, 255);
  padding: 40px 20px 20px 30px;
  border-radius: 5px;
  text-align: center;
  min-width: 30rem;
}

.delete-archive-options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: fit-content;
  margin: 1.05rem auto 1.25rem;
}

.delete-archive-checkbox {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.42rem 0;
  color: #6b7280;
  font-size: 0.88rem;
  font-weight: 400;
}

.delete-archive-checkbox:last-child {
  margin-bottom: 0;
}

.delete-archive-checkbox input {
  width: 12px;
  height: 12px;
  accent-color: #6b7280;
  cursor: pointer;
}

.deletemessage {
  white-space: pre-line;
}

.modal-content button {
  margin: 10px;
  padding: 8px 16px;
  cursor: pointer;
}
.btn-modal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  font-weight: 700;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.2s ease;
  min-width: 100px;
}

/* Rosso Elimina */
.btn-danger {
  background-color: #dc3545;
  color: white;
}

.btn-danger:hover {
  background-color: #c82333;
}

/* Grigio “Annulla” */
.btn-primary {
  background-color: #1474bd;
  border-color: #1474bd;
  color: white;
}

.btn-primary:hover {
  background-color: #115f9b;
  border-color: #0f568d;
}

.btn-secondary {
  background-color: #eef1f4;
  border-color: #d5dce4;
  color: #374151;
}

.btn-secondary:hover {
  background-color: #e3e8ed;
  border-color: #c4ced8;
}
/* .has-hidden-description {
  border: 2px solid #d4d4d4 !important;
} */

.custom-description-action {
  position: absolute;
  top: 7px;
  right: 2px;
  z-index: 40;
  display: inline-flex;
  align-items: flex-start;
}

/* Stile per l'icona */
.info-icon-hidden {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.62rem;
  height: 1.62rem;
  border-radius: 5px;
  cursor: default;
  font-size: 0.88rem;
  color: #8b8b8b;
  border: 1px solid #f9f9f900;
  background: rgba(255, 255, 255, 0.72);
}

.info-icon-hidden:hover {
  color: #5f5f5f;
  background-color: #ffffff;
  border: 1px solid rgb(242, 242, 242);
}
/* Stile del tooltip */
.description-original-tooltip {
  position: absolute;
  top: -0.15rem;
  left: calc(100% + 0.42rem);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.32rem;
  min-width: 17rem;
  max-width: 25rem;
  font-weight: normal;
  background-color: #ffffff;
  border: 1px solid #d8e3ed;
  color: #393939;
  border-radius: 8px;
  text-align: left;
  padding: 0.64rem 0.74rem 0.58rem;
  transition: opacity 0.3s ease-in-out;
  font-size: 0.88rem;
  white-space: normal;
  box-shadow: 0 10px 24px rgba(25, 42, 62, 0.14);
}

.description-original-tooltip::before {
  content: "";
  position: absolute;
  top: 0;
  left: -0.55rem;
  width: 0.55rem;
  height: 100%;
}

.description-original-tooltip-label {
  color: #6a7885;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}
#excelTable td {
  position: relative;
  text-align: center;
}
#excelTable th {
  text-align: center;
}
.desc-originale {
  color: #142f45;
  font-weight: 700;
  font-size: 0.88rem;
  line-height: 1.25;
}

.restore-original-description-button {
  display: inline-flex;
  align-self: flex-end;
  align-items: center;
  gap: 0.28rem;
  margin-top: 0.24rem;
  padding: 0.16rem 0;
  border: 0;
  background: transparent;
  color: #66788a;
  font-size: 0.68rem;
  font-weight: 700;
  cursor: pointer;
}

.restore-original-description-button:hover {
  color: #1f5f92;
  text-decoration: underline;
}

.upload-scope-panel {
  margin: 0 0 1.25rem;
  padding: 0.85rem 0.95rem;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fbfdff;
  text-align: left;
}

.upload-scope-title {
  display: block;
  margin-bottom: 0.55rem;
  color: #374151;
  font-size: 0.95rem;
  font-weight: 700;
}

.upload-scope-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  margin-bottom: 0.8rem;
}

.upload-scope-option {
  display: inline-flex;
  align-items: center;
  gap: 0.38rem;
  padding: 0.42rem 0.62rem;
  border: 1px solid #d8e1eb;
  border-radius: 8px;
  background: #ffffff;
  color: #24364a;
  font-size: 0.86rem;
  font-weight: 700;
  cursor: pointer;
}

.upload-scope-option input {
  width: 12px;
  height: 12px;
  accent-color: #2563eb;
}

.upload-client-select,
.upload-client-input {
  width: 100%;
  box-sizing: border-box;
  padding: 0.62rem 0.72rem;
  border: 1px solid #cfd9e5;
  border-radius: 8px;
  background: #ffffff;
  color: #1f3448;
}

.upload-new-client-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.7rem;
}
.btn-madre-pdc {
  display: flex;
  display: flex; /* Make button a flex container */
  align-items: center; /* Vertically center icon and text */
  gap: 0.5rem; /* Add gap between icon and text */
  padding: 0.5rem 0.7rem;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.3s ease, background-color 0.3s ease;
}
.fa-book-open {
  color: #666;
}
.modal-madre {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9900;
}

.modal-content-madre {
  position: relative;
  background-color: white;
  padding: 20px 30px;
  border-radius: 5px;
  max-width: 80%;
  min-width: 48rem;
  max-height: 80%;
  display: flex;
  flex-direction: column; /* Dispone gli elementi in colonna */
}

.table-container {
  max-height: calc(
    80vh - 120px
  ); /* Altezza massima per la tabella, lasciando spazio per titolo e footer */
  overflow-y: auto; /* Abilita lo scrolling verticale solo per la tabella */
}

#madrePDCTable {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

#madrePDCTable th:nth-child(1),
#madrePDCTable td:nth-child(1) {
  width: 1.6rem;
}

#madrePDCTable th:nth-child(2),
#madrePDCTable td:nth-child(2) {
  width: 8.5rem;
  text-align: center;
}

#madrePDCTable th:nth-child(3),
#madrePDCTable td:nth-child(3),
.hide-software-column .madre-descrizione {
  width: 36rem;
  text-align: left;
}

#madrePDCTable th:nth-child(4),
#madrePDCTable td:nth-child(4) {
  width: 11rem;
  text-align: center;
}

#madrePDCTable th,
#madrePDCTable td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

#madrePDCTable th {
  background-color: #f2f2f2;
}

.modal-footer {
  padding-top: 10px; /* Spazio sopra il footer */
  text-align: center; /* Allinea il pulsante a destra */
  border-top: 1px solid #ddd; /* Separatore visivo */
}

.btn-modal-madre {
  margin: 10px 5px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-secondary-madre {
  background-color: #6c757d;
  color: white;
}

.btn-secondary-madre:hover {
  background-color: #5a6268;
}

.chiudiPDCmadre {
  font-size: 1.5rem;
  position: absolute;
  top: 12px;
  right: 12px;
}

.chiudiPDCmadre:hover {
  color: #717171;
}

/* Assicura che lo scrollbar sia visivamente separato */
.table-container::-webkit-scrollbar {
  width: 8px; /* Larghezza dello scrollbar */
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1; /* Sfondo dello scrollbar */
}

.table-container::-webkit-scrollbar-thumb {
  background: #888; /* Colore del cursore dello scrollbar */
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* Colore al passaggio del mouse */
}
.tooltip {
  width: 17.4rem;
  overflow-wrap: break-word;
  white-space: normal;
  text-align: left;
}
.checkcodicicontoIcon {
  color: rgb(96, 186, 102);
}
/* Quando si nasconde la colonna software (la seconda) */
.hide-software-column :is(th, td):nth-child(2) {
  display: none !important;
}

/* Sposta a sinistra la colonna successiva (descrizione) */
.hide-software-column :is(th, td):nth-child(3) {
  padding-left: 4px; /* regola tu questo valore */
}

/* Se vuoi essere molto esplicito */
.hide-software-column .madre-descrizione {
  padding-left: 4px !important;
}
.btnPDCvisible {
  top: 1.8rem;
  right: 190px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 170px;
  height: 30px;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid rgba(72, 84, 116, 0.24);
  border-radius: 8px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.74rem;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}
.btnPDCvisible .toggle-icon {
  margin-left: auto;
}
.pdc-hidden-legacy-label {
  display: none;
}
.pdc-code-view-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pdc-code-view-menu {
  position: absolute;
  top: 4.05rem;
  right: 190px;
  z-index: 30;
  width: 170px;
  max-height: 180px;
  overflow: auto;
  padding: 6px;
  border: 1px solid rgba(72, 84, 116, 0.18);
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(8, 40, 64, 0.18);
}
.pdc-code-view-menu button,
.pdc-client-view-menu button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 32px;
  gap: 8px;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #082840;
  font-size: 0.82rem;
  font-weight: 750;
  text-align: left;
  cursor: pointer;
}
.pdc-code-view-menu button:hover,
.pdc-code-view-menu button.active,
.pdc-client-view-menu button:hover,
.pdc-client-view-menu button.active {
  background: #eef4fb;
  color: #174f86;
}
.pdc-client-view-controls {
  position: absolute;
  top: 1.8rem;
  right: 25px;
  width: 160px;
  z-index: 31;
}
.pdc-client-view-trigger {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid rgba(72, 84, 116, 0.24);
  border-radius: 8px;
  background: #ffffff;
  color: #26364d;
  font-size: 0.7rem;
  font-weight: 800;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(8, 40, 64, 0.08);
}
.pdc-client-view-trigger span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.pdc-client-view-trigger i:last-child {
  margin-left: auto;
}
.pdc-client-view-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: 220px;
  max-height: 250px;
  overflow: auto;
  padding: 6px;
  border: 1px solid rgba(72, 84, 116, 0.18);
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(8, 40, 64, 0.18);
}
.pdc-client-custom-cell {
  background: #eef9f0 !important;
}
.prospetti-cell-input--pdc-custom {
  border-color: #7ebf89 !important;
  background: #f4fff5 !important;
}
.cod_conto_table_div,
.cod_conto_table_divPCT {
  max-height: 20.75rem !important;
}
.expand-buttoncodconto {
  z-index: 10;
  margin-bottom: 1rem;
  font-size: 21px; /* Dimensione dell'icona */
  position: absolute;
  top: 7px;
  left: 8px;
  color: #aaa9a9;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
}
.expand-buttoncodconto:hover {
  transform: scale(1.1);
  color: rgb(136, 135, 135);
}

/* Workspace libreria: strumenti e contenuto appartengono allo stesso file. */
.PDCcontainer {
  box-sizing: border-box;
  width: 100%;
  max-width: none;
  margin: 0 auto;
}

.library-workspace {
  --library-accent: #216951;
  --library-accent-hover: #195640;
  --library-accent-soft: #eef7f3;
  --library-border: #d9e5df;
  box-sizing: border-box;
  width: 100%;
  margin: 0.16rem 0 3rem;
  padding: 1rem 1.15rem 1.25rem;
  border: 1px solid var(--library-border);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 12px 30px rgba(33, 80, 62, 0.08);
}

.library-workspace--empty {
  min-height: 23rem;
}

.library-workspace .dashboarddiv {
  width: 100%;
  min-width: 0;
  margin: 0;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid #e7eeea;
}

.library-workspace .dashboard,
.library-workspace .dashboarddiv > .dashboard > .buttons {
  width: 100%;
  box-sizing: border-box;
}

.library-workspace .dashboarddiv > .dashboard > .buttons {
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.38rem;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.library-workspace .dashboarddiv > .dashboard > .buttons:hover {
  box-shadow: none;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  min-height: 2.9rem;
  padding: 0.68rem 1.08rem;
  border: 1px solid #dce6e1;
  border-radius: 9px;
  background: #ffffff;
  color: #263c34;
  box-shadow: 0 2px 5px rgba(35, 63, 52, 0.035);
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  gap: 0.7rem;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button.leggibilancino {
  min-width: 13.8rem;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button:first-child {
  border-color: var(--library-accent);
  background: linear-gradient(
    180deg,
    #28795f 0%,
    var(--library-accent) 100%
  ) !important;
  color: #ffffff;
  box-shadow: 0 5px 12px rgba(33, 105, 81, 0.2);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:first-child
  i {
  color: #ffffff !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:first-child:hover:not(:disabled) {
  border-color: var(--library-accent-hover);
  background: linear-gradient(
    180deg,
    #246f58 0%,
    var(--library-accent-hover) 100%
  ) !important;
  transform: none !important;
  box-shadow: 0 5px 12px rgba(33, 105, 81, 0.24);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv) {
  border-color: #e6ebe8;
  background: #f4f6f5;
  color: #a3aca8;
  box-shadow: none;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:not(:first-child):not(.savebuttondiv)
  i,
.library-workspace .dashboarddiv > .dashboard > .buttons > .download-menu i,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi i) {
  color: #3f4750 !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:not(:first-child):not(.savebuttondiv):hover:not(:disabled),
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger:hover:not(:disabled) {
  border-color: #cfd9d4;
  background: #f6f7f7 !important;
  transform: none !important;
  box-shadow: 0 4px 10px rgba(33, 80, 62, 0.08);
}

.library-workspace .dashboarddiv > .dashboard > .buttons :deep(.btn-condividi) {
  min-height: 2.9rem;
  padding: 0.68rem 1.08rem;
  gap: 0.7rem;
  border: 1px solid #dce6e1;
  border-radius: 9px;
  background: #ffffff;
  color: #263c34;
  box-shadow: 0 2px 5px rgba(35, 63, 52, 0.035);
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  border: 1px solid #dce6e1 !important;
  background: #ffffff !important;
  box-shadow: 0 2px 5px rgba(35, 63, 52, 0.035) !important;
}

.library-workspace .library-share-control {
  display: inline-flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 0;
  min-width: 0;
}

.library-workspace .library-share-control::after {
  content: "";
  display: block;
  flex: 0 0 1px;
  width: 1px;
  height: 2rem;
  margin: 0 auto;
  background: #d7e1dc;
  transform: translateX(0.19rem);
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi:hover:not(:disabled)) {
  border-color: #cfd9d4;
  background: #f6f7f7;
  transform: none;
  box-shadow: 0 4px 10px rgba(33, 80, 62, 0.08);
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button,
.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > .download-menu
  > .download-menu-trigger {
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, color 0.18s ease;
}

.library-workspace .dashboarddiv > .dashboard > .buttons > button:first-child {
  transition: border-color 0.18s ease, box-shadow 0.18s ease, color 0.18s ease;
}

.library-workspace .savebuttondiv:disabled,
.library-workspace .savebuttondiv:not(.unsaved) {
  opacity: 1;
  border-color: #e2e6e8 !important;
  background: #f1f3f4 !important;
  color: #a9afb4 !important;
  box-shadow: none !important;
}

.library-workspace .savebuttondiv {
  box-sizing: border-box;
  flex: 0 0 7rem;
  width: 7rem;
  min-width: 7rem;
  justify-content: center;
}

@media (min-width: 1500px) {
  .library-workspace .dashboarddiv > .dashboard > .buttons {
    flex-wrap: nowrap;
  }
}

.library-workspace .savebuttondiv.unsaved {
  background-color: #fbf9dd !important;
}

.library-workspace .savebuttondiv.unsaved:hover {
  background-color: #f7f3c1 !important;
  transform: none !important;
}

.library-workspace .savebuttondiv:disabled {
  border-color: #e2e6e8 !important;
  background: #f1f3f4 !important;
  color: #a9afb4 !important;
  box-shadow: none !important;
}

.library-workspace .savebuttondiv:disabled :is(i, span) {
  color: #a9afb4 !important;
}

.library-workspace .savebuttondiv:not(.unsaved) :is(i, span) {
  color: #a9afb4 !important;
}

.library-workspace .savebuttondiv:not(.unsaved):hover {
  border-color: #e2e6e8 !important;
  background: #f4f5f6 !important;
  color: #a9afb4 !important;
  transform: none !important;
  box-shadow: none !important;
}

.library-workspace button:not(:disabled) {
  cursor: pointer;
}

.library-workspace button:disabled,
.library-workspace button:disabled * {
  cursor: not-allowed !important;
  transform: none !important;
}

.library-workspace button:disabled:hover {
  transform: none !important;
}

.library-workspace .savebuttondiv:not(.unsaved),
.library-workspace .savebuttondiv:not(.unsaved) * {
  cursor: not-allowed !important;
  transform: none !important;
}

.library-workspace :deep(.btn-condividi:disabled),
.library-workspace :deep(.btn-condividi:disabled:hover) {
  opacity: 1;
  border-color: #e4e9e6 !important;
  background: #ffffff !important;
  color: #a9b1ad !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  :deep(.btn-condividi:disabled i) {
  color: #a9b1ad !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv) {
  opacity: 1;
  border-color: #e4e9e6 !important;
  background: #ffffff !important;
  color: #a9b1ad !important;
  box-shadow: none !important;
}

.library-workspace
  .dashboarddiv
  > .dashboard
  > .buttons
  > button:disabled:not(.savebuttondiv)
  :is(i, span) {
  color: #a9b1ad !important;
}

.library-workspace .table-wrapper {
  box-sizing: border-box;
  width: 100%;
  padding: 1rem 0 0;
}

.library-workspace .table-meta-row {
  box-sizing: border-box;
  width: 100%;
  margin: 0 0 0.9rem;
}

.library-workspace #excelTable,
.library-workspace #madrePDCTable {
  width: 100%;
  max-width: none;
  margin-top: 0;
  margin-bottom: 0;
  overflow: hidden;
  border: 1px solid #d6e1e8 !important;
  border-radius: 11px;
  border-collapse: separate;
  border-spacing: 0;
  color: #243b4d;
  font-size: 0.9rem;
}

.library-workspace #excelTable.focused-software-table,
.library-workspace
  #excelTable.focused-software-table.focused-software-table--double {
  width: 100%;
}

.library-workspace #excelTable.focused-software-table + .table-empty-message,
.library-workspace
  #excelTable.focused-software-table.focused-software-table--double
  + .table-empty-message {
  width: 100%;
  min-width: 0;
}

.library-workspace :is(#excelTable, #madrePDCTable) :is(th, td) {
  padding: 0.72rem 0.78rem;
  border: 0;
  border-right: 1px solid #e4ebf0;
  border-bottom: 1px solid #e2e9ee;
  line-height: 1.28;
  vertical-align: middle;
}

.library-workspace :is(#excelTable, #madrePDCTable) th {
  background: #eef2f4;
  color: #304658;
  font-size: 0.92rem;
  font-weight: 750;
}

.library-workspace #madrePDCTable.hide-software-column th:nth-child(3),
.library-workspace #madrePDCTable.hide-software-column td:nth-child(3) {
  width: 68%;
}

.library-workspace #madrePDCTable.hide-software-column th:nth-child(4),
.library-workspace #madrePDCTable.hide-software-column td:nth-child(4) {
  width: 32%;
}

.library-workspace :is(#excelTable, #madrePDCTable) tr:last-child > td,
.library-workspace :is(#excelTable, #madrePDCTable) tr:last-child > th {
  border-bottom: 0;
}

.library-workspace :is(#excelTable, #madrePDCTable) :is(th, td):last-child {
  border-right: 0;
}

.library-workspace
  :is(#excelTable, #madrePDCTable)
  > tr:nth-child(odd):not(.highlight-row):not(.highlight-rowmadre):not(
    .provisional-row
  ):not(.row-deleting):not(.row-deletingmadre)
  > td:not(.modified-cell):not(.error-cell) {
  background: #f9f9f9;
}

.library-workspace
  :is(#excelTable, #madrePDCTable)
  > tr:is(.highlight-row, .highlight-rowmadre)
  > td {
  background: #ffeeba !important;
  transition: background-color 0.3s ease-in-out !important;
}

.library-workspace tr:is(.highlight-row, .highlight-rowmadre) .delete-button {
  background: #ffeeba !important;
  color: #000000 !important;
}

.library-workspace #excelTable > tr {
  height: 3.15rem;
  border: 0 !important;
}

.library-workspace .row-index {
  color: #798995;
  font-size: 0.78rem;
}

.library-workspace .table-empty-message {
  margin-bottom: 0;
  border-color: #d6e1e8;
  background: #f7fafc;
  color: #5e7180;
}

.library-workspace .ultimamodificatext {
  color: #64756e;
  font-size: 0.82rem;
}

.title {
  color: var(--library-title-color, #216951);
}

.title::after {
  background: #216951;
}
</style>
